// This file is generated by scripts/generators/generate-proto-domain-model-converters.ts
import * as DomainModel from 'poc-ai-biz-irdb_domain-model'
import * as ProtoModel from './_gen/_gen.models_pb'
import { Struct } from '@bufbuild/protobuf'
import { assertNever } from '../_shared/lib'
import { camelCase } from 'change-case'
import { CamelCasedPropertiesDeep } from 'type-fest'

/**
 * Recursively converts all object keys to camelCase.
 * Arrays and primitive values are preserved.
 */
export const changeKeysToCamelCaseRecursively = <T>(obj: T): CamelCasedPropertiesDeep<T> => {
  if (Array.isArray(obj)) {
    return obj.map((item) => changeKeysToCamelCaseRecursively(item)) as CamelCasedPropertiesDeep<T>
  } else if (obj !== null && typeof obj === 'object') {
    const result: any = {}
    Object.entries(obj as Record<string, any>).forEach(([key, value]) => {
      result[camelCase(key)] = changeKeysToCamelCaseRecursively(value)
    })
    return result
  }
  return obj as CamelCasedPropertiesDeep<T>
}

// From DomainModel to ProtoModel

export const convertUsecaseTableCompanyOverviewToProtoModel = (entity: DomainModel.UsecaseTableCompanyOverview): ProtoModel.UsecaseTableCompanyOverview => {
  return new ProtoModel.UsecaseTableCompanyOverview({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    companyNameJa: entity.companyNameJa !== null ? entity.companyNameJa : undefined,
    companyNameEn: entity.companyNameEn !== null ? entity.companyNameEn : undefined,
    headQuaterAddress: entity.headQuaterAddress !== null ? entity.headQuaterAddress : undefined,
    presidentRole: entity.presidentRole !== null ? entity.presidentRole : undefined,
    presidentName: entity.presidentName !== null ? entity.presidentName : undefined,
    phoneNumber: entity.phoneNumber !== null ? entity.phoneNumber : undefined,
    consolidatedEmployees: entity.consolidatedEmployees !== null ? entity.consolidatedEmployees : undefined,
    consolidatedSubsidiariesCount: entity.consolidatedSubsidiariesCount !== null ? entity.consolidatedSubsidiariesCount : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTablePlHighlightToProtoModel = (entity: DomainModel.UsecaseTablePlHighlight): ProtoModel.UsecaseTablePlHighlight => {
  return new ProtoModel.UsecaseTablePlHighlight({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    unit: entity.unit !== null ? entity.unit : undefined,
    unitText: entity.unitText !== null ? entity.unitText : undefined,
    revenueJpy: entity.revenueJpy !== null ? entity.revenueJpy : undefined,
    costOfSalesJpy: entity.costOfSalesJpy !== null ? entity.costOfSalesJpy : undefined,
    grossProfitJpy: entity.grossProfitJpy !== null ? entity.grossProfitJpy : undefined,
    sellingGeneralAdminExpensesJpy: entity.sellingGeneralAdminExpensesJpy !== null ? entity.sellingGeneralAdminExpensesJpy : undefined,
    operatingProfitJpy: entity.operatingProfitJpy !== null ? entity.operatingProfitJpy : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableBsHighlightToProtoModel = (entity: DomainModel.UsecaseTableBsHighlight): ProtoModel.UsecaseTableBsHighlight => {
  return new ProtoModel.UsecaseTableBsHighlight({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    unit: entity.unit !== null ? entity.unit : undefined,
    unitText: entity.unitText !== null ? entity.unitText : undefined,
    cashAndDepositsJpy: entity.cashAndDepositsJpy !== null ? entity.cashAndDepositsJpy : undefined,
    accountsReceivableJpy: entity.accountsReceivableJpy !== null ? entity.accountsReceivableJpy : undefined,
    inventoriesJpy: entity.inventoriesJpy !== null ? entity.inventoriesJpy : undefined,
    propertyPlantEquipmentJpy: entity.propertyPlantEquipmentJpy !== null ? entity.propertyPlantEquipmentJpy : undefined,
    totalAssetsJpy: entity.totalAssetsJpy !== null ? entity.totalAssetsJpy : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableCfHighlightToProtoModel = (entity: DomainModel.UsecaseTableCfHighlight): ProtoModel.UsecaseTableCfHighlight => {
  return new ProtoModel.UsecaseTableCfHighlight({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    unit: entity.unit !== null ? entity.unit : undefined,
    unitText: entity.unitText !== null ? entity.unitText : undefined,
    operatingCfJpy: entity.operatingCfJpy !== null ? entity.operatingCfJpy : undefined,
    investingCfJpy: entity.investingCfJpy !== null ? entity.investingCfJpy : undefined,
    financingCfJpy: entity.financingCfJpy !== null ? entity.financingCfJpy : undefined,
    cashEoyJpy: entity.cashEoyJpy !== null ? entity.cashEoyJpy : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableFundamentalsBasicToProtoModel = (
  entity: DomainModel.UsecaseTableFundamentalsBasic,
): ProtoModel.UsecaseTableFundamentalsBasic => {
  return new ProtoModel.UsecaseTableFundamentalsBasic({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    totalCapitalEtc: entity.totalCapitalEtc !== null ? entity.totalCapitalEtc : undefined,
    capitalSurplus: entity.capitalSurplus !== null ? entity.capitalSurplus : undefined,
    shareholdersEquity: entity.shareholdersEquity !== null ? entity.shareholdersEquity : undefined,
    ownersEquityOld: entity.ownersEquityOld !== null ? entity.ownersEquityOld : undefined,
    salesGrowthRate: entity.salesGrowthRate !== null ? entity.salesGrowthRate : undefined,
    cashAndCashEquivalents: entity.cashAndCashEquivalents !== null ? entity.cashAndCashEquivalents : undefined,
    interestBearingDebt: entity.interestBearingDebt !== null ? entity.interestBearingDebt : undefined,
    netInterestBearingDebt: entity.netInterestBearingDebt !== null ? entity.netInterestBearingDebt : undefined,
    netInterestBearingDebtExclSecurities: entity.netInterestBearingDebtExclSecurities !== null ? entity.netInterestBearingDebtExclSecurities : undefined,
    capexCfTangible: entity.capexCfTangible !== null ? entity.capexCfTangible : undefined,
    capexCfTangibleIntangible: entity.capexCfTangibleIntangible !== null ? entity.capexCfTangibleIntangible : undefined,
    investedCapital: entity.investedCapital !== null ? entity.investedCapital : undefined,
    businessAssets: entity.businessAssets !== null ? entity.businessAssets : undefined,
    workingCapital: entity.workingCapital !== null ? entity.workingCapital : undefined,
    ebit: entity.ebit !== null ? entity.ebit : undefined,
    ebitda: entity.ebitda !== null ? entity.ebitda : undefined,
    nopat: entity.nopat !== null ? entity.nopat : undefined,
    freeCashFlow: entity.freeCashFlow !== null ? entity.freeCashFlow : undefined,
    personnelExpensesTotal: entity.personnelExpensesTotal !== null ? entity.personnelExpensesTotal : undefined,
    personnelExpenses: entity.personnelExpenses !== null ? entity.personnelExpenses : undefined,
    laborCost: entity.laborCost !== null ? entity.laborCost : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableFundamentalsGrowthToProtoModel = (
  entity: DomainModel.UsecaseTableFundamentalsGrowth,
): ProtoModel.UsecaseTableFundamentalsGrowth => {
  return new ProtoModel.UsecaseTableFundamentalsGrowth({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    salesGrowthRate: entity.salesGrowthRate !== null ? entity.salesGrowthRate : undefined,
    operatingProfitGrowthRate: entity.operatingProfitGrowthRate !== null ? entity.operatingProfitGrowthRate : undefined,
    ordinaryProfitGrowthRate: entity.ordinaryProfitGrowthRate !== null ? entity.ordinaryProfitGrowthRate : undefined,
    netProfitGrowthRate: entity.netProfitGrowthRate !== null ? entity.netProfitGrowthRate : undefined,
    ebitdaGrowthRate: entity.ebitdaGrowthRate !== null ? entity.ebitdaGrowthRate : undefined,
    epsGrowthRate: entity.epsGrowthRate !== null ? entity.epsGrowthRate : undefined,
    dilutedEpsGrowthRate: entity.dilutedEpsGrowthRate !== null ? entity.dilutedEpsGrowthRate : undefined,
    totalAssetsGrowthRate: entity.totalAssetsGrowthRate !== null ? entity.totalAssetsGrowthRate : undefined,
    employeesGrowthRate: entity.employeesGrowthRate !== null ? entity.employeesGrowthRate : undefined,
    sgaGrowthRate: entity.sgaGrowthRate !== null ? entity.sgaGrowthRate : undefined,
    personnelExpensesGrowthRate: entity.personnelExpensesGrowthRate !== null ? entity.personnelExpensesGrowthRate : undefined,
    advertisingExpensesGrowthRate: entity.advertisingExpensesGrowthRate !== null ? entity.advertisingExpensesGrowthRate : undefined,
    rdExpensesGrowthRate: entity.rdExpensesGrowthRate !== null ? entity.rdExpensesGrowthRate : undefined,
    capexGrowthRate: entity.capexGrowthRate !== null ? entity.capexGrowthRate : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableFundamentalsProfitabilityToProtoModel = (
  entity: DomainModel.UsecaseTableFundamentalsProfitability,
): ProtoModel.UsecaseTableFundamentalsProfitability => {
  return new ProtoModel.UsecaseTableFundamentalsProfitability({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    grossProfitMargin: entity.grossProfitMargin !== null ? entity.grossProfitMargin : undefined,
    sgaRatio: entity.sgaRatio !== null ? entity.sgaRatio : undefined,
    operatingProfitMargin: entity.operatingProfitMargin !== null ? entity.operatingProfitMargin : undefined,
    ordinaryProfitMargin: entity.ordinaryProfitMargin !== null ? entity.ordinaryProfitMargin : undefined,
    pretaxProfitMargin: entity.pretaxProfitMargin !== null ? entity.pretaxProfitMargin : undefined,
    netProfitMargin: entity.netProfitMargin !== null ? entity.netProfitMargin : undefined,
    parentNetProfitMargin: entity.parentNetProfitMargin !== null ? entity.parentNetProfitMargin : undefined,
    comprehensiveIncomeMargin: entity.comprehensiveIncomeMargin !== null ? entity.comprehensiveIncomeMargin : undefined,
    ebitdaMargin: entity.ebitdaMargin !== null ? entity.ebitdaMargin : undefined,
    operatingCfMargin: entity.operatingCfMargin !== null ? entity.operatingCfMargin : undefined,
    costOfSalesRatio: entity.costOfSalesRatio !== null ? entity.costOfSalesRatio : undefined,
    personnelExpensesRatio: entity.personnelExpensesRatio !== null ? entity.personnelExpensesRatio : undefined,
    personnelExpensesSgaRatio: entity.personnelExpensesSgaRatio !== null ? entity.personnelExpensesSgaRatio : undefined,
    laborCostRatio: entity.laborCostRatio !== null ? entity.laborCostRatio : undefined,
    rdRatio: entity.rdRatio !== null ? entity.rdRatio : undefined,
    rentRatio: entity.rentRatio !== null ? entity.rentRatio : undefined,
    advertisingRatio: entity.advertisingRatio !== null ? entity.advertisingRatio : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableFundamentalsProductivityToProtoModel = (
  entity: DomainModel.UsecaseTableFundamentalsProductivity,
): ProtoModel.UsecaseTableFundamentalsProductivity => {
  return new ProtoModel.UsecaseTableFundamentalsProductivity({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    salesPerEmployee: entity.salesPerEmployee !== null ? entity.salesPerEmployee : undefined,
    operatingProfitPerEmployee: entity.operatingProfitPerEmployee !== null ? entity.operatingProfitPerEmployee : undefined,
    ordinaryProfitPerEmployee: entity.ordinaryProfitPerEmployee !== null ? entity.ordinaryProfitPerEmployee : undefined,
    netProfitPerEmployee: entity.netProfitPerEmployee !== null ? entity.netProfitPerEmployee : undefined,
    operatingCfPerEmployee: entity.operatingCfPerEmployee !== null ? entity.operatingCfPerEmployee : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableFundamentalsEfficiencyToProtoModel = (
  entity: DomainModel.UsecaseTableFundamentalsEfficiency,
): ProtoModel.UsecaseTableFundamentalsEfficiency => {
  return new ProtoModel.UsecaseTableFundamentalsEfficiency({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    roe: entity.roe !== null ? entity.roe : undefined,
    roa: entity.roa !== null ? entity.roa : undefined,
    roicInvestedCapital: entity.roicInvestedCapital !== null ? entity.roicInvestedCapital : undefined,
    roicBusinessAssets: entity.roicBusinessAssets !== null ? entity.roicBusinessAssets : undefined,
    totalAssetsOrdinaryProfitRatio: entity.totalAssetsOrdinaryProfitRatio !== null ? entity.totalAssetsOrdinaryProfitRatio : undefined,
    totalAssetsTurnover: entity.totalAssetsTurnover !== null ? entity.totalAssetsTurnover : undefined,
    receivablesTurnover: entity.receivablesTurnover !== null ? entity.receivablesTurnover : undefined,
    inventoryTurnover: entity.inventoryTurnover !== null ? entity.inventoryTurnover : undefined,
    payablesTurnover: entity.payablesTurnover !== null ? entity.payablesTurnover : undefined,
    advancePaymentsTurnover: entity.advancePaymentsTurnover !== null ? entity.advancePaymentsTurnover : undefined,
    prepaidExpensesTurnover: entity.prepaidExpensesTurnover !== null ? entity.prepaidExpensesTurnover : undefined,
    advancesReceivedTurnover: entity.advancesReceivedTurnover !== null ? entity.advancesReceivedTurnover : undefined,
    deferredRevenueTurnover: entity.deferredRevenueTurnover !== null ? entity.deferredRevenueTurnover : undefined,
    receivablesTurnoverPeriod: entity.receivablesTurnoverPeriod !== null ? entity.receivablesTurnoverPeriod : undefined,
    inventoryTurnoverPeriod: entity.inventoryTurnoverPeriod !== null ? entity.inventoryTurnoverPeriod : undefined,
    payablesTurnoverPeriod: entity.payablesTurnoverPeriod !== null ? entity.payablesTurnoverPeriod : undefined,
    advancePaymentsTurnoverPeriod: entity.advancePaymentsTurnoverPeriod !== null ? entity.advancePaymentsTurnoverPeriod : undefined,
    prepaidExpensesTurnoverPeriod: entity.prepaidExpensesTurnoverPeriod !== null ? entity.prepaidExpensesTurnoverPeriod : undefined,
    advancesReceivedTurnoverPeriod: entity.advancesReceivedTurnoverPeriod !== null ? entity.advancesReceivedTurnoverPeriod : undefined,
    deferredRevenueTurnoverPeriod: entity.deferredRevenueTurnoverPeriod !== null ? entity.deferredRevenueTurnoverPeriod : undefined,
    ccc: entity.ccc !== null ? entity.ccc : undefined,
    cccAdjusted: entity.cccAdjusted !== null ? entity.cccAdjusted : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableFundamentalsSafetyLeverageToProtoModel = (
  entity: DomainModel.UsecaseTableFundamentalsSafetyLeverage,
): ProtoModel.UsecaseTableFundamentalsSafetyLeverage => {
  return new ProtoModel.UsecaseTableFundamentalsSafetyLeverage({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    equityRatio: entity.equityRatio !== null ? entity.equityRatio : undefined,
    financialLeverage: entity.financialLeverage !== null ? entity.financialLeverage : undefined,
    deRatio: entity.deRatio !== null ? entity.deRatio : undefined,
    netDeRatio: entity.netDeRatio !== null ? entity.netDeRatio : undefined,
    debtEbitdaRatio: entity.debtEbitdaRatio !== null ? entity.debtEbitdaRatio : undefined,
    netDebtEbitdaRatio: entity.netDebtEbitdaRatio !== null ? entity.netDebtEbitdaRatio : undefined,
    debtOperatingCfRatio: entity.debtOperatingCfRatio !== null ? entity.debtOperatingCfRatio : undefined,
    netDebtOperatingCfRatio: entity.netDebtOperatingCfRatio !== null ? entity.netDebtOperatingCfRatio : undefined,
    debtFcfRatio: entity.debtFcfRatio !== null ? entity.debtFcfRatio : undefined,
    netDebtFcfRatio: entity.netDebtFcfRatio !== null ? entity.netDebtFcfRatio : undefined,
    interestCoverageRatio: entity.interestCoverageRatio !== null ? entity.interestCoverageRatio : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableFundamentalsLiquidityToProtoModel = (
  entity: DomainModel.UsecaseTableFundamentalsLiquidity,
): ProtoModel.UsecaseTableFundamentalsLiquidity => {
  return new ProtoModel.UsecaseTableFundamentalsLiquidity({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    currentRatio: entity.currentRatio !== null ? entity.currentRatio : undefined,
    quickRatio: entity.quickRatio !== null ? entity.quickRatio : undefined,
    fixedRatio: entity.fixedRatio !== null ? entity.fixedRatio : undefined,
    fixedRatioTangible: entity.fixedRatioTangible !== null ? entity.fixedRatioTangible : undefined,
    cashToAssetsRatio: entity.cashToAssetsRatio !== null ? entity.cashToAssetsRatio : undefined,
    assetAgingRatio: entity.assetAgingRatio !== null ? entity.assetAgingRatio : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableFundamentalsShareholderReturnToProtoModel = (
  entity: DomainModel.UsecaseTableFundamentalsShareholderReturn,
): ProtoModel.UsecaseTableFundamentalsShareholderReturn => {
  return new ProtoModel.UsecaseTableFundamentalsShareholderReturn({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    payoutRatio: entity.payoutRatio !== null ? entity.payoutRatio : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
    calculationDependency: entity.calculationDependency !== null ? Struct.fromJson(entity.calculationDependency as any) : undefined,
  })
}

export const convertUsecaseTableExecutiveOverviewToProtoModel = (
  entity: DomainModel.UsecaseTableExecutiveOverview,
): ProtoModel.UsecaseTableExecutiveOverview => {
  return new ProtoModel.UsecaseTableExecutiveOverview({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    totalNumberOfExecutives: entity.totalNumberOfExecutives !== null ? entity.totalNumberOfExecutives : undefined,
    numberOfMaleExecutives: entity.numberOfMaleExecutives !== null ? entity.numberOfMaleExecutives : undefined,
    ratioOfMaleExecutives: entity.ratioOfMaleExecutives !== null ? entity.ratioOfMaleExecutives : undefined,
    numberOfFemaleExecutives: entity.numberOfFemaleExecutives !== null ? entity.numberOfFemaleExecutives : undefined,
    ratioOfFemaleExecutives: entity.ratioOfFemaleExecutives !== null ? entity.ratioOfFemaleExecutives : undefined,
    numberOfExternalExecutives: entity.numberOfExternalExecutives !== null ? entity.numberOfExternalExecutives : undefined,
    ratioOfExternalExecutives: entity.ratioOfExternalExecutives !== null ? entity.ratioOfExternalExecutives : undefined,
    averageAgeOfExecutives: entity.averageAgeOfExecutives !== null ? entity.averageAgeOfExecutives : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableExecutivesToProtoModel = (entity: DomainModel.UsecaseTableExecutives): ProtoModel.UsecaseTableExecutives => {
  return new ProtoModel.UsecaseTableExecutives({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    appearanceIndex: entity.appearanceIndex !== null ? entity.appearanceIndex : undefined,
    title: entity.title !== null ? entity.title : undefined,
    name: entity.name !== null ? entity.name : undefined,
    birthDay: entity.birthDay !== null ? entity.birthDay : undefined,
    sharesOwned: entity.sharesOwned !== null ? entity.sharesOwned : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableExecutiveCompensationToProtoModel = (
  entity: DomainModel.UsecaseTableExecutiveCompensation,
): ProtoModel.UsecaseTableExecutiveCompensation => {
  return new ProtoModel.UsecaseTableExecutiveCompensation({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    appearanceIndex: entity.appearanceIndex !== null ? entity.appearanceIndex : undefined,
    unit: entity.unit !== null ? entity.unit : undefined,
    unitText: entity.unitText !== null ? entity.unitText : undefined,
    titleSegment: entity.titleSegment !== null ? entity.titleSegment : undefined,
    name: entity.name !== null ? entity.name : undefined,
    totalCompensation: entity.totalCompensation !== null ? entity.totalCompensation : undefined,
    numberOfOfficers: entity.numberOfOfficers !== null ? entity.numberOfOfficers : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableBusinessDescriptionToProtoModel = (
  entity: DomainModel.UsecaseTableBusinessDescription,
): ProtoModel.UsecaseTableBusinessDescription => {
  return new ProtoModel.UsecaseTableBusinessDescription({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    summary: entity.summary !== null ? entity.summary : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableBusinessRisksToProtoModel = (entity: DomainModel.UsecaseTableBusinessRisks): ProtoModel.UsecaseTableBusinessRisks => {
  return new ProtoModel.UsecaseTableBusinessRisks({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    appearanceIndex: entity.appearanceIndex !== null ? entity.appearanceIndex : undefined,
    category: entity.category !== null ? entity.category : undefined,
    title: entity.title !== null ? entity.title : undefined,
    contentSummary: entity.contentSummary !== null ? entity.contentSummary : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableHistoryToProtoModel = (entity: DomainModel.UsecaseTableHistory): ProtoModel.UsecaseTableHistory => {
  return new ProtoModel.UsecaseTableHistory({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    appearanceIndex: entity.appearanceIndex !== null ? entity.appearanceIndex : undefined,
    year: entity.year !== null ? entity.year : undefined,
    month: entity.month !== null ? entity.month : undefined,
    event: entity.event !== null ? entity.event : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableMajorSubsidiariesToProtoModel = (
  entity: DomainModel.UsecaseTableMajorSubsidiaries,
): ProtoModel.UsecaseTableMajorSubsidiaries => {
  return new ProtoModel.UsecaseTableMajorSubsidiaries({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    appearanceIndex: entity.appearanceIndex !== null ? entity.appearanceIndex : undefined,
    companyName: entity.companyName !== null ? entity.companyName : undefined,
    relationship: entity.relationship !== null ? entity.relationship : undefined,
    address: entity.address !== null ? entity.address : undefined,
    capitalJpy: entity.capitalJpy !== null ? entity.capitalJpy : undefined,
    businessDescription: entity.businessDescription !== null ? entity.businessDescription : undefined,
    percentageOwned: entity.percentageOwned !== null ? entity.percentageOwned : undefined,
    relationshipDetails: entity.relationshipDetails !== null ? entity.relationshipDetails : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableOfficesToProtoModel = (entity: DomainModel.UsecaseTableOffices): ProtoModel.UsecaseTableOffices => {
  return new ProtoModel.UsecaseTableOffices({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    appearanceIndex: entity.appearanceIndex !== null ? entity.appearanceIndex : undefined,
    officeName: entity.officeName !== null ? entity.officeName : undefined,
    address: entity.address !== null ? entity.address : undefined,
    businessSegmentName: entity.businessSegmentName !== null ? entity.businessSegmentName : undefined,
    facilitiesSummary: entity.facilitiesSummary !== null ? entity.facilitiesSummary : undefined,
    bookValueUnit: entity.bookValueUnit !== null ? entity.bookValueUnit : undefined,
    bookValueLandJpy: entity.bookValueLandJpy !== null ? entity.bookValueLandJpy : undefined,
    landArea: entity.landArea !== null ? entity.landArea : undefined,
    landAreaUnit: entity.landAreaUnit !== null ? entity.landAreaUnit : undefined,
    bookValueBuildingJpy: entity.bookValueBuildingJpy !== null ? entity.bookValueBuildingJpy : undefined,
    bookValueMachineryVehiclesEquipmentJpy: entity.bookValueMachineryVehiclesEquipmentJpy !== null ? entity.bookValueMachineryVehiclesEquipmentJpy : undefined,
    bookValueTotalJpy: entity.bookValueTotalJpy !== null ? entity.bookValueTotalJpy : undefined,
    numberOfEmployees: entity.numberOfEmployees !== null ? entity.numberOfEmployees : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableMajorShareholdersToProtoModel = (
  entity: DomainModel.UsecaseTableMajorShareholders,
): ProtoModel.UsecaseTableMajorShareholders => {
  return new ProtoModel.UsecaseTableMajorShareholders({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    appearanceIndex: entity.appearanceIndex !== null ? entity.appearanceIndex : undefined,
    name: entity.name !== null ? entity.name : undefined,
    address: entity.address !== null ? entity.address : undefined,
    sharesOwned: entity.sharesOwned !== null ? entity.sharesOwned : undefined,
    sharesOwnedUnit: entity.sharesOwnedUnit !== null ? entity.sharesOwnedUnit : undefined,
    percentageOfTotalShares: entity.percentageOfTotalShares !== null ? entity.percentageOfTotalShares : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableKeyManagementIndicatorsConsolidatedToProtoModel = (
  entity: DomainModel.UsecaseTableKeyManagementIndicatorsConsolidated,
): ProtoModel.UsecaseTableKeyManagementIndicatorsConsolidated => {
  return new ProtoModel.UsecaseTableKeyManagementIndicatorsConsolidated({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    fiscalYear: entity.fiscalYear !== null ? entity.fiscalYear : undefined,
    revenue: entity.revenue !== null ? entity.revenue : undefined,
    ordinaryIncomeLoss: entity.ordinaryIncomeLoss !== null ? entity.ordinaryIncomeLoss : undefined,
    netIncomeLossAttributableToOwnersOfParent:
      entity.netIncomeLossAttributableToOwnersOfParent !== null ? entity.netIncomeLossAttributableToOwnersOfParent : undefined,
    comprehensiveIncome: entity.comprehensiveIncome !== null ? entity.comprehensiveIncome : undefined,
    netAssets: entity.netAssets !== null ? entity.netAssets : undefined,
    totalAssets: entity.totalAssets !== null ? entity.totalAssets : undefined,
    netAssetsPerShare: entity.netAssetsPerShare !== null ? entity.netAssetsPerShare : undefined,
    netIncomeLossPerShare: entity.netIncomeLossPerShare !== null ? entity.netIncomeLossPerShare : undefined,
    dilutedNetIncomePerShare: entity.dilutedNetIncomePerShare !== null ? entity.dilutedNetIncomePerShare : undefined,
    equityRatio: entity.equityRatio !== null ? entity.equityRatio : undefined,
    returnOnEquity: entity.returnOnEquity !== null ? entity.returnOnEquity : undefined,
    priceEarningsRatio: entity.priceEarningsRatio !== null ? entity.priceEarningsRatio : undefined,
    cashFlowsFromOperatingActivities: entity.cashFlowsFromOperatingActivities !== null ? entity.cashFlowsFromOperatingActivities : undefined,
    cashFlowsFromInvestingActivities: entity.cashFlowsFromInvestingActivities !== null ? entity.cashFlowsFromInvestingActivities : undefined,
    cashFlowsFromFinancingActivities: entity.cashFlowsFromFinancingActivities !== null ? entity.cashFlowsFromFinancingActivities : undefined,
    cashAndCashEquivalentsEndOfPeriod: entity.cashAndCashEquivalentsEndOfPeriod !== null ? entity.cashAndCashEquivalentsEndOfPeriod : undefined,
    numberOfEmployees: entity.numberOfEmployees !== null ? entity.numberOfEmployees : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableKeyManagementIndicatorsNonConsolidatedToProtoModel = (
  entity: DomainModel.UsecaseTableKeyManagementIndicatorsNonConsolidated,
): ProtoModel.UsecaseTableKeyManagementIndicatorsNonConsolidated => {
  return new ProtoModel.UsecaseTableKeyManagementIndicatorsNonConsolidated({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    fiscalYear: entity.fiscalYear !== null ? entity.fiscalYear : undefined,
    revenue: entity.revenue !== null ? entity.revenue : undefined,
    ordinaryIncomeLoss: entity.ordinaryIncomeLoss !== null ? entity.ordinaryIncomeLoss : undefined,
    netIncomeLossAttributableToOwnersOfParent:
      entity.netIncomeLossAttributableToOwnersOfParent !== null ? entity.netIncomeLossAttributableToOwnersOfParent : undefined,
    comprehensiveIncome: entity.comprehensiveIncome !== null ? entity.comprehensiveIncome : undefined,
    netAssets: entity.netAssets !== null ? entity.netAssets : undefined,
    totalAssets: entity.totalAssets !== null ? entity.totalAssets : undefined,
    netAssetsPerShare: entity.netAssetsPerShare !== null ? entity.netAssetsPerShare : undefined,
    netIncomeLossPerShare: entity.netIncomeLossPerShare !== null ? entity.netIncomeLossPerShare : undefined,
    dilutedNetIncomePerShare: entity.dilutedNetIncomePerShare !== null ? entity.dilutedNetIncomePerShare : undefined,
    equityRatio: entity.equityRatio !== null ? entity.equityRatio : undefined,
    returnOnEquity: entity.returnOnEquity !== null ? entity.returnOnEquity : undefined,
    priceEarningsRatio: entity.priceEarningsRatio !== null ? entity.priceEarningsRatio : undefined,
    cashFlowsFromOperatingActivities: entity.cashFlowsFromOperatingActivities !== null ? entity.cashFlowsFromOperatingActivities : undefined,
    cashFlowsFromInvestingActivities: entity.cashFlowsFromInvestingActivities !== null ? entity.cashFlowsFromInvestingActivities : undefined,
    cashFlowsFromFinancingActivities: entity.cashFlowsFromFinancingActivities !== null ? entity.cashFlowsFromFinancingActivities : undefined,
    cashAndCashEquivalentsEndOfPeriod: entity.cashAndCashEquivalentsEndOfPeriod !== null ? entity.cashAndCashEquivalentsEndOfPeriod : undefined,
    numberOfEmployees: entity.numberOfEmployees !== null ? entity.numberOfEmployees : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTablePlFullToProtoModel = (entity: DomainModel.UsecaseTablePlFull): ProtoModel.UsecaseTablePlFull => {
  return new ProtoModel.UsecaseTablePlFull({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    accountingStandard: entity.accountingStandard !== null ? entity.accountingStandard : undefined,
    unit: entity.unit !== null ? entity.unit : undefined,
    unitText: entity.unitText !== null ? entity.unitText : undefined,
    highlightRevenueJpy: entity.highlightRevenueJpy !== null ? entity.highlightRevenueJpy : undefined,
    highlightCostOfSalesJpy: entity.highlightCostOfSalesJpy !== null ? entity.highlightCostOfSalesJpy : undefined,
    highlightGrossProfitJpy: entity.highlightGrossProfitJpy !== null ? entity.highlightGrossProfitJpy : undefined,
    highlightSellingGeneralAdminExpensesJpy:
      entity.highlightSellingGeneralAdminExpensesJpy !== null ? entity.highlightSellingGeneralAdminExpensesJpy : undefined,
    highlightOperatingProfitJpy: entity.highlightOperatingProfitJpy !== null ? entity.highlightOperatingProfitJpy : undefined,
    ifrsGeneralRevenue: entity.ifrsGeneralRevenue !== null ? entity.ifrsGeneralRevenue : undefined,
    ifrsGeneralGainsAndLossesFromDerecOfFaAtAc:
      entity.ifrsGeneralGainsAndLossesFromDerecOfFaAtAc !== null ? entity.ifrsGeneralGainsAndLossesFromDerecOfFaAtAc : undefined,
    ifrsGeneralFinanceCosts: entity.ifrsGeneralFinanceCosts !== null ? entity.ifrsGeneralFinanceCosts : undefined,
    ifrsGeneralShareOfPolOfAjvUsingEquityMethod:
      entity.ifrsGeneralShareOfPolOfAjvUsingEquityMethod !== null ? entity.ifrsGeneralShareOfPolOfAjvUsingEquityMethod : undefined,
    ifrsGeneralGainsAndLossesFromDiffBetweenPrevAcAndFv:
      entity.ifrsGeneralGainsAndLossesFromDiffBetweenPrevAcAndFv !== null ? entity.ifrsGeneralGainsAndLossesFromDiffBetweenPrevAcAndFv : undefined,
    ifrsGeneralTaxExpense: entity.ifrsGeneralTaxExpense !== null ? entity.ifrsGeneralTaxExpense : undefined,
    ifrsGeneralDiscontinuedOperations: entity.ifrsGeneralDiscontinuedOperations !== null ? entity.ifrsGeneralDiscontinuedOperations : undefined,
    ifrsGeneralProfitOrLoss: entity.ifrsGeneralProfitOrLoss !== null ? entity.ifrsGeneralProfitOrLoss : undefined,
    ifrsGeneralPolAttrToOwnersOfParent: entity.ifrsGeneralPolAttrToOwnersOfParent !== null ? entity.ifrsGeneralPolAttrToOwnersOfParent : undefined,
    ifrsGeneralPolAttrToNci: entity.ifrsGeneralPolAttrToNci !== null ? entity.ifrsGeneralPolAttrToNci : undefined,
    ifrsGeneralItemsNotReclassifiedSubsequentlyToPol:
      entity.ifrsGeneralItemsNotReclassifiedSubsequentlyToPol !== null ? entity.ifrsGeneralItemsNotReclassifiedSubsequentlyToPol : undefined,
    ifrsGeneralItemsReclassifiedSubsequentlyToPol:
      entity.ifrsGeneralItemsReclassifiedSubsequentlyToPol !== null ? entity.ifrsGeneralItemsReclassifiedSubsequentlyToPol : undefined,
    ifrsGeneralShareOfOciOfAjv: entity.ifrsGeneralShareOfOciOfAjv !== null ? entity.ifrsGeneralShareOfOciOfAjv : undefined,
    ifrsGeneralTotalOtherComprehensiveIncome:
      entity.ifrsGeneralTotalOtherComprehensiveIncome !== null ? entity.ifrsGeneralTotalOtherComprehensiveIncome : undefined,
    ifrsGeneralTotalComprehensiveIncomeForThePeriod:
      entity.ifrsGeneralTotalComprehensiveIncomeForThePeriod !== null ? entity.ifrsGeneralTotalComprehensiveIncomeForThePeriod : undefined,
    ifrsFiInterestIncomeCalcUsingEim: entity.ifrsFiInterestIncomeCalcUsingEim !== null ? entity.ifrsFiInterestIncomeCalcUsingEim : undefined,
    ifrsFinancialInstitutionsOtherInterestIncome:
      entity.ifrsFinancialInstitutionsOtherInterestIncome !== null ? entity.ifrsFinancialInstitutionsOtherInterestIncome : undefined,
    ifrsFinancialInstitutionsInterestExpense:
      entity.ifrsFinancialInstitutionsInterestExpense !== null ? entity.ifrsFinancialInstitutionsInterestExpense : undefined,
    ifrsFinancialInstitutionsNetInterestIncome:
      entity.ifrsFinancialInstitutionsNetInterestIncome !== null ? entity.ifrsFinancialInstitutionsNetInterestIncome : undefined,
    ifrsFinancialInstitutionsFeeAndCommissionIncome:
      entity.ifrsFinancialInstitutionsFeeAndCommissionIncome !== null ? entity.ifrsFinancialInstitutionsFeeAndCommissionIncome : undefined,
    ifrsFinancialInstitutionsFeeAndCommissionExpense:
      entity.ifrsFinancialInstitutionsFeeAndCommissionExpense !== null ? entity.ifrsFinancialInstitutionsFeeAndCommissionExpense : undefined,
    ifrsFinancialInstitutionsNetFeeAndCommissionIncome:
      entity.ifrsFinancialInstitutionsNetFeeAndCommissionIncome !== null ? entity.ifrsFinancialInstitutionsNetFeeAndCommissionIncome : undefined,
    ifrsFinancialInstitutionsNetTradingIncome:
      entity.ifrsFinancialInstitutionsNetTradingIncome !== null ? entity.ifrsFinancialInstitutionsNetTradingIncome : undefined,
    ifrsFiNetIncomeFromOtherFiAtFvtpl: entity.ifrsFiNetIncomeFromOtherFiAtFvtpl !== null ? entity.ifrsFiNetIncomeFromOtherFiAtFvtpl : undefined,
    ifrsFinancialInstitutionsCreditImpairmentLosses:
      entity.ifrsFinancialInstitutionsCreditImpairmentLosses !== null ? entity.ifrsFinancialInstitutionsCreditImpairmentLosses : undefined,
    ifrsInsuranceIndustryInsuranceRevenue: entity.ifrsInsuranceIndustryInsuranceRevenue !== null ? entity.ifrsInsuranceIndustryInsuranceRevenue : undefined,
    ifrsInsuranceIndustryInsuranceServiceExpenses:
      entity.ifrsInsuranceIndustryInsuranceServiceExpenses !== null ? entity.ifrsInsuranceIndustryInsuranceServiceExpenses : undefined,
    ifrsInsuranceIndustryInsuranceServiceResult:
      entity.ifrsInsuranceIndustryInsuranceServiceResult !== null ? entity.ifrsInsuranceIndustryInsuranceServiceResult : undefined,
    ifrsInsuranceIndustryAllocationOfReinsurancePremiums:
      entity.ifrsInsuranceIndustryAllocationOfReinsurancePremiums !== null ? entity.ifrsInsuranceIndustryAllocationOfReinsurancePremiums : undefined,
    ifrsInsuranceAmountsRecoverableFromReinsurersForClaims:
      entity.ifrsInsuranceAmountsRecoverableFromReinsurersForClaims !== null ? entity.ifrsInsuranceAmountsRecoverableFromReinsurersForClaims : undefined,
    ifrsInsuranceNetIncomeExpensesFromReinsuranceHeld:
      entity.ifrsInsuranceNetIncomeExpensesFromReinsuranceHeld !== null ? entity.ifrsInsuranceNetIncomeExpensesFromReinsuranceHeld : undefined,
    ifrsInsuranceIndustryInsuranceFinanceIncomeOrExpenses:
      entity.ifrsInsuranceIndustryInsuranceFinanceIncomeOrExpenses !== null ? entity.ifrsInsuranceIndustryInsuranceFinanceIncomeOrExpenses : undefined,
    ifrsInsuranceIndustryReinsuranceFinanceIncomeOrExpenses:
      entity.ifrsInsuranceIndustryReinsuranceFinanceIncomeOrExpenses !== null ? entity.ifrsInsuranceIndustryReinsuranceFinanceIncomeOrExpenses : undefined,
    ifrsInsuranceIndustryNetInsuranceFinanceResult:
      entity.ifrsInsuranceIndustryNetInsuranceFinanceResult !== null ? entity.ifrsInsuranceIndustryNetInsuranceFinanceResult : undefined,
    ifrsAgricultureGainsAndLossesFromFvChangesOfBioAssets:
      entity.ifrsAgricultureGainsAndLossesFromFvChangesOfBioAssets !== null ? entity.ifrsAgricultureGainsAndLossesFromFvChangesOfBioAssets : undefined,
    ifrsEfaeomrExplorationAndEvaluationExpenses:
      entity.ifrsEfaeomrExplorationAndEvaluationExpenses !== null ? entity.ifrsEfaeomrExplorationAndEvaluationExpenses : undefined,
    ifrsEfaeomrImpairmentLossesOnEaeAssets: entity.ifrsEfaeomrImpairmentLossesOnEaeAssets !== null ? entity.ifrsEfaeomrImpairmentLossesOnEaeAssets : undefined,
    ifrsRraNetMovementInRdabRelatedToPol: entity.ifrsRraNetMovementInRdabRelatedToPol !== null ? entity.ifrsRraNetMovementInRdabRelatedToPol : undefined,
    ifrsRraNetMovementInRdabRelatedToOci: entity.ifrsRraNetMovementInRdabRelatedToOci !== null ? entity.ifrsRraNetMovementInRdabRelatedToOci : undefined,
    ifrsIeNetGainOrLossOnFaAtFvtpl: entity.ifrsIeNetGainOrLossOnFaAtFvtpl !== null ? entity.ifrsIeNetGainOrLossOnFaAtFvtpl : undefined,
    ifrsIeDividendIncomeFromInvestmentsAtFvtpl:
      entity.ifrsIeDividendIncomeFromInvestmentsAtFvtpl !== null ? entity.ifrsIeDividendIncomeFromInvestmentsAtFvtpl : undefined,
    jgaapGeneralNetSales: entity.jgaapGeneralNetSales !== null ? entity.jgaapGeneralNetSales : undefined,
    jgaapGeneralCostOfSales: entity.jgaapGeneralCostOfSales !== null ? entity.jgaapGeneralCostOfSales : undefined,
    jgaapGeneralGrossProfit: entity.jgaapGeneralGrossProfit !== null ? entity.jgaapGeneralGrossProfit : undefined,
    jgaapGeneralSellingGeneralAndAdministrativeExpenses:
      entity.jgaapGeneralSellingGeneralAndAdministrativeExpenses !== null ? entity.jgaapGeneralSellingGeneralAndAdministrativeExpenses : undefined,
    jgaapGeneralOperatingProfitOrOperatingLoss:
      entity.jgaapGeneralOperatingProfitOrOperatingLoss !== null ? entity.jgaapGeneralOperatingProfitOrOperatingLoss : undefined,
    jgaapGeneralNonOperatingIncome: entity.jgaapGeneralNonOperatingIncome !== null ? entity.jgaapGeneralNonOperatingIncome : undefined,
    jgaapGeneralNonOperatingExpenses: entity.jgaapGeneralNonOperatingExpenses !== null ? entity.jgaapGeneralNonOperatingExpenses : undefined,
    jgaapGeneralOrdinaryProfitOrOrdinaryLoss:
      entity.jgaapGeneralOrdinaryProfitOrOrdinaryLoss !== null ? entity.jgaapGeneralOrdinaryProfitOrOrdinaryLoss : undefined,
    jgaapGeneralExtraordinaryIncome: entity.jgaapGeneralExtraordinaryIncome !== null ? entity.jgaapGeneralExtraordinaryIncome : undefined,
    jgaapGeneralExtraordinaryLosses: entity.jgaapGeneralExtraordinaryLosses !== null ? entity.jgaapGeneralExtraordinaryLosses : undefined,
    jgaapGeneralProfitBeforeIncomeTaxes: entity.jgaapGeneralProfitBeforeIncomeTaxes !== null ? entity.jgaapGeneralProfitBeforeIncomeTaxes : undefined,
    jgaapGeneralIncomeTaxesCurrent: entity.jgaapGeneralIncomeTaxesCurrent !== null ? entity.jgaapGeneralIncomeTaxesCurrent : undefined,
    jgaapGeneralIncomeTaxesDeferred: entity.jgaapGeneralIncomeTaxesDeferred !== null ? entity.jgaapGeneralIncomeTaxesDeferred : undefined,
    jgaapGeneralProfit: entity.jgaapGeneralProfit !== null ? entity.jgaapGeneralProfit : undefined,
    jgaapGeneralProfitAttributableToNonControllingInterests:
      entity.jgaapGeneralProfitAttributableToNonControllingInterests !== null ? entity.jgaapGeneralProfitAttributableToNonControllingInterests : undefined,
    jgaapGeneralProfitAttributableToOwnersOfParent:
      entity.jgaapGeneralProfitAttributableToOwnersOfParent !== null ? entity.jgaapGeneralProfitAttributableToOwnersOfParent : undefined,
    jgaapGeneralOtherComprehensiveIncome: entity.jgaapGeneralOtherComprehensiveIncome !== null ? entity.jgaapGeneralOtherComprehensiveIncome : undefined,
    jgaapGeneralComprehensiveIncome: entity.jgaapGeneralComprehensiveIncome !== null ? entity.jgaapGeneralComprehensiveIncome : undefined,
    jgaapGeneralDepreciationAmortization: entity.jgaapGeneralDepreciationAmortization !== null ? entity.jgaapGeneralDepreciationAmortization : undefined,
    jgaapGeneralInterestIncome: entity.jgaapGeneralInterestIncome !== null ? entity.jgaapGeneralInterestIncome : undefined,
    jgaapGeneralInterestExpenses: entity.jgaapGeneralInterestExpenses !== null ? entity.jgaapGeneralInterestExpenses : undefined,
    jgaapGeneralPersonnelExpenses: entity.jgaapGeneralPersonnelExpenses !== null ? entity.jgaapGeneralPersonnelExpenses : undefined,
    jgaapGeneralLaborCost: entity.jgaapGeneralLaborCost !== null ? entity.jgaapGeneralLaborCost : undefined,
    jgaapGeneralAdvertisingExpenses: entity.jgaapGeneralAdvertisingExpenses !== null ? entity.jgaapGeneralAdvertisingExpenses : undefined,
    jgaapGeneralResearchDevelopmentExpenses:
      entity.jgaapGeneralResearchDevelopmentExpenses !== null ? entity.jgaapGeneralResearchDevelopmentExpenses : undefined,
    jgaapGeneralRentExpenses: entity.jgaapGeneralRentExpenses !== null ? entity.jgaapGeneralRentExpenses : undefined,
    jgaapGeneralEpsBasic: entity.jgaapGeneralEpsBasic !== null ? entity.jgaapGeneralEpsBasic : undefined,
    jgaapGeneralEpsDiluted: entity.jgaapGeneralEpsDiluted !== null ? entity.jgaapGeneralEpsDiluted : undefined,
    jgaapConstructionNetSalesOfCompletedCc: entity.jgaapConstructionNetSalesOfCompletedCc !== null ? entity.jgaapConstructionNetSalesOfCompletedCc : undefined,
    jgaapConstructionCosOfCompletedCc: entity.jgaapConstructionCosOfCompletedCc !== null ? entity.jgaapConstructionCosOfCompletedCc : undefined,
    jgaapConstructionGrossProfitOnCompletedCc:
      entity.jgaapConstructionGrossProfitOnCompletedCc !== null ? entity.jgaapConstructionGrossProfitOnCompletedCc : undefined,
    jgaapBankingOrdinaryIncome: entity.jgaapBankingOrdinaryIncome !== null ? entity.jgaapBankingOrdinaryIncome : undefined,
    jgaapBankingInterestIncome: entity.jgaapBankingInterestIncome !== null ? entity.jgaapBankingInterestIncome : undefined,
    jgaapBankingInterestOnLoansAndDiscounts:
      entity.jgaapBankingInterestOnLoansAndDiscounts !== null ? entity.jgaapBankingInterestOnLoansAndDiscounts : undefined,
    jgaapBankingInterestAndDividendsOnSecurities:
      entity.jgaapBankingInterestAndDividendsOnSecurities !== null ? entity.jgaapBankingInterestAndDividendsOnSecurities : undefined,
    jgaapBankingFeesAndCommissions: entity.jgaapBankingFeesAndCommissions !== null ? entity.jgaapBankingFeesAndCommissions : undefined,
    jgaapBankingTradingIncome: entity.jgaapBankingTradingIncome !== null ? entity.jgaapBankingTradingIncome : undefined,
    jgaapBankingOtherOperatingIncome: entity.jgaapBankingOtherOperatingIncome !== null ? entity.jgaapBankingOtherOperatingIncome : undefined,
    jgaapBankingOtherOrdinaryIncome: entity.jgaapBankingOtherOrdinaryIncome !== null ? entity.jgaapBankingOtherOrdinaryIncome : undefined,
    jgaapBankingOrdinaryExpenses: entity.jgaapBankingOrdinaryExpenses !== null ? entity.jgaapBankingOrdinaryExpenses : undefined,
    jgaapBankingInterestExpenses: entity.jgaapBankingInterestExpenses !== null ? entity.jgaapBankingInterestExpenses : undefined,
    jgaapBankingInterestOnDeposits: entity.jgaapBankingInterestOnDeposits !== null ? entity.jgaapBankingInterestOnDeposits : undefined,
    jgaapBankingFeesAndCommissionsPayments: entity.jgaapBankingFeesAndCommissionsPayments !== null ? entity.jgaapBankingFeesAndCommissionsPayments : undefined,
    jgaapBankingTradingExpenses: entity.jgaapBankingTradingExpenses !== null ? entity.jgaapBankingTradingExpenses : undefined,
    jgaapBankingOtherOperatingExpenses: entity.jgaapBankingOtherOperatingExpenses !== null ? entity.jgaapBankingOtherOperatingExpenses : undefined,
    jgaapBankingGeneralAndAdministrativeExpenses:
      entity.jgaapBankingGeneralAndAdministrativeExpenses !== null ? entity.jgaapBankingGeneralAndAdministrativeExpenses : undefined,
    jgaapBankingOtherOrdinaryExpenses: entity.jgaapBankingOtherOrdinaryExpenses !== null ? entity.jgaapBankingOtherOrdinaryExpenses : undefined,
    jgaapBankingOrdinaryProfit: entity.jgaapBankingOrdinaryProfit !== null ? entity.jgaapBankingOrdinaryProfit : undefined,
    jgaapSecuritiesOperatingRevenue: entity.jgaapSecuritiesOperatingRevenue !== null ? entity.jgaapSecuritiesOperatingRevenue : undefined,
    jgaapSecuritiesCommissionsReceived: entity.jgaapSecuritiesCommissionsReceived !== null ? entity.jgaapSecuritiesCommissionsReceived : undefined,
    jgaapSecuritiesBrokerageCommissions: entity.jgaapSecuritiesBrokerageCommissions !== null ? entity.jgaapSecuritiesBrokerageCommissions : undefined,
    jgaapSecuritiesUnderwritingAndSellingCommissions:
      entity.jgaapSecuritiesUnderwritingAndSellingCommissions !== null ? entity.jgaapSecuritiesUnderwritingAndSellingCommissions : undefined,
    jgaapSecuritiesSubscriptionAndDistributionCommissions:
      entity.jgaapSecuritiesSubscriptionAndDistributionCommissions !== null ? entity.jgaapSecuritiesSubscriptionAndDistributionCommissions : undefined,
    jgaapSecuritiesNetTradingIncome: entity.jgaapSecuritiesNetTradingIncome !== null ? entity.jgaapSecuritiesNetTradingIncome : undefined,
    jgaapSecuritiesFinancialRevenue: entity.jgaapSecuritiesFinancialRevenue !== null ? entity.jgaapSecuritiesFinancialRevenue : undefined,
    jgaapSecuritiesFinancialExpenses: entity.jgaapSecuritiesFinancialExpenses !== null ? entity.jgaapSecuritiesFinancialExpenses : undefined,
    jgaapSecuritiesSellingGeneralAndAdministrativeExpenses:
      entity.jgaapSecuritiesSellingGeneralAndAdministrativeExpenses !== null ? entity.jgaapSecuritiesSellingGeneralAndAdministrativeExpenses : undefined,
    jgaapSecuritiesTransactionExpenses: entity.jgaapSecuritiesTransactionExpenses !== null ? entity.jgaapSecuritiesTransactionExpenses : undefined,
    jgaapSecuritiesOperatingProfit: entity.jgaapSecuritiesOperatingProfit !== null ? entity.jgaapSecuritiesOperatingProfit : undefined,
    jgaapInsuranceOrdinaryIncome: entity.jgaapInsuranceOrdinaryIncome !== null ? entity.jgaapInsuranceOrdinaryIncome : undefined,
    jgaapInsuranceUnderwritingIncome: entity.jgaapInsuranceUnderwritingIncome !== null ? entity.jgaapInsuranceUnderwritingIncome : undefined,
    jgaapInsurancePremiumIncome: entity.jgaapInsurancePremiumIncome !== null ? entity.jgaapInsurancePremiumIncome : undefined,
    jgaapInsuranceNetPremiumsWritten: entity.jgaapInsuranceNetPremiumsWritten !== null ? entity.jgaapInsuranceNetPremiumsWritten : undefined,
    jgaapInsuranceInvestmentIncome: entity.jgaapInsuranceInvestmentIncome !== null ? entity.jgaapInsuranceInvestmentIncome : undefined,
    jgaapInsuranceInvestmentIncomeOnSeparateAccounts:
      entity.jgaapInsuranceInvestmentIncomeOnSeparateAccounts !== null ? entity.jgaapInsuranceInvestmentIncomeOnSeparateAccounts : undefined,
    jgaapInsuranceInterestAndDividendsIncome:
      entity.jgaapInsuranceInterestAndDividendsIncome !== null ? entity.jgaapInsuranceInterestAndDividendsIncome : undefined,
    jgaapInsuranceOtherOrdinaryIncome: entity.jgaapInsuranceOtherOrdinaryIncome !== null ? entity.jgaapInsuranceOtherOrdinaryIncome : undefined,
    jgaapInsuranceOrdinaryExpenses: entity.jgaapInsuranceOrdinaryExpenses !== null ? entity.jgaapInsuranceOrdinaryExpenses : undefined,
    jgaapInsuranceUnderwritingExpenses: entity.jgaapInsuranceUnderwritingExpenses !== null ? entity.jgaapInsuranceUnderwritingExpenses : undefined,
    jgaapInsuranceClaimsAndOtherPayments: entity.jgaapInsuranceClaimsAndOtherPayments !== null ? entity.jgaapInsuranceClaimsAndOtherPayments : undefined,
    jgaapInsuranceClaimsPaid: entity.jgaapInsuranceClaimsPaid !== null ? entity.jgaapInsuranceClaimsPaid : undefined,
    jgaapInsuranceInsuranceClaims: entity.jgaapInsuranceInsuranceClaims !== null ? entity.jgaapInsuranceInsuranceClaims : undefined,
    jgaapInsuranceAnnuityPayments: entity.jgaapInsuranceAnnuityPayments !== null ? entity.jgaapInsuranceAnnuityPayments : undefined,
    jgaapInsuranceBenefits: entity.jgaapInsuranceBenefits !== null ? entity.jgaapInsuranceBenefits : undefined,
    jgaapInsuranceSurrenderValues: entity.jgaapInsuranceSurrenderValues !== null ? entity.jgaapInsuranceSurrenderValues : undefined,
    jgaapInsuranceOtherRefunds: entity.jgaapInsuranceOtherRefunds !== null ? entity.jgaapInsuranceOtherRefunds : undefined,
    jgaapInsuranceReinsurancePremiums: entity.jgaapInsuranceReinsurancePremiums !== null ? entity.jgaapInsuranceReinsurancePremiums : undefined,
    jgaapInsuranceProvisionForPolicyReserves:
      entity.jgaapInsuranceProvisionForPolicyReserves !== null ? entity.jgaapInsuranceProvisionForPolicyReserves : undefined,
    jgaapInsuranceInvestmentExpenses: entity.jgaapInsuranceInvestmentExpenses !== null ? entity.jgaapInsuranceInvestmentExpenses : undefined,
    jgaapInsuranceInvestmentLossesOnSeparateAccounts:
      entity.jgaapInsuranceInvestmentLossesOnSeparateAccounts !== null ? entity.jgaapInsuranceInvestmentLossesOnSeparateAccounts : undefined,
    jgaapInsuranceOperatingExpenses: entity.jgaapInsuranceOperatingExpenses !== null ? entity.jgaapInsuranceOperatingExpenses : undefined,
    jgaapInsuranceLossAdjustmentExpenses: entity.jgaapInsuranceLossAdjustmentExpenses !== null ? entity.jgaapInsuranceLossAdjustmentExpenses : undefined,
    jgaapRealEstateRevenueFromRealEstateBusiness:
      entity.jgaapRealEstateRevenueFromRealEstateBusiness !== null ? entity.jgaapRealEstateRevenueFromRealEstateBusiness : undefined,
    jgaapRealEstateRevenueFromRealEstateLeasing:
      entity.jgaapRealEstateRevenueFromRealEstateLeasing !== null ? entity.jgaapRealEstateRevenueFromRealEstateLeasing : undefined,
    jgaapRealEstateCostOfRealEstateBusiness:
      entity.jgaapRealEstateCostOfRealEstateBusiness !== null ? entity.jgaapRealEstateCostOfRealEstateBusiness : undefined,
    jgaapRealEstateCostOfRealEstateSales: entity.jgaapRealEstateCostOfRealEstateSales !== null ? entity.jgaapRealEstateCostOfRealEstateSales : undefined,
    jgaapRealEstateCostOfRealEstateLeasing: entity.jgaapRealEstateCostOfRealEstateLeasing !== null ? entity.jgaapRealEstateCostOfRealEstateLeasing : undefined,
    jgaapRailwayOperatingRevenuesFromRailwayBusiness:
      entity.jgaapRailwayOperatingRevenuesFromRailwayBusiness !== null ? entity.jgaapRailwayOperatingRevenuesFromRailwayBusiness : undefined,
    jgaapRailwayOperatingExpensesFromRailwayBusiness:
      entity.jgaapRailwayOperatingExpensesFromRailwayBusiness !== null ? entity.jgaapRailwayOperatingExpensesFromRailwayBusiness : undefined,
    jgaapShippingShippingRevenues: entity.jgaapShippingShippingRevenues !== null ? entity.jgaapShippingShippingRevenues : undefined,
    jgaapShippingShippingExpenses: entity.jgaapShippingShippingExpenses !== null ? entity.jgaapShippingShippingExpenses : undefined,
    jgaapShippingOperatingExpenses: entity.jgaapShippingOperatingExpenses !== null ? entity.jgaapShippingOperatingExpenses : undefined,
    jgaapEpagOperatingRevenuesFromEub: entity.jgaapEpagOperatingRevenuesFromEub !== null ? entity.jgaapEpagOperatingRevenuesFromEub : undefined,
    jgaapEpagOperatingExpensesFromEub: entity.jgaapEpagOperatingExpensesFromEub !== null ? entity.jgaapEpagOperatingExpensesFromEub : undefined,
    jgaapElectricPowerAndGasNonOperatingIncome:
      entity.jgaapElectricPowerAndGasNonOperatingIncome !== null ? entity.jgaapElectricPowerAndGasNonOperatingIncome : undefined,
    jgaapElectricPowerAndGasNonOperatingExpenses:
      entity.jgaapElectricPowerAndGasNonOperatingExpenses !== null ? entity.jgaapElectricPowerAndGasNonOperatingExpenses : undefined,
    jgaapLeasingLeaseRevenue: entity.jgaapLeasingLeaseRevenue !== null ? entity.jgaapLeasingLeaseRevenue : undefined,
    jgaapLeasingLeaseCost: entity.jgaapLeasingLeaseCost !== null ? entity.jgaapLeasingLeaseCost : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableBsFullToProtoModel = (entity: DomainModel.UsecaseTableBsFull): ProtoModel.UsecaseTableBsFull => {
  return new ProtoModel.UsecaseTableBsFull({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    accountingStandard: entity.accountingStandard !== null ? entity.accountingStandard : undefined,
    unit: entity.unit !== null ? entity.unit : undefined,
    unitText: entity.unitText !== null ? entity.unitText : undefined,
    highlightCashAndDepositsJpy: entity.highlightCashAndDepositsJpy !== null ? entity.highlightCashAndDepositsJpy : undefined,
    highlightAccountsReceivableJpy: entity.highlightAccountsReceivableJpy !== null ? entity.highlightAccountsReceivableJpy : undefined,
    highlightInventoriesJpy: entity.highlightInventoriesJpy !== null ? entity.highlightInventoriesJpy : undefined,
    highlightPropertyPlantEquipmentJpy: entity.highlightPropertyPlantEquipmentJpy !== null ? entity.highlightPropertyPlantEquipmentJpy : undefined,
    highlightTotalAssetsJpy: entity.highlightTotalAssetsJpy !== null ? entity.highlightTotalAssetsJpy : undefined,
    ifrsGeneralPropertyPlantAndEquipment: entity.ifrsGeneralPropertyPlantAndEquipment !== null ? entity.ifrsGeneralPropertyPlantAndEquipment : undefined,
    ifrsGeneralInvestmentProperty: entity.ifrsGeneralInvestmentProperty !== null ? entity.ifrsGeneralInvestmentProperty : undefined,
    ifrsGeneralIntangibleAssets: entity.ifrsGeneralIntangibleAssets !== null ? entity.ifrsGeneralIntangibleAssets : undefined,
    ifrsGeneralFinancialAssetsExcludingCashEquivalents:
      entity.ifrsGeneralFinancialAssetsExcludingCashEquivalents !== null ? entity.ifrsGeneralFinancialAssetsExcludingCashEquivalents : undefined,
    ifrsGeneralInvestmentsAccountedForUsingTheEquityMethod:
      entity.ifrsGeneralInvestmentsAccountedForUsingTheEquityMethod !== null ? entity.ifrsGeneralInvestmentsAccountedForUsingTheEquityMethod : undefined,
    ifrsGeneralDeferredTaxAssets: entity.ifrsGeneralDeferredTaxAssets !== null ? entity.ifrsGeneralDeferredTaxAssets : undefined,
    ifrsGeneralTotalNonCurrentAssets: entity.ifrsGeneralTotalNonCurrentAssets !== null ? entity.ifrsGeneralTotalNonCurrentAssets : undefined,
    ifrsGeneralInventories: entity.ifrsGeneralInventories !== null ? entity.ifrsGeneralInventories : undefined,
    ifrsGeneralTradeAndOtherReceivables: entity.ifrsGeneralTradeAndOtherReceivables !== null ? entity.ifrsGeneralTradeAndOtherReceivables : undefined,
    ifrsGeneralCashAndCashEquivalents: entity.ifrsGeneralCashAndCashEquivalents !== null ? entity.ifrsGeneralCashAndCashEquivalents : undefined,
    ifrsGeneralAssetsHeldForSale: entity.ifrsGeneralAssetsHeldForSale !== null ? entity.ifrsGeneralAssetsHeldForSale : undefined,
    ifrsGeneralTotalCurrentAssets: entity.ifrsGeneralTotalCurrentAssets !== null ? entity.ifrsGeneralTotalCurrentAssets : undefined,
    ifrsGeneralTotalAssets: entity.ifrsGeneralTotalAssets !== null ? entity.ifrsGeneralTotalAssets : undefined,
    ifrsGeneralTotalFixedAssets: entity.ifrsGeneralTotalFixedAssets !== null ? entity.ifrsGeneralTotalFixedAssets : undefined,
    ifrsGeneralTotalCurrentLiabilities: entity.ifrsGeneralTotalCurrentLiabilities !== null ? entity.ifrsGeneralTotalCurrentLiabilities : undefined,
    ifrsGeneralTotalFixedLiabilities: entity.ifrsGeneralTotalFixedLiabilities !== null ? entity.ifrsGeneralTotalFixedLiabilities : undefined,
    ifrsGeneralTotalLiabilities: entity.ifrsGeneralTotalLiabilities !== null ? entity.ifrsGeneralTotalLiabilities : undefined,
    ifrsGeneralNonControllingInterests: entity.ifrsGeneralNonControllingInterests !== null ? entity.ifrsGeneralNonControllingInterests : undefined,
    ifrsGeneralIssuedCapitalAndReservesAttrToOotp:
      entity.ifrsGeneralIssuedCapitalAndReservesAttrToOotp !== null ? entity.ifrsGeneralIssuedCapitalAndReservesAttrToOotp : undefined,
    ifrsGeneralTotalEquity: entity.ifrsGeneralTotalEquity !== null ? entity.ifrsGeneralTotalEquity : undefined,
    ifrsGeneralTotalEquityAndLiabilities: entity.ifrsGeneralTotalEquityAndLiabilities !== null ? entity.ifrsGeneralTotalEquityAndLiabilities : undefined,
    ifrsFiCashAndBalancesWithCentralBanks: entity.ifrsFiCashAndBalancesWithCentralBanks !== null ? entity.ifrsFiCashAndBalancesWithCentralBanks : undefined,
    ifrsFinancialInstitutionsLoansAndAdvancesToBanks:
      entity.ifrsFinancialInstitutionsLoansAndAdvancesToBanks !== null ? entity.ifrsFinancialInstitutionsLoansAndAdvancesToBanks : undefined,
    ifrsFinancialInstitutionsLoansAndAdvancesToCustomers:
      entity.ifrsFinancialInstitutionsLoansAndAdvancesToCustomers !== null ? entity.ifrsFinancialInstitutionsLoansAndAdvancesToCustomers : undefined,
    ifrsFiDerivativeFiAssets: entity.ifrsFiDerivativeFiAssets !== null ? entity.ifrsFiDerivativeFiAssets : undefined,
    ifrsFinancialInstitutionsInvestmentSecurities:
      entity.ifrsFinancialInstitutionsInvestmentSecurities !== null ? entity.ifrsFinancialInstitutionsInvestmentSecurities : undefined,
    ifrsFinancialInstitutionsTradingAssets: entity.ifrsFinancialInstitutionsTradingAssets !== null ? entity.ifrsFinancialInstitutionsTradingAssets : undefined,
    ifrsFinancialInstitutionsPledgedAssets: entity.ifrsFinancialInstitutionsPledgedAssets !== null ? entity.ifrsFinancialInstitutionsPledgedAssets : undefined,
    ifrsFinancialInstitutionsDepositsFromBanks:
      entity.ifrsFinancialInstitutionsDepositsFromBanks !== null ? entity.ifrsFinancialInstitutionsDepositsFromBanks : undefined,
    ifrsFinancialInstitutionsDepositsFromCustomers:
      entity.ifrsFinancialInstitutionsDepositsFromCustomers !== null ? entity.ifrsFinancialInstitutionsDepositsFromCustomers : undefined,
    ifrsFiDerivativeFiLiabilities: entity.ifrsFiDerivativeFiLiabilities !== null ? entity.ifrsFiDerivativeFiLiabilities : undefined,
    ifrsFinancialInstitutionsDebtSecuritiesInIssue:
      entity.ifrsFinancialInstitutionsDebtSecuritiesInIssue !== null ? entity.ifrsFinancialInstitutionsDebtSecuritiesInIssue : undefined,
    ifrsFinancialInstitutionsSubordinatedLiabilities:
      entity.ifrsFinancialInstitutionsSubordinatedLiabilities !== null ? entity.ifrsFinancialInstitutionsSubordinatedLiabilities : undefined,
    ifrsFinancialInstitutionsTradingLiabilities:
      entity.ifrsFinancialInstitutionsTradingLiabilities !== null ? entity.ifrsFinancialInstitutionsTradingLiabilities : undefined,
    ifrsInsuranceIndustryInsuranceContractAssets:
      entity.ifrsInsuranceIndustryInsuranceContractAssets !== null ? entity.ifrsInsuranceIndustryInsuranceContractAssets : undefined,
    ifrsInsuranceIndustryReinsuranceContractAssets:
      entity.ifrsInsuranceIndustryReinsuranceContractAssets !== null ? entity.ifrsInsuranceIndustryReinsuranceContractAssets : undefined,
    ifrsInsuranceIndustryInsuranceContractLiabilities:
      entity.ifrsInsuranceIndustryInsuranceContractLiabilities !== null ? entity.ifrsInsuranceIndustryInsuranceContractLiabilities : undefined,
    ifrsInsuranceIndustryReinsuranceContractLiabilities:
      entity.ifrsInsuranceIndustryReinsuranceContractLiabilities !== null ? entity.ifrsInsuranceIndustryReinsuranceContractLiabilities : undefined,
    ifrsInsuranceIndustryInvestmentContractLiabilities:
      entity.ifrsInsuranceIndustryInvestmentContractLiabilities !== null ? entity.ifrsInsuranceIndustryInvestmentContractLiabilities : undefined,
    ifrsAgricultureBiologicalAssets: entity.ifrsAgricultureBiologicalAssets !== null ? entity.ifrsAgricultureBiologicalAssets : undefined,
    ifrsAgricultureBearerPlants: entity.ifrsAgricultureBearerPlants !== null ? entity.ifrsAgricultureBearerPlants : undefined,
    ifrsAgricultureAgriculturalProduceInventoryAtHarvest:
      entity.ifrsAgricultureAgriculturalProduceInventoryAtHarvest !== null ? entity.ifrsAgricultureAgriculturalProduceInventoryAtHarvest : undefined,
    ifrsEfaeomrExplorationAndEvaluationAssets:
      entity.ifrsEfaeomrExplorationAndEvaluationAssets !== null ? entity.ifrsEfaeomrExplorationAndEvaluationAssets : undefined,
    ifrsEfaeomrEaeAssetsTangible: entity.ifrsEfaeomrEaeAssetsTangible !== null ? entity.ifrsEfaeomrEaeAssetsTangible : undefined,
    ifrsEfaeomrEaeAssetsIntangible: entity.ifrsEfaeomrEaeAssetsIntangible !== null ? entity.ifrsEfaeomrEaeAssetsIntangible : undefined,
    ifrsEfaeomrLiabilitiesRelatedToEaeAssets:
      entity.ifrsEfaeomrLiabilitiesRelatedToEaeAssets !== null ? entity.ifrsEfaeomrLiabilitiesRelatedToEaeAssets : undefined,
    ifrsRraTotalAssetsSubjectToRateReg: entity.ifrsRraTotalAssetsSubjectToRateReg !== null ? entity.ifrsRraTotalAssetsSubjectToRateReg : undefined,
    ifrsRraRegulatoryDeferralAccountDebitBal:
      entity.ifrsRraRegulatoryDeferralAccountDebitBal !== null ? entity.ifrsRraRegulatoryDeferralAccountDebitBal : undefined,
    ifrsRraRegulatoryDeferralAccountCreditBal:
      entity.ifrsRraRegulatoryDeferralAccountCreditBal !== null ? entity.ifrsRraRegulatoryDeferralAccountCreditBal : undefined,
    ifrsIeFaAtFvtplInvestmentsInSubs: entity.ifrsIeFaAtFvtplInvestmentsInSubs !== null ? entity.ifrsIeFaAtFvtplInvestmentsInSubs : undefined,
    jgaapGeneralCashAndDeposits: entity.jgaapGeneralCashAndDeposits !== null ? entity.jgaapGeneralCashAndDeposits : undefined,
    jgaapGeneralNotesAndArTradeAndContractAssets:
      entity.jgaapGeneralNotesAndArTradeAndContractAssets !== null ? entity.jgaapGeneralNotesAndArTradeAndContractAssets : undefined,
    jgaapGeneralSecurities: entity.jgaapGeneralSecurities !== null ? entity.jgaapGeneralSecurities : undefined,
    jgaapGeneralInventories: entity.jgaapGeneralInventories !== null ? entity.jgaapGeneralInventories : undefined,
    jgaapGeneralPropertyPlantAndEquipment: entity.jgaapGeneralPropertyPlantAndEquipment !== null ? entity.jgaapGeneralPropertyPlantAndEquipment : undefined,
    jgaapGeneralIntangibleAssets: entity.jgaapGeneralIntangibleAssets !== null ? entity.jgaapGeneralIntangibleAssets : undefined,
    jgaapGeneralInvestmentSecurities: entity.jgaapGeneralInvestmentSecurities !== null ? entity.jgaapGeneralInvestmentSecurities : undefined,
    jgaapGeneralDeferredTaxAssets: entity.jgaapGeneralDeferredTaxAssets !== null ? entity.jgaapGeneralDeferredTaxAssets : undefined,
    jgaapGeneralNotesAndAccountsPayableTrade:
      entity.jgaapGeneralNotesAndAccountsPayableTrade !== null ? entity.jgaapGeneralNotesAndAccountsPayableTrade : undefined,
    jgaapGeneralShortTermBorrowings: entity.jgaapGeneralShortTermBorrowings !== null ? entity.jgaapGeneralShortTermBorrowings : undefined,
    jgaapGeneralProvisions: entity.jgaapGeneralProvisions !== null ? entity.jgaapGeneralProvisions : undefined,
    jgaapGeneralBondsPayable: entity.jgaapGeneralBondsPayable !== null ? entity.jgaapGeneralBondsPayable : undefined,
    jgaapGeneralLongTermBorrowings: entity.jgaapGeneralLongTermBorrowings !== null ? entity.jgaapGeneralLongTermBorrowings : undefined,
    jgaapGeneralRetirementBenefitLiability: entity.jgaapGeneralRetirementBenefitLiability !== null ? entity.jgaapGeneralRetirementBenefitLiability : undefined,
    jgaapGeneralShareCapital: entity.jgaapGeneralShareCapital !== null ? entity.jgaapGeneralShareCapital : undefined,
    jgaapGeneralCapitalSurplus: entity.jgaapGeneralCapitalSurplus !== null ? entity.jgaapGeneralCapitalSurplus : undefined,
    jgaapGeneralRetainedEarnings: entity.jgaapGeneralRetainedEarnings !== null ? entity.jgaapGeneralRetainedEarnings : undefined,
    jgaapGeneralTreasuryShares: entity.jgaapGeneralTreasuryShares !== null ? entity.jgaapGeneralTreasuryShares : undefined,
    jgaapGeneralAccumulatedOtherComprehensiveIncome:
      entity.jgaapGeneralAccumulatedOtherComprehensiveIncome !== null ? entity.jgaapGeneralAccumulatedOtherComprehensiveIncome : undefined,
    jgaapGeneralNonControllingInterests: entity.jgaapGeneralNonControllingInterests !== null ? entity.jgaapGeneralNonControllingInterests : undefined,
    jgaapGeneralTotalCurrentAssets: entity.jgaapGeneralTotalCurrentAssets !== null ? entity.jgaapGeneralTotalCurrentAssets : undefined,
    jgaapGeneralTotalFixedAssets: entity.jgaapGeneralTotalFixedAssets !== null ? entity.jgaapGeneralTotalFixedAssets : undefined,
    jgaapGeneralTotalCurrentLiabilities: entity.jgaapGeneralTotalCurrentLiabilities !== null ? entity.jgaapGeneralTotalCurrentLiabilities : undefined,
    jgaapGeneralTotalFixedLiabilities: entity.jgaapGeneralTotalFixedLiabilities !== null ? entity.jgaapGeneralTotalFixedLiabilities : undefined,
    jgaapGeneralTotalLiabilities: entity.jgaapGeneralTotalLiabilities !== null ? entity.jgaapGeneralTotalLiabilities : undefined,
    jgaapGeneralTotalNetAssets: entity.jgaapGeneralTotalNetAssets !== null ? entity.jgaapGeneralTotalNetAssets : undefined,
    jgaapGeneralTotalAssets: entity.jgaapGeneralTotalAssets !== null ? entity.jgaapGeneralTotalAssets : undefined,
    jgaapGeneralAccumulatedDepreciation: entity.jgaapGeneralAccumulatedDepreciation !== null ? entity.jgaapGeneralAccumulatedDepreciation : undefined,
    jgaapGeneralSubscriptionRightsShares: entity.jgaapGeneralSubscriptionRightsShares !== null ? entity.jgaapGeneralSubscriptionRightsShares : undefined,
    jgaapGeneralAdvancePayments: entity.jgaapGeneralAdvancePayments !== null ? entity.jgaapGeneralAdvancePayments : undefined,
    jgaapGeneralPrepaidExpenses: entity.jgaapGeneralPrepaidExpenses !== null ? entity.jgaapGeneralPrepaidExpenses : undefined,
    jgaapGeneralAdvancesReceived: entity.jgaapGeneralAdvancesReceived !== null ? entity.jgaapGeneralAdvancesReceived : undefined,
    jgaapGeneralDeferredRevenue: entity.jgaapGeneralDeferredRevenue !== null ? entity.jgaapGeneralDeferredRevenue : undefined,
    jgaapConstructionArFromCompletedCc: entity.jgaapConstructionArFromCompletedCc !== null ? entity.jgaapConstructionArFromCompletedCc : undefined,
    jgaapConstructionCostsOnUncompletedConstructionContracts:
      entity.jgaapConstructionCostsOnUncompletedConstructionContracts !== null ? entity.jgaapConstructionCostsOnUncompletedConstructionContracts : undefined,
    jgaapConstructionAdvancesReceivedOnUncompletedCc:
      entity.jgaapConstructionAdvancesReceivedOnUncompletedCc !== null ? entity.jgaapConstructionAdvancesReceivedOnUncompletedCc : undefined,
    jgaapConstructionMaterialsAndSupplies: entity.jgaapConstructionMaterialsAndSupplies !== null ? entity.jgaapConstructionMaterialsAndSupplies : undefined,
    jgaapConstructionAccountsPayableForConstructionContracts:
      entity.jgaapConstructionAccountsPayableForConstructionContracts !== null ? entity.jgaapConstructionAccountsPayableForConstructionContracts : undefined,
    jgaapConstructionProvisionForLossOnConstructionContracts:
      entity.jgaapConstructionProvisionForLossOnConstructionContracts !== null ? entity.jgaapConstructionProvisionForLossOnConstructionContracts : undefined,
    jgaapConstructionProvisionForWarrantiesForCompletedC:
      entity.jgaapConstructionProvisionForWarrantiesForCompletedC !== null ? entity.jgaapConstructionProvisionForWarrantiesForCompletedC : undefined,
    jgaapBankingCashAndDueFromBanks: entity.jgaapBankingCashAndDueFromBanks !== null ? entity.jgaapBankingCashAndDueFromBanks : undefined,
    jgaapBankingCallLoansAndBillsBought: entity.jgaapBankingCallLoansAndBillsBought !== null ? entity.jgaapBankingCallLoansAndBillsBought : undefined,
    jgaapBankingMonetaryClaimsBought: entity.jgaapBankingMonetaryClaimsBought !== null ? entity.jgaapBankingMonetaryClaimsBought : undefined,
    jgaapBankingTradingAssets: entity.jgaapBankingTradingAssets !== null ? entity.jgaapBankingTradingAssets : undefined,
    jgaapBankingMoneyHeldInTrust: entity.jgaapBankingMoneyHeldInTrust !== null ? entity.jgaapBankingMoneyHeldInTrust : undefined,
    jgaapBankingSecurities: entity.jgaapBankingSecurities !== null ? entity.jgaapBankingSecurities : undefined,
    jgaapBankingLoansAndBillsDiscounted: entity.jgaapBankingLoansAndBillsDiscounted !== null ? entity.jgaapBankingLoansAndBillsDiscounted : undefined,
    jgaapBankingForeignExchangesAssets: entity.jgaapBankingForeignExchangesAssets !== null ? entity.jgaapBankingForeignExchangesAssets : undefined,
    jgaapBankingDerivativesAssets: entity.jgaapBankingDerivativesAssets !== null ? entity.jgaapBankingDerivativesAssets : undefined,
    jgaapBankingDeposits: entity.jgaapBankingDeposits !== null ? entity.jgaapBankingDeposits : undefined,
    jgaapBankingNegotiableCertificatesOfDeposit:
      entity.jgaapBankingNegotiableCertificatesOfDeposit !== null ? entity.jgaapBankingNegotiableCertificatesOfDeposit : undefined,
    jgaapBankingCallMoneyAndBillsSold: entity.jgaapBankingCallMoneyAndBillsSold !== null ? entity.jgaapBankingCallMoneyAndBillsSold : undefined,
    jgaapBankingPayablesUnderSecuritiesLendingTransactions:
      entity.jgaapBankingPayablesUnderSecuritiesLendingTransactions !== null ? entity.jgaapBankingPayablesUnderSecuritiesLendingTransactions : undefined,
    jgaapBankingTradingLiabilities: entity.jgaapBankingTradingLiabilities !== null ? entity.jgaapBankingTradingLiabilities : undefined,
    jgaapBankingBorrowedMoney: entity.jgaapBankingBorrowedMoney !== null ? entity.jgaapBankingBorrowedMoney : undefined,
    jgaapBankingForeignExchangesLiabilities:
      entity.jgaapBankingForeignExchangesLiabilities !== null ? entity.jgaapBankingForeignExchangesLiabilities : undefined,
    jgaapBankingBondsPayable: entity.jgaapBankingBondsPayable !== null ? entity.jgaapBankingBondsPayable : undefined,
    jgaapBankingDerivativesLiabilities: entity.jgaapBankingDerivativesLiabilities !== null ? entity.jgaapBankingDerivativesLiabilities : undefined,
    jgaapBankingDeferredTaxLiabilitiesForLandRevaluation:
      entity.jgaapBankingDeferredTaxLiabilitiesForLandRevaluation !== null ? entity.jgaapBankingDeferredTaxLiabilitiesForLandRevaluation : undefined,
    jgaapBankingCustomersLiabForAcceptancesAndGuarantees:
      entity.jgaapBankingCustomersLiabForAcceptancesAndGuarantees !== null ? entity.jgaapBankingCustomersLiabForAcceptancesAndGuarantees : undefined,
    jgaapBankingAcceptancesAndGuarantees: entity.jgaapBankingAcceptancesAndGuarantees !== null ? entity.jgaapBankingAcceptancesAndGuarantees : undefined,
    jgaapSecuritiesDepositsPaid: entity.jgaapSecuritiesDepositsPaid !== null ? entity.jgaapSecuritiesDepositsPaid : undefined,
    jgaapSecuritiesSegregatedDepositsForCustomers:
      entity.jgaapSecuritiesSegregatedDepositsForCustomers !== null ? entity.jgaapSecuritiesSegregatedDepositsForCustomers : undefined,
    jgaapSecuritiesTradingProducts: entity.jgaapSecuritiesTradingProducts !== null ? entity.jgaapSecuritiesTradingProducts : undefined,
    jgaapSecuritiesMarginTransactionAssets: entity.jgaapSecuritiesMarginTransactionAssets !== null ? entity.jgaapSecuritiesMarginTransactionAssets : undefined,
    jgaapSecuritiesLoansOnMarginTransactions:
      entity.jgaapSecuritiesLoansOnMarginTransactions !== null ? entity.jgaapSecuritiesLoansOnMarginTransactions : undefined,
    jgaapSecuritiesCashCollateralForSecBorrowedOnMt:
      entity.jgaapSecuritiesCashCollateralForSecBorrowedOnMt !== null ? entity.jgaapSecuritiesCashCollateralForSecBorrowedOnMt : undefined,
    jgaapSecuritiesAdvancesPaid: entity.jgaapSecuritiesAdvancesPaid !== null ? entity.jgaapSecuritiesAdvancesPaid : undefined,
    jgaapSecuritiesSubscriptionDeposits: entity.jgaapSecuritiesSubscriptionDeposits !== null ? entity.jgaapSecuritiesSubscriptionDeposits : undefined,
    jgaapSecuritiesShortTermGuaranteeDeposits:
      entity.jgaapSecuritiesShortTermGuaranteeDeposits !== null ? entity.jgaapSecuritiesShortTermGuaranteeDeposits : undefined,
    jgaapSecuritiesLoansSecuredBySecurities:
      entity.jgaapSecuritiesLoansSecuredBySecurities !== null ? entity.jgaapSecuritiesLoansSecuredBySecurities : undefined,
    jgaapSecuritiesTradingProductsLiabilities:
      entity.jgaapSecuritiesTradingProductsLiabilities !== null ? entity.jgaapSecuritiesTradingProductsLiabilities : undefined,
    jgaapSecuritiesMarginTransactionLiabilities:
      entity.jgaapSecuritiesMarginTransactionLiabilities !== null ? entity.jgaapSecuritiesMarginTransactionLiabilities : undefined,
    jgaapSecuritiesBorrowingsOnMarginTransactions:
      entity.jgaapSecuritiesBorrowingsOnMarginTransactions !== null ? entity.jgaapSecuritiesBorrowingsOnMarginTransactions : undefined,
    jgaapSecuritiesCashReceivedForSecLentOnMt:
      entity.jgaapSecuritiesCashReceivedForSecLentOnMt !== null ? entity.jgaapSecuritiesCashReceivedForSecLentOnMt : undefined,
    jgaapSecuritiesGuaranteeDepositsReceived:
      entity.jgaapSecuritiesGuaranteeDepositsReceived !== null ? entity.jgaapSecuritiesGuaranteeDepositsReceived : undefined,
    jgaapSecuritiesDepositsReceived: entity.jgaapSecuritiesDepositsReceived !== null ? entity.jgaapSecuritiesDepositsReceived : undefined,
    jgaapSecuritiesDepositsFromCustomers: entity.jgaapSecuritiesDepositsFromCustomers !== null ? entity.jgaapSecuritiesDepositsFromCustomers : undefined,
    jgaapSecuritiesShortTermGuaranteeDepositsReceived:
      entity.jgaapSecuritiesShortTermGuaranteeDepositsReceived !== null ? entity.jgaapSecuritiesShortTermGuaranteeDepositsReceived : undefined,
    jgaapSecuritiesShortTermBorrowings: entity.jgaapSecuritiesShortTermBorrowings !== null ? entity.jgaapSecuritiesShortTermBorrowings : undefined,
    jgaapSecuritiesBorrowingsSecuredBySecurities:
      entity.jgaapSecuritiesBorrowingsSecuredBySecurities !== null ? entity.jgaapSecuritiesBorrowingsSecuredBySecurities : undefined,
    jgaapInsuranceCashAndDeposits: entity.jgaapInsuranceCashAndDeposits !== null ? entity.jgaapInsuranceCashAndDeposits : undefined,
    jgaapInsuranceCallLoans: entity.jgaapInsuranceCallLoans !== null ? entity.jgaapInsuranceCallLoans : undefined,
    jgaapInsuranceMonetaryClaimsBought: entity.jgaapInsuranceMonetaryClaimsBought !== null ? entity.jgaapInsuranceMonetaryClaimsBought : undefined,
    jgaapInsuranceMoneyHeldInTrust: entity.jgaapInsuranceMoneyHeldInTrust !== null ? entity.jgaapInsuranceMoneyHeldInTrust : undefined,
    jgaapInsuranceSecurities: entity.jgaapInsuranceSecurities !== null ? entity.jgaapInsuranceSecurities : undefined,
    jgaapInsuranceLoans: entity.jgaapInsuranceLoans !== null ? entity.jgaapInsuranceLoans : undefined,
    jgaapInsuranceAgencyLoans: entity.jgaapInsuranceAgencyLoans !== null ? entity.jgaapInsuranceAgencyLoans : undefined,
    jgaapInsuranceReinsuranceReceivables: entity.jgaapInsuranceReinsuranceReceivables !== null ? entity.jgaapInsuranceReinsuranceReceivables : undefined,
    jgaapInsuranceDeferredAssetsUnderArticle113:
      entity.jgaapInsuranceDeferredAssetsUnderArticle113 !== null ? entity.jgaapInsuranceDeferredAssetsUnderArticle113 : undefined,
    jgaapInsuranceReserveForOutstandingClaims:
      entity.jgaapInsuranceReserveForOutstandingClaims !== null ? entity.jgaapInsuranceReserveForOutstandingClaims : undefined,
    jgaapInsurancePolicyReserves: entity.jgaapInsurancePolicyReserves !== null ? entity.jgaapInsurancePolicyReserves : undefined,
    jgaapInsuranceReserveForPolicyholderDividends:
      entity.jgaapInsuranceReserveForPolicyholderDividends !== null ? entity.jgaapInsuranceReserveForPolicyholderDividends : undefined,
    jgaapInsuranceReinsurancePayables: entity.jgaapInsuranceReinsurancePayables !== null ? entity.jgaapInsuranceReinsurancePayables : undefined,
    jgaapInsuranceReserveForPriceFluctuation:
      entity.jgaapInsuranceReserveForPriceFluctuation !== null ? entity.jgaapInsuranceReserveForPriceFluctuation : undefined,
    jgaapRealEstateRealEstateForSale: entity.jgaapRealEstateRealEstateForSale !== null ? entity.jgaapRealEstateRealEstateForSale : undefined,
    jgaapRealEstateRealEstateForSaleInProcess:
      entity.jgaapRealEstateRealEstateForSaleInProcess !== null ? entity.jgaapRealEstateRealEstateForSaleInProcess : undefined,
    jgaapShippingVessels: entity.jgaapShippingVessels !== null ? entity.jgaapShippingVessels : undefined,
    jgaapShippingDeferredShippingExpenses: entity.jgaapShippingDeferredShippingExpenses !== null ? entity.jgaapShippingDeferredShippingExpenses : undefined,
    jgaapShippingDeferredShippingRevenue: entity.jgaapShippingDeferredShippingRevenue !== null ? entity.jgaapShippingDeferredShippingRevenue : undefined,
    jgaapEpagFixedAssetsForEub: entity.jgaapEpagFixedAssetsForEub !== null ? entity.jgaapEpagFixedAssetsForEub : undefined,
    jgaapElectricPowerAndGasConstructionInProgress:
      entity.jgaapElectricPowerAndGasConstructionInProgress !== null ? entity.jgaapElectricPowerAndGasConstructionInProgress : undefined,
    jgaapElectricPowerAndGasNuclearFuel: entity.jgaapElectricPowerAndGasNuclearFuel !== null ? entity.jgaapElectricPowerAndGasNuclearFuel : undefined,
    jgaapEpagNfInReactorOfSpecificNpf: entity.jgaapEpagNfInReactorOfSpecificNpf !== null ? entity.jgaapEpagNfInReactorOfSpecificNpf : undefined,
    jgaapEpagReserveForSpecialDeprOfSpecificEquip:
      entity.jgaapEpagReserveForSpecialDeprOfSpecificEquip !== null ? entity.jgaapEpagReserveForSpecialDeprOfSpecificEquip : undefined,
    jgaapEpagReserveForFluctuationInWaterLevels:
      entity.jgaapEpagReserveForFluctuationInWaterLevels !== null ? entity.jgaapEpagReserveForFluctuationInWaterLevels : undefined,
    jgaapEpagReserveForDecommissioningOfNpu:
      entity.jgaapEpagReserveForDecommissioningOfNpu !== null ? entity.jgaapEpagReserveForDecommissioningOfNpu : undefined,
    jgaapEpagReserveForReprocessingOfIrradiatedNf:
      entity.jgaapEpagReserveForReprocessingOfIrradiatedNf !== null ? entity.jgaapEpagReserveForReprocessingOfIrradiatedNf : undefined,
    jgaapEpagReserveForDecommissioningOfSpecificNpf:
      entity.jgaapEpagReserveForDecommissioningOfSpecificNpf !== null ? entity.jgaapEpagReserveForDecommissioningOfSpecificNpf : undefined,
    jgaapLeasingLeaseInvestmentAssets: entity.jgaapLeasingLeaseInvestmentAssets !== null ? entity.jgaapLeasingLeaseInvestmentAssets : undefined,
    jgaapLeasingLeaseReceivables: entity.jgaapLeasingLeaseReceivables !== null ? entity.jgaapLeasingLeaseReceivables : undefined,
    jgaapLeasingAssetsForLease: entity.jgaapLeasingAssetsForLease !== null ? entity.jgaapLeasingAssetsForLease : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUsecaseTableCfFullToProtoModel = (entity: DomainModel.UsecaseTableCfFull): ProtoModel.UsecaseTableCfFull => {
  return new ProtoModel.UsecaseTableCfFull({
    ...entity,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    accountingStandard: entity.accountingStandard !== null ? entity.accountingStandard : undefined,
    unit: entity.unit !== null ? entity.unit : undefined,
    unitText: entity.unitText !== null ? entity.unitText : undefined,
    highlightOperatingCfJpy: entity.highlightOperatingCfJpy !== null ? entity.highlightOperatingCfJpy : undefined,
    highlightInvestingCfJpy: entity.highlightInvestingCfJpy !== null ? entity.highlightInvestingCfJpy : undefined,
    highlightFinancingCfJpy: entity.highlightFinancingCfJpy !== null ? entity.highlightFinancingCfJpy : undefined,
    highlightCashEoyJpy: entity.highlightCashEoyJpy !== null ? entity.highlightCashEoyJpy : undefined,
    ifrsGeneralCashFlowsFromOperatingActivities:
      entity.ifrsGeneralCashFlowsFromOperatingActivities !== null ? entity.ifrsGeneralCashFlowsFromOperatingActivities : undefined,
    ifrsGeneralInterestPaid: entity.ifrsGeneralInterestPaid !== null ? entity.ifrsGeneralInterestPaid : undefined,
    ifrsGeneralInterestReceived: entity.ifrsGeneralInterestReceived !== null ? entity.ifrsGeneralInterestReceived : undefined,
    ifrsGeneralDividendsReceived: entity.ifrsGeneralDividendsReceived !== null ? entity.ifrsGeneralDividendsReceived : undefined,
    ifrsGeneralIncomeTaxesPaid: entity.ifrsGeneralIncomeTaxesPaid !== null ? entity.ifrsGeneralIncomeTaxesPaid : undefined,
    ifrsGeneralCashFlowsFromInvestingActivities:
      entity.ifrsGeneralCashFlowsFromInvestingActivities !== null ? entity.ifrsGeneralCashFlowsFromInvestingActivities : undefined,
    ifrsGeneralCashFlowsFromFinancingActivities:
      entity.ifrsGeneralCashFlowsFromFinancingActivities !== null ? entity.ifrsGeneralCashFlowsFromFinancingActivities : undefined,
    ifrsGeneralDividendsPaid: entity.ifrsGeneralDividendsPaid !== null ? entity.ifrsGeneralDividendsPaid : undefined,
    ifrsGeneralCceAtBeginningOfPeriod: entity.ifrsGeneralCceAtBeginningOfPeriod !== null ? entity.ifrsGeneralCceAtBeginningOfPeriod : undefined,
    ifrsGeneralCashAndCashEquivalentsAtTheEndOfThePeriod:
      entity.ifrsGeneralCashAndCashEquivalentsAtTheEndOfThePeriod !== null ? entity.ifrsGeneralCashAndCashEquivalentsAtTheEndOfThePeriod : undefined,
    jgaapGeneralCashFlowsFromOperatingActivities:
      entity.jgaapGeneralCashFlowsFromOperatingActivities !== null ? entity.jgaapGeneralCashFlowsFromOperatingActivities : undefined,
    jgaapGeneralCashFlowsFromInvestingActivities:
      entity.jgaapGeneralCashFlowsFromInvestingActivities !== null ? entity.jgaapGeneralCashFlowsFromInvestingActivities : undefined,
    jgaapGeneralCashFlowsFromFinancingActivities:
      entity.jgaapGeneralCashFlowsFromFinancingActivities !== null ? entity.jgaapGeneralCashFlowsFromFinancingActivities : undefined,
    jgaapGeneralEffectOfExchRateChangeOnCce:
      entity.jgaapGeneralEffectOfExchRateChangeOnCce !== null ? entity.jgaapGeneralEffectOfExchRateChangeOnCce : undefined,
    jgaapGeneralNetIncreaseDecreaseInCce: entity.jgaapGeneralNetIncreaseDecreaseInCce !== null ? entity.jgaapGeneralNetIncreaseDecreaseInCce : undefined,
    jgaapGeneralCashAndCashEquivalentsAtBeginningOfPeriod:
      entity.jgaapGeneralCashAndCashEquivalentsAtBeginningOfPeriod !== null ? entity.jgaapGeneralCashAndCashEquivalentsAtBeginningOfPeriod : undefined,
    jgaapGeneralCashAndCashEquivalentsAtEndOfPeriod:
      entity.jgaapGeneralCashAndCashEquivalentsAtEndOfPeriod !== null ? entity.jgaapGeneralCashAndCashEquivalentsAtEndOfPeriod : undefined,
    jgaapGeneralPurchasePpe: entity.jgaapGeneralPurchasePpe !== null ? entity.jgaapGeneralPurchasePpe : undefined,
    jgaapGeneralPurchaseIntangible: entity.jgaapGeneralPurchaseIntangible !== null ? entity.jgaapGeneralPurchaseIntangible : undefined,
    jgaapGeneralDividendsPaid: entity.jgaapGeneralDividendsPaid !== null ? entity.jgaapGeneralDividendsPaid : undefined,

    columnMissingReason: entity.columnMissingReason !== null ? Struct.fromJson(entity.columnMissingReason as any) : undefined,
  })
}

export const convertUserToProtoModel = (entity: DomainModel.User): ProtoModel.User => {
  return new ProtoModel.User({
    ...entity,

    createdAt: entity.createdAt?.toISOString() ?? '',
  })
}

export const convertUserAnalysisThreadToProtoModel = (entity: DomainModel.UserAnalysisThread): ProtoModel.UserAnalysisThread => {
  return new ProtoModel.UserAnalysisThread({
    ...entity,
    description: entity.description !== null ? entity.description : undefined,

    createdAt: entity.createdAt?.toISOString() ?? '',
    updatedAt: entity.updatedAt?.toISOString() ?? '',
  })
}

export const convertUserAnalysisThreadMessageStatusEnumToProtoModel = (enumValue: DomainModel.UserAnalysisThreadMessage['status']) => {
  switch (enumValue) {
    case 'pending':
      return ProtoModel.UserAnalysisThreadMessage_Status.PENDING
    case 'processing':
      return ProtoModel.UserAnalysisThreadMessage_Status.PROCESSING
    case 'completed':
      return ProtoModel.UserAnalysisThreadMessage_Status.COMPLETED
    case 'failed':
      return ProtoModel.UserAnalysisThreadMessage_Status.FAILED
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertUserAnalysisThreadMessageContentTypeEnumToProtoModel = (enumValue: DomainModel.UserAnalysisThreadMessage['contentType']) => {
  switch (enumValue) {
    case 'companyOverview':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.COMPANY_OVERVIEW
    case 'plHighlight':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.PL_HIGHLIGHT
    case 'bsHighlight':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.BS_HIGHLIGHT
    case 'cfHighlight':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.CF_HIGHLIGHT
    case 'executives':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.EXECUTIVES
    case 'executiveCompensation':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.EXECUTIVE_COMPENSATION
    case 'businessDescription':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.BUSINESS_DESCRIPTION
    case 'businessRisks':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.BUSINESS_RISKS
    case 'history':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.HISTORY
    case 'majorSubsidiaries':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.MAJOR_SUBSIDIARIES
    case 'offices':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.OFFICES
    case 'majorShareholders':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.MAJOR_SHAREHOLDERS
    case 'userPrompt':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.USER_PROMPT
    case 'assistant':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.ASSISTANT
    case 'summary':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.SUMMARY
    case 'securitiesReportAnalysis':
      return ProtoModel.UserAnalysisThreadMessage_ContentType.SECURITIES_REPORT_ANALYSIS
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertUserAnalysisThreadMessageToProtoModel = (entity: DomainModel.UserAnalysisThreadMessage): ProtoModel.UserAnalysisThreadMessage => {
  return new ProtoModel.UserAnalysisThreadMessage({
    ...entity,
    errorMessage: entity.errorMessage !== null ? entity.errorMessage : undefined,
    status: convertUserAnalysisThreadMessageStatusEnumToProtoModel(entity.status),
    contentType: convertUserAnalysisThreadMessageContentTypeEnumToProtoModel(entity.contentType),
    createdAt: entity.createdAt?.toISOString() ?? '',
    updatedAt: entity.updatedAt?.toISOString() ?? '',
    content: Struct.fromJson(entity.content as any),
  })
}

export const convertCompanyAvailabilityToProtoModel = (entity: DomainModel.CompanyAvailability): ProtoModel.CompanyAvailability => {
  return new ProtoModel.CompanyAvailability({
    ...entity,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
  })
}

export const convertSecuritiesReportChunkToProtoModel = (entity: DomainModel.SecuritiesReportChunk): ProtoModel.SecuritiesReportChunk => {
  return new ProtoModel.SecuritiesReportChunk({
    ...entity,
    secCode: entity.secCode !== null ? entity.secCode : undefined,
    docDescription: entity.docDescription !== null ? entity.docDescription : undefined,
    periodStart: entity.periodStart !== null ? entity.periodStart : undefined,
    periodEnd: entity.periodEnd !== null ? entity.periodEnd : undefined,
    fiscalPeriodEndYear: entity.fiscalPeriodEndYear !== null ? entity.fiscalPeriodEndYear : undefined,
    fiscalPeriodEndMonth: entity.fiscalPeriodEndMonth !== null ? entity.fiscalPeriodEndMonth : undefined,
    docTypeCode: entity.docTypeCode !== null ? entity.docTypeCode : undefined,
    filerName: entity.filerName !== null ? entity.filerName : undefined,
    ordinanceCode: entity.ordinanceCode !== null ? entity.ordinanceCode : undefined,
    formCode: entity.formCode !== null ? entity.formCode : undefined,
    errorMessage: entity.errorMessage !== null ? entity.errorMessage : undefined,
    chunkIndex: entity.chunkIndex !== null ? entity.chunkIndex : undefined,
    layer: entity.layer !== null ? entity.layer : undefined,
    parentChunkId: entity.parentChunkId !== null ? entity.parentChunkId : undefined,

    creationTime: entity.creationTime?.toISOString() ?? '',
  })
}

export const convertAiChatSessionToProtoModel = (entity: DomainModel.AiChatSession): ProtoModel.AiChatSession => {
  return new ProtoModel.AiChatSession({
    ...entity,
    description: entity.description !== null ? entity.description : undefined,

    createdAt: entity.createdAt?.toISOString() ?? '',
    updatedAt: entity.updatedAt?.toISOString() ?? '',
  })
}

export const convertAiChatEventEventTypeEnumToProtoModel = (enumValue: DomainModel.AiChatEvent['eventType']) => {
  switch (enumValue) {
    case 'userMessage':
      return ProtoModel.AiChatEvent_EventType.USER_MESSAGE
    case 'assistantMessage':
      return ProtoModel.AiChatEvent_EventType.ASSISTANT_MESSAGE
    case 'serverSideToolCall':
      return ProtoModel.AiChatEvent_EventType.SERVER_SIDE_TOOL_CALL
    case 'clientInfo':
      return ProtoModel.AiChatEvent_EventType.CLIENT_INFO
    case 'clientAction':
      return ProtoModel.AiChatEvent_EventType.CLIENT_ACTION
    case 'error':
      return ProtoModel.AiChatEvent_EventType.ERROR
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertAiChatEventPayloadJsonStatusEnumToProtoModel = (enumValue: DomainModel.AiChatEvent['payloadJsonStatus']) => {
  switch (enumValue) {
    case 'generating':
      return ProtoModel.AiChatEvent_PayloadJsonStatus.GENERATING
    case 'completed':
      return ProtoModel.AiChatEvent_PayloadJsonStatus.COMPLETED
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertAiChatEventToProtoModel = (entity: DomainModel.AiChatEvent): ProtoModel.AiChatEvent => {
  return new ProtoModel.AiChatEvent({
    ...entity,

    eventType: convertAiChatEventEventTypeEnumToProtoModel(entity.eventType),
    payloadJsonStatus: convertAiChatEventPayloadJsonStatusEnumToProtoModel(entity.payloadJsonStatus),
    createdAt: entity.createdAt?.toISOString() ?? '',
    payload: Struct.fromJson(entity.payload as any),
  })
}

export const convertNikkeiNeedsIndustryLargeToProtoModel = (entity: DomainModel.NikkeiNeedsIndustryLarge): ProtoModel.NikkeiNeedsIndustryLarge => {
  return new ProtoModel.NikkeiNeedsIndustryLarge({
    ...entity,
  })
}

export const convertNikkeiNeedsIndustryMediumToProtoModel = (entity: DomainModel.NikkeiNeedsIndustryMedium): ProtoModel.NikkeiNeedsIndustryMedium => {
  return new ProtoModel.NikkeiNeedsIndustryMedium({
    ...entity,
  })
}

export const convertNikkeiNeedsIndustrySmallToProtoModel = (entity: DomainModel.NikkeiNeedsIndustrySmall): ProtoModel.NikkeiNeedsIndustrySmall => {
  return new ProtoModel.NikkeiNeedsIndustrySmall({
    ...entity,
  })
}

export const convertCompanyToProtoModel = (entity: DomainModel.Company): ProtoModel.Company => {
  return new ProtoModel.Company({
    ...entity,
    edinetCode: entity.edinetCode !== null ? entity.edinetCode : undefined,
    englishName: entity.englishName !== null ? entity.englishName : undefined,
    cooperateSiteNewsPageUrl: entity.cooperateSiteNewsPageUrl !== null ? entity.cooperateSiteNewsPageUrl : undefined,
    industry33Name: entity.industry33Name !== null ? entity.industry33Name : undefined,
    industry17Name: entity.industry17Name !== null ? entity.industry17Name : undefined,
    description: entity.description !== null ? entity.description : undefined,
  })
}

export const convertCompanyNikkeiNeedsIndustrySmallAssignmentToProtoModel = (
  entity: DomainModel.CompanyNikkeiNeedsIndustrySmallAssignment,
): ProtoModel.CompanyNikkeiNeedsIndustrySmallAssignment => {
  return new ProtoModel.CompanyNikkeiNeedsIndustrySmallAssignment({
    ...entity,
  })
}

export const convertCompanyFiscalPeriodToProtoModel = (entity: DomainModel.CompanyFiscalPeriod): ProtoModel.CompanyFiscalPeriod => {
  return new ProtoModel.CompanyFiscalPeriod({
    ...entity,

    startAt: entity.startAt?.toISOString() ?? '',
    endAt: entity.endAt?.toISOString() ?? '',
  })
}

export const convertIrDataSourceDocumentTypeEnumToProtoModel = (enumValue: DomainModel.IrDataSource['documentType']) => {
  switch (enumValue) {
    case 'securitiesReport':
      return ProtoModel.IrDataSource_DocumentType.SECURITIES_REPORT
    case 'financialResultsPresentation':
      return ProtoModel.IrDataSource_DocumentType.FINANCIAL_RESULTS_PRESENTATION
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertIrDataSourceToProtoModel = (entity: DomainModel.IrDataSource): ProtoModel.IrDataSource => {
  return new ProtoModel.IrDataSource({
    ...entity,
    edinetDocumentId: entity.edinetDocumentId !== null ? entity.edinetDocumentId : undefined,
    documentType: convertIrDataSourceDocumentTypeEnumToProtoModel(entity.documentType),
    issuedAt: entity.issuedAt?.toISOString() ?? undefined,
  })
}

export const convertIrDataSourceFragmentToProtoModel = (entity: DomainModel.IrDataSourceFragment): ProtoModel.IrDataSourceFragment => {
  return new ProtoModel.IrDataSourceFragment({
    ...entity,
    extractedContent: entity.extractedContent !== null ? entity.extractedContent : undefined,
  })
}

export const convertReportableSegmentToProtoModel = (entity: DomainModel.ReportableSegment): ProtoModel.ReportableSegment => {
  return new ProtoModel.ReportableSegment({
    ...entity,
    companyFiscalPeriodId: entity.companyFiscalPeriodId !== null ? entity.companyFiscalPeriodId : undefined,
    extractedIrDataSourceId: entity.extractedIrDataSourceId !== null ? entity.extractedIrDataSourceId : undefined,
    irDataSourceFragmentExtractionId: entity.irDataSourceFragmentExtractionId !== null ? entity.irDataSourceFragmentExtractionId : undefined,
  })
}

export const convertFinancialIndicatorTargetTypeEnumToProtoModel = (enumValue: DomainModel.FinancialIndicator['targetType']) => {
  switch (enumValue) {
    case 'company':
      return ProtoModel.FinancialIndicator_TargetType.COMPANY
    case 'reportableSegment':
      return ProtoModel.FinancialIndicator_TargetType.REPORTABLE_SEGMENT
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertFinancialIndicatorIndicatorTypeEnumToProtoModel = (enumValue: DomainModel.FinancialIndicator['indicatorType']) => {
  switch (enumValue) {
    case 'grossSales':
      return ProtoModel.FinancialIndicator_IndicatorType.GROSS_SALES
    case 'grossProfit':
      return ProtoModel.FinancialIndicator_IndicatorType.GROSS_PROFIT
    case 'operatingProfit':
      return ProtoModel.FinancialIndicator_IndicatorType.OPERATING_PROFIT
    case 'managementProfit':
      return ProtoModel.FinancialIndicator_IndicatorType.MANAGEMENT_PROFIT
    case 'preTaxProfit':
      return ProtoModel.FinancialIndicator_IndicatorType.PRE_TAX_PROFIT
    case 'netIncome':
      return ProtoModel.FinancialIndicator_IndicatorType.NET_INCOME
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertFinancialIndicatorCurrencyEnumToProtoModel = (enumValue: DomainModel.FinancialIndicator['currency']) => {
  switch (enumValue) {
    case 'jpy':
      return ProtoModel.FinancialIndicator_Currency.JPY
    case 'usd':
      return ProtoModel.FinancialIndicator_Currency.USD
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertFinancialIndicatorUnitEnumToProtoModel = (enumValue: DomainModel.FinancialIndicator['unit']) => {
  switch (enumValue) {
    case 'one':
      return ProtoModel.FinancialIndicator_Unit.ONE
    case 'thousand':
      return ProtoModel.FinancialIndicator_Unit.THOUSAND
    case 'million':
      return ProtoModel.FinancialIndicator_Unit.MILLION
    case 'billion':
      return ProtoModel.FinancialIndicator_Unit.BILLION
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertFinancialIndicatorToProtoModel = (entity: DomainModel.FinancialIndicator): ProtoModel.FinancialIndicator => {
  return new ProtoModel.FinancialIndicator({
    ...entity,
    reportableSegmentId: entity.reportableSegmentId !== null ? entity.reportableSegmentId : undefined,
    extractedIrDataSourceId: entity.extractedIrDataSourceId !== null ? entity.extractedIrDataSourceId : undefined,
    irDataSourceFragmentExtractionId: entity.irDataSourceFragmentExtractionId !== null ? entity.irDataSourceFragmentExtractionId : undefined,
    yoyChangePercentage: entity.yoyChangePercentage !== null ? entity.yoyChangePercentage : undefined,
    targetType: convertFinancialIndicatorTargetTypeEnumToProtoModel(entity.targetType),
    indicatorType: convertFinancialIndicatorIndicatorTypeEnumToProtoModel(entity.indicatorType),
    currency: convertFinancialIndicatorCurrencyEnumToProtoModel(entity.currency),
    unit: convertFinancialIndicatorUnitEnumToProtoModel(entity.unit),
  })
}

export const convertUserAnalysisQueryToProtoModel = (entity: DomainModel.UserAnalysisQuery): ProtoModel.UserAnalysisQuery => {
  return new ProtoModel.UserAnalysisQuery({
    ...entity,

    requestedAt: entity.requestedAt?.toISOString() ?? '',

    summaryAnalysisResultCache: entity.summaryAnalysisResultCache !== null ? Struct.fromJson(entity.summaryAnalysisResultCache as any) : undefined,
    analysisResultWidetsCache: entity.analysisResultWidetsCache !== null ? Struct.fromJson(entity.analysisResultWidetsCache as any) : undefined,
  })
}

export const convertFinancialIndicatorFactorToProtoModel = (entity: DomainModel.FinancialIndicatorFactor): ProtoModel.FinancialIndicatorFactor => {
  return new ProtoModel.FinancialIndicatorFactor({
    ...entity,
    irDataSourceFragmentExtractionId: entity.irDataSourceFragmentExtractionId !== null ? entity.irDataSourceFragmentExtractionId : undefined,
  })
}

export const convertReportableSegmentCompanyFiscalPeriodAppearanceToProtoModel = (
  entity: DomainModel.ReportableSegmentCompanyFiscalPeriodAppearance,
): ProtoModel.ReportableSegmentCompanyFiscalPeriodAppearance => {
  return new ProtoModel.ReportableSegmentCompanyFiscalPeriodAppearance({
    ...entity,
  })
}

export const convertMediumTermManagementPlanToProtoModel = (entity: DomainModel.MediumTermManagementPlan): ProtoModel.MediumTermManagementPlan => {
  return new ProtoModel.MediumTermManagementPlan({
    ...entity,
    startFiscalYear: entity.startFiscalYear !== null ? entity.startFiscalYear : undefined,
    endFiscalYear: entity.endFiscalYear !== null ? entity.endFiscalYear : undefined,
  })
}

export const convertMediumTermManagementPlanObjectiveToProtoModel = (
  entity: DomainModel.MediumTermManagementPlanObjective,
): ProtoModel.MediumTermManagementPlanObjective => {
  return new ProtoModel.MediumTermManagementPlanObjective({
    ...entity,
  })
}

export const convertMediumTermManagementPlanFocusPointToProtoModel = (
  entity: DomainModel.MediumTermManagementPlanFocusPoint,
): ProtoModel.MediumTermManagementPlanFocusPoint => {
  return new ProtoModel.MediumTermManagementPlanFocusPoint({
    ...entity,
  })
}

export const convertMediumTermManagementPlanFocusPointCaseToProtoModel = (
  entity: DomainModel.MediumTermManagementPlanFocusPointCase,
): ProtoModel.MediumTermManagementPlanFocusPointCase => {
  return new ProtoModel.MediumTermManagementPlanFocusPointCase({
    ...entity,
  })
}

export const convertIrDataSourceFragmentExtractionExtractedFactTypeEnumToProtoModel = (
  enumValue: DomainModel.IrDataSourceFragmentExtraction['extractedFactType'],
) => {
  switch (enumValue) {
    case 'reportableSegment':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.REPORTABLE_SEGMENT
    case 'reportableSegmentCompanyFiscalPeriodAppearance':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.REPORTABLE_SEGMENT_COMPANY_FISCAL_PERIOD_APPEARANCE
    case 'financialIndicator':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.FINANCIAL_INDICATOR
    case 'financialIndicatorFactor':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.FINANCIAL_INDICATOR_FACTOR
    case 'mediumTermManagementPlan':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.MEDIUM_TERM_MANAGEMENT_PLAN
    case 'mediumTermManagementPlanObjective':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.MEDIUM_TERM_MANAGEMENT_PLAN_OBJECTIVE
    case 'mediumTermManagementPlanFocusPoint':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT
    case 'mediumTermManagementPlanFocusPointCase':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT_CASE
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertIrDataSourceFragmentExtractionExtractionMethodEnumToProtoModel = (
  enumValue: DomainModel.IrDataSourceFragmentExtraction['extractionMethod'],
) => {
  switch (enumValue) {
    case 'visionLlm':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractionMethod.VISION_LLM
    case 'parseXbrl':
      return ProtoModel.IrDataSourceFragmentExtraction_ExtractionMethod.PARSE_XBRL
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}

export const convertIrDataSourceFragmentExtractionToProtoModel = (
  entity: DomainModel.IrDataSourceFragmentExtraction,
): ProtoModel.IrDataSourceFragmentExtraction => {
  return new ProtoModel.IrDataSourceFragmentExtraction({
    ...entity,
    model: entity.model !== null ? entity.model : undefined,
    extractedFactType: convertIrDataSourceFragmentExtractionExtractedFactTypeEnumToProtoModel(entity.extractedFactType),
    extractionMethod: convertIrDataSourceFragmentExtractionExtractionMethodEnumToProtoModel(entity.extractionMethod),
    extractedAt: entity.extractedAt?.toISOString() ?? '',
  })
}

export const convertPressReleaseToProtoModel = (entity: DomainModel.PressRelease): ProtoModel.PressRelease => {
  return new ProtoModel.PressRelease({
    ...entity,

    releasedAt: entity.releasedAt?.toISOString() ?? '',
  })
}

// From ProtoModel to DomainModel

export const convertUsecaseTableCompanyOverviewToDomainModel = (entity: ProtoModel.UsecaseTableCompanyOverview): DomainModel.UsecaseTableCompanyOverview => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    companyNameJa: entity.companyNameJa !== undefined ? entity.companyNameJa : null,
    companyNameEn: entity.companyNameEn !== undefined ? entity.companyNameEn : null,
    headQuaterAddress: entity.headQuaterAddress !== undefined ? entity.headQuaterAddress : null,
    presidentRole: entity.presidentRole !== undefined ? entity.presidentRole : null,
    presidentName: entity.presidentName !== undefined ? entity.presidentName : null,
    phoneNumber: entity.phoneNumber !== undefined ? entity.phoneNumber : null,
    consolidatedEmployees: entity.consolidatedEmployees !== undefined ? entity.consolidatedEmployees : null,
    consolidatedSubsidiariesCount: entity.consolidatedSubsidiariesCount !== undefined ? entity.consolidatedSubsidiariesCount : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTablePlHighlightToDomainModel = (entity: ProtoModel.UsecaseTablePlHighlight): DomainModel.UsecaseTablePlHighlight => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    unit: entity.unit !== undefined ? entity.unit : null,
    unitText: entity.unitText !== undefined ? entity.unitText : null,
    revenueJpy: entity.revenueJpy !== undefined ? entity.revenueJpy : null,
    costOfSalesJpy: entity.costOfSalesJpy !== undefined ? entity.costOfSalesJpy : null,
    grossProfitJpy: entity.grossProfitJpy !== undefined ? entity.grossProfitJpy : null,
    sellingGeneralAdminExpensesJpy: entity.sellingGeneralAdminExpensesJpy !== undefined ? entity.sellingGeneralAdminExpensesJpy : null,
    operatingProfitJpy: entity.operatingProfitJpy !== undefined ? entity.operatingProfitJpy : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableBsHighlightToDomainModel = (entity: ProtoModel.UsecaseTableBsHighlight): DomainModel.UsecaseTableBsHighlight => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    unit: entity.unit !== undefined ? entity.unit : null,
    unitText: entity.unitText !== undefined ? entity.unitText : null,
    cashAndDepositsJpy: entity.cashAndDepositsJpy !== undefined ? entity.cashAndDepositsJpy : null,
    accountsReceivableJpy: entity.accountsReceivableJpy !== undefined ? entity.accountsReceivableJpy : null,
    inventoriesJpy: entity.inventoriesJpy !== undefined ? entity.inventoriesJpy : null,
    propertyPlantEquipmentJpy: entity.propertyPlantEquipmentJpy !== undefined ? entity.propertyPlantEquipmentJpy : null,
    totalAssetsJpy: entity.totalAssetsJpy !== undefined ? entity.totalAssetsJpy : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableCfHighlightToDomainModel = (entity: ProtoModel.UsecaseTableCfHighlight): DomainModel.UsecaseTableCfHighlight => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    unit: entity.unit !== undefined ? entity.unit : null,
    unitText: entity.unitText !== undefined ? entity.unitText : null,
    operatingCfJpy: entity.operatingCfJpy !== undefined ? entity.operatingCfJpy : null,
    investingCfJpy: entity.investingCfJpy !== undefined ? entity.investingCfJpy : null,
    financingCfJpy: entity.financingCfJpy !== undefined ? entity.financingCfJpy : null,
    cashEoyJpy: entity.cashEoyJpy !== undefined ? entity.cashEoyJpy : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableFundamentalsBasicToDomainModel = (
  entity: ProtoModel.UsecaseTableFundamentalsBasic,
): DomainModel.UsecaseTableFundamentalsBasic => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    totalCapitalEtc: entity.totalCapitalEtc !== undefined ? entity.totalCapitalEtc : null,
    capitalSurplus: entity.capitalSurplus !== undefined ? entity.capitalSurplus : null,
    shareholdersEquity: entity.shareholdersEquity !== undefined ? entity.shareholdersEquity : null,
    ownersEquityOld: entity.ownersEquityOld !== undefined ? entity.ownersEquityOld : null,
    salesGrowthRate: entity.salesGrowthRate !== undefined ? entity.salesGrowthRate : null,
    cashAndCashEquivalents: entity.cashAndCashEquivalents !== undefined ? entity.cashAndCashEquivalents : null,
    interestBearingDebt: entity.interestBearingDebt !== undefined ? entity.interestBearingDebt : null,
    netInterestBearingDebt: entity.netInterestBearingDebt !== undefined ? entity.netInterestBearingDebt : null,
    netInterestBearingDebtExclSecurities: entity.netInterestBearingDebtExclSecurities !== undefined ? entity.netInterestBearingDebtExclSecurities : null,
    capexCfTangible: entity.capexCfTangible !== undefined ? entity.capexCfTangible : null,
    capexCfTangibleIntangible: entity.capexCfTangibleIntangible !== undefined ? entity.capexCfTangibleIntangible : null,
    investedCapital: entity.investedCapital !== undefined ? entity.investedCapital : null,
    businessAssets: entity.businessAssets !== undefined ? entity.businessAssets : null,
    workingCapital: entity.workingCapital !== undefined ? entity.workingCapital : null,
    ebit: entity.ebit !== undefined ? entity.ebit : null,
    ebitda: entity.ebitda !== undefined ? entity.ebitda : null,
    nopat: entity.nopat !== undefined ? entity.nopat : null,
    freeCashFlow: entity.freeCashFlow !== undefined ? entity.freeCashFlow : null,
    personnelExpensesTotal: entity.personnelExpensesTotal !== undefined ? entity.personnelExpensesTotal : null,
    personnelExpenses: entity.personnelExpenses !== undefined ? entity.personnelExpenses : null,
    laborCost: entity.laborCost !== undefined ? entity.laborCost : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableFundamentalsGrowthToDomainModel = (
  entity: ProtoModel.UsecaseTableFundamentalsGrowth,
): DomainModel.UsecaseTableFundamentalsGrowth => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    salesGrowthRate: entity.salesGrowthRate !== undefined ? entity.salesGrowthRate : null,
    operatingProfitGrowthRate: entity.operatingProfitGrowthRate !== undefined ? entity.operatingProfitGrowthRate : null,
    ordinaryProfitGrowthRate: entity.ordinaryProfitGrowthRate !== undefined ? entity.ordinaryProfitGrowthRate : null,
    netProfitGrowthRate: entity.netProfitGrowthRate !== undefined ? entity.netProfitGrowthRate : null,
    ebitdaGrowthRate: entity.ebitdaGrowthRate !== undefined ? entity.ebitdaGrowthRate : null,
    epsGrowthRate: entity.epsGrowthRate !== undefined ? entity.epsGrowthRate : null,
    dilutedEpsGrowthRate: entity.dilutedEpsGrowthRate !== undefined ? entity.dilutedEpsGrowthRate : null,
    totalAssetsGrowthRate: entity.totalAssetsGrowthRate !== undefined ? entity.totalAssetsGrowthRate : null,
    employeesGrowthRate: entity.employeesGrowthRate !== undefined ? entity.employeesGrowthRate : null,
    sgaGrowthRate: entity.sgaGrowthRate !== undefined ? entity.sgaGrowthRate : null,
    personnelExpensesGrowthRate: entity.personnelExpensesGrowthRate !== undefined ? entity.personnelExpensesGrowthRate : null,
    advertisingExpensesGrowthRate: entity.advertisingExpensesGrowthRate !== undefined ? entity.advertisingExpensesGrowthRate : null,
    rdExpensesGrowthRate: entity.rdExpensesGrowthRate !== undefined ? entity.rdExpensesGrowthRate : null,
    capexGrowthRate: entity.capexGrowthRate !== undefined ? entity.capexGrowthRate : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableFundamentalsProfitabilityToDomainModel = (
  entity: ProtoModel.UsecaseTableFundamentalsProfitability,
): DomainModel.UsecaseTableFundamentalsProfitability => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    grossProfitMargin: entity.grossProfitMargin !== undefined ? entity.grossProfitMargin : null,
    sgaRatio: entity.sgaRatio !== undefined ? entity.sgaRatio : null,
    operatingProfitMargin: entity.operatingProfitMargin !== undefined ? entity.operatingProfitMargin : null,
    ordinaryProfitMargin: entity.ordinaryProfitMargin !== undefined ? entity.ordinaryProfitMargin : null,
    pretaxProfitMargin: entity.pretaxProfitMargin !== undefined ? entity.pretaxProfitMargin : null,
    netProfitMargin: entity.netProfitMargin !== undefined ? entity.netProfitMargin : null,
    parentNetProfitMargin: entity.parentNetProfitMargin !== undefined ? entity.parentNetProfitMargin : null,
    comprehensiveIncomeMargin: entity.comprehensiveIncomeMargin !== undefined ? entity.comprehensiveIncomeMargin : null,
    ebitdaMargin: entity.ebitdaMargin !== undefined ? entity.ebitdaMargin : null,
    operatingCfMargin: entity.operatingCfMargin !== undefined ? entity.operatingCfMargin : null,
    costOfSalesRatio: entity.costOfSalesRatio !== undefined ? entity.costOfSalesRatio : null,
    personnelExpensesRatio: entity.personnelExpensesRatio !== undefined ? entity.personnelExpensesRatio : null,
    personnelExpensesSgaRatio: entity.personnelExpensesSgaRatio !== undefined ? entity.personnelExpensesSgaRatio : null,
    laborCostRatio: entity.laborCostRatio !== undefined ? entity.laborCostRatio : null,
    rdRatio: entity.rdRatio !== undefined ? entity.rdRatio : null,
    rentRatio: entity.rentRatio !== undefined ? entity.rentRatio : null,
    advertisingRatio: entity.advertisingRatio !== undefined ? entity.advertisingRatio : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableFundamentalsProductivityToDomainModel = (
  entity: ProtoModel.UsecaseTableFundamentalsProductivity,
): DomainModel.UsecaseTableFundamentalsProductivity => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    salesPerEmployee: entity.salesPerEmployee !== undefined ? entity.salesPerEmployee : null,
    operatingProfitPerEmployee: entity.operatingProfitPerEmployee !== undefined ? entity.operatingProfitPerEmployee : null,
    ordinaryProfitPerEmployee: entity.ordinaryProfitPerEmployee !== undefined ? entity.ordinaryProfitPerEmployee : null,
    netProfitPerEmployee: entity.netProfitPerEmployee !== undefined ? entity.netProfitPerEmployee : null,
    operatingCfPerEmployee: entity.operatingCfPerEmployee !== undefined ? entity.operatingCfPerEmployee : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableFundamentalsEfficiencyToDomainModel = (
  entity: ProtoModel.UsecaseTableFundamentalsEfficiency,
): DomainModel.UsecaseTableFundamentalsEfficiency => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    roe: entity.roe !== undefined ? entity.roe : null,
    roa: entity.roa !== undefined ? entity.roa : null,
    roicInvestedCapital: entity.roicInvestedCapital !== undefined ? entity.roicInvestedCapital : null,
    roicBusinessAssets: entity.roicBusinessAssets !== undefined ? entity.roicBusinessAssets : null,
    totalAssetsOrdinaryProfitRatio: entity.totalAssetsOrdinaryProfitRatio !== undefined ? entity.totalAssetsOrdinaryProfitRatio : null,
    totalAssetsTurnover: entity.totalAssetsTurnover !== undefined ? entity.totalAssetsTurnover : null,
    receivablesTurnover: entity.receivablesTurnover !== undefined ? entity.receivablesTurnover : null,
    inventoryTurnover: entity.inventoryTurnover !== undefined ? entity.inventoryTurnover : null,
    payablesTurnover: entity.payablesTurnover !== undefined ? entity.payablesTurnover : null,
    advancePaymentsTurnover: entity.advancePaymentsTurnover !== undefined ? entity.advancePaymentsTurnover : null,
    prepaidExpensesTurnover: entity.prepaidExpensesTurnover !== undefined ? entity.prepaidExpensesTurnover : null,
    advancesReceivedTurnover: entity.advancesReceivedTurnover !== undefined ? entity.advancesReceivedTurnover : null,
    deferredRevenueTurnover: entity.deferredRevenueTurnover !== undefined ? entity.deferredRevenueTurnover : null,
    receivablesTurnoverPeriod: entity.receivablesTurnoverPeriod !== undefined ? entity.receivablesTurnoverPeriod : null,
    inventoryTurnoverPeriod: entity.inventoryTurnoverPeriod !== undefined ? entity.inventoryTurnoverPeriod : null,
    payablesTurnoverPeriod: entity.payablesTurnoverPeriod !== undefined ? entity.payablesTurnoverPeriod : null,
    advancePaymentsTurnoverPeriod: entity.advancePaymentsTurnoverPeriod !== undefined ? entity.advancePaymentsTurnoverPeriod : null,
    prepaidExpensesTurnoverPeriod: entity.prepaidExpensesTurnoverPeriod !== undefined ? entity.prepaidExpensesTurnoverPeriod : null,
    advancesReceivedTurnoverPeriod: entity.advancesReceivedTurnoverPeriod !== undefined ? entity.advancesReceivedTurnoverPeriod : null,
    deferredRevenueTurnoverPeriod: entity.deferredRevenueTurnoverPeriod !== undefined ? entity.deferredRevenueTurnoverPeriod : null,
    ccc: entity.ccc !== undefined ? entity.ccc : null,
    cccAdjusted: entity.cccAdjusted !== undefined ? entity.cccAdjusted : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableFundamentalsSafetyLeverageToDomainModel = (
  entity: ProtoModel.UsecaseTableFundamentalsSafetyLeverage,
): DomainModel.UsecaseTableFundamentalsSafetyLeverage => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    equityRatio: entity.equityRatio !== undefined ? entity.equityRatio : null,
    financialLeverage: entity.financialLeverage !== undefined ? entity.financialLeverage : null,
    deRatio: entity.deRatio !== undefined ? entity.deRatio : null,
    netDeRatio: entity.netDeRatio !== undefined ? entity.netDeRatio : null,
    debtEbitdaRatio: entity.debtEbitdaRatio !== undefined ? entity.debtEbitdaRatio : null,
    netDebtEbitdaRatio: entity.netDebtEbitdaRatio !== undefined ? entity.netDebtEbitdaRatio : null,
    debtOperatingCfRatio: entity.debtOperatingCfRatio !== undefined ? entity.debtOperatingCfRatio : null,
    netDebtOperatingCfRatio: entity.netDebtOperatingCfRatio !== undefined ? entity.netDebtOperatingCfRatio : null,
    debtFcfRatio: entity.debtFcfRatio !== undefined ? entity.debtFcfRatio : null,
    netDebtFcfRatio: entity.netDebtFcfRatio !== undefined ? entity.netDebtFcfRatio : null,
    interestCoverageRatio: entity.interestCoverageRatio !== undefined ? entity.interestCoverageRatio : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableFundamentalsLiquidityToDomainModel = (
  entity: ProtoModel.UsecaseTableFundamentalsLiquidity,
): DomainModel.UsecaseTableFundamentalsLiquidity => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    currentRatio: entity.currentRatio !== undefined ? entity.currentRatio : null,
    quickRatio: entity.quickRatio !== undefined ? entity.quickRatio : null,
    fixedRatio: entity.fixedRatio !== undefined ? entity.fixedRatio : null,
    fixedRatioTangible: entity.fixedRatioTangible !== undefined ? entity.fixedRatioTangible : null,
    cashToAssetsRatio: entity.cashToAssetsRatio !== undefined ? entity.cashToAssetsRatio : null,
    assetAgingRatio: entity.assetAgingRatio !== undefined ? entity.assetAgingRatio : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableFundamentalsShareholderReturnToDomainModel = (
  entity: ProtoModel.UsecaseTableFundamentalsShareholderReturn,
): DomainModel.UsecaseTableFundamentalsShareholderReturn => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    payoutRatio: entity.payoutRatio !== undefined ? entity.payoutRatio : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    calculationDependency:
      entity.calculationDependency !== undefined
        ? (() => {
            if (!entity.calculationDependency) throw new Error('Struct is null')
            const result = entity.calculationDependency.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableExecutiveOverviewToDomainModel = (
  entity: ProtoModel.UsecaseTableExecutiveOverview,
): DomainModel.UsecaseTableExecutiveOverview => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    totalNumberOfExecutives: entity.totalNumberOfExecutives !== undefined ? entity.totalNumberOfExecutives : null,
    numberOfMaleExecutives: entity.numberOfMaleExecutives !== undefined ? entity.numberOfMaleExecutives : null,
    ratioOfMaleExecutives: entity.ratioOfMaleExecutives !== undefined ? entity.ratioOfMaleExecutives : null,
    numberOfFemaleExecutives: entity.numberOfFemaleExecutives !== undefined ? entity.numberOfFemaleExecutives : null,
    ratioOfFemaleExecutives: entity.ratioOfFemaleExecutives !== undefined ? entity.ratioOfFemaleExecutives : null,
    numberOfExternalExecutives: entity.numberOfExternalExecutives !== undefined ? entity.numberOfExternalExecutives : null,
    ratioOfExternalExecutives: entity.ratioOfExternalExecutives !== undefined ? entity.ratioOfExternalExecutives : null,
    averageAgeOfExecutives: entity.averageAgeOfExecutives !== undefined ? entity.averageAgeOfExecutives : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableExecutivesToDomainModel = (entity: ProtoModel.UsecaseTableExecutives): DomainModel.UsecaseTableExecutives => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    appearanceIndex: entity.appearanceIndex !== undefined ? entity.appearanceIndex : null,
    title: entity.title !== undefined ? entity.title : null,
    name: entity.name !== undefined ? entity.name : null,
    birthDay: entity.birthDay !== undefined ? entity.birthDay : null,
    sharesOwned: entity.sharesOwned !== undefined ? entity.sharesOwned : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableExecutiveCompensationToDomainModel = (
  entity: ProtoModel.UsecaseTableExecutiveCompensation,
): DomainModel.UsecaseTableExecutiveCompensation => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    appearanceIndex: entity.appearanceIndex !== undefined ? entity.appearanceIndex : null,
    unit: entity.unit !== undefined ? entity.unit : null,
    unitText: entity.unitText !== undefined ? entity.unitText : null,
    titleSegment: entity.titleSegment !== undefined ? entity.titleSegment : null,
    name: entity.name !== undefined ? entity.name : null,
    totalCompensation: entity.totalCompensation !== undefined ? entity.totalCompensation : null,
    numberOfOfficers: entity.numberOfOfficers !== undefined ? entity.numberOfOfficers : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableBusinessDescriptionToDomainModel = (
  entity: ProtoModel.UsecaseTableBusinessDescription,
): DomainModel.UsecaseTableBusinessDescription => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    summary: entity.summary !== undefined ? entity.summary : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableBusinessRisksToDomainModel = (entity: ProtoModel.UsecaseTableBusinessRisks): DomainModel.UsecaseTableBusinessRisks => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    appearanceIndex: entity.appearanceIndex !== undefined ? entity.appearanceIndex : null,
    category: entity.category !== undefined ? entity.category : null,
    title: entity.title !== undefined ? entity.title : null,
    contentSummary: entity.contentSummary !== undefined ? entity.contentSummary : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableHistoryToDomainModel = (entity: ProtoModel.UsecaseTableHistory): DomainModel.UsecaseTableHistory => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    appearanceIndex: entity.appearanceIndex !== undefined ? entity.appearanceIndex : null,
    year: entity.year !== undefined ? entity.year : null,
    month: entity.month !== undefined ? entity.month : null,
    event: entity.event !== undefined ? entity.event : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableMajorSubsidiariesToDomainModel = (
  entity: ProtoModel.UsecaseTableMajorSubsidiaries,
): DomainModel.UsecaseTableMajorSubsidiaries => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    appearanceIndex: entity.appearanceIndex !== undefined ? entity.appearanceIndex : null,
    companyName: entity.companyName !== undefined ? entity.companyName : null,
    relationship: entity.relationship !== undefined ? entity.relationship : null,
    address: entity.address !== undefined ? entity.address : null,
    capitalJpy: entity.capitalJpy !== undefined ? entity.capitalJpy : null,
    businessDescription: entity.businessDescription !== undefined ? entity.businessDescription : null,
    percentageOwned: entity.percentageOwned !== undefined ? entity.percentageOwned : null,
    relationshipDetails: entity.relationshipDetails !== undefined ? entity.relationshipDetails : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableOfficesToDomainModel = (entity: ProtoModel.UsecaseTableOffices): DomainModel.UsecaseTableOffices => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    appearanceIndex: entity.appearanceIndex !== undefined ? entity.appearanceIndex : null,
    officeName: entity.officeName !== undefined ? entity.officeName : null,
    address: entity.address !== undefined ? entity.address : null,
    businessSegmentName: entity.businessSegmentName !== undefined ? entity.businessSegmentName : null,
    facilitiesSummary: entity.facilitiesSummary !== undefined ? entity.facilitiesSummary : null,
    bookValueUnit: entity.bookValueUnit !== undefined ? entity.bookValueUnit : null,
    bookValueLandJpy: entity.bookValueLandJpy !== undefined ? entity.bookValueLandJpy : null,
    landArea: entity.landArea !== undefined ? entity.landArea : null,
    landAreaUnit: entity.landAreaUnit !== undefined ? entity.landAreaUnit : null,
    bookValueBuildingJpy: entity.bookValueBuildingJpy !== undefined ? entity.bookValueBuildingJpy : null,
    bookValueMachineryVehiclesEquipmentJpy: entity.bookValueMachineryVehiclesEquipmentJpy !== undefined ? entity.bookValueMachineryVehiclesEquipmentJpy : null,
    bookValueTotalJpy: entity.bookValueTotalJpy !== undefined ? entity.bookValueTotalJpy : null,
    numberOfEmployees: entity.numberOfEmployees !== undefined ? entity.numberOfEmployees : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableMajorShareholdersToDomainModel = (
  entity: ProtoModel.UsecaseTableMajorShareholders,
): DomainModel.UsecaseTableMajorShareholders => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    appearanceIndex: entity.appearanceIndex !== undefined ? entity.appearanceIndex : null,
    name: entity.name !== undefined ? entity.name : null,
    address: entity.address !== undefined ? entity.address : null,
    sharesOwned: entity.sharesOwned !== undefined ? entity.sharesOwned : null,
    sharesOwnedUnit: entity.sharesOwnedUnit !== undefined ? entity.sharesOwnedUnit : null,
    percentageOfTotalShares: entity.percentageOfTotalShares !== undefined ? entity.percentageOfTotalShares : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableKeyManagementIndicatorsConsolidatedToDomainModel = (
  entity: ProtoModel.UsecaseTableKeyManagementIndicatorsConsolidated,
): DomainModel.UsecaseTableKeyManagementIndicatorsConsolidated => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    fiscalYear: entity.fiscalYear !== undefined ? entity.fiscalYear : null,
    revenue: entity.revenue !== undefined ? entity.revenue : null,
    ordinaryIncomeLoss: entity.ordinaryIncomeLoss !== undefined ? entity.ordinaryIncomeLoss : null,
    netIncomeLossAttributableToOwnersOfParent:
      entity.netIncomeLossAttributableToOwnersOfParent !== undefined ? entity.netIncomeLossAttributableToOwnersOfParent : null,
    comprehensiveIncome: entity.comprehensiveIncome !== undefined ? entity.comprehensiveIncome : null,
    netAssets: entity.netAssets !== undefined ? entity.netAssets : null,
    totalAssets: entity.totalAssets !== undefined ? entity.totalAssets : null,
    netAssetsPerShare: entity.netAssetsPerShare !== undefined ? entity.netAssetsPerShare : null,
    netIncomeLossPerShare: entity.netIncomeLossPerShare !== undefined ? entity.netIncomeLossPerShare : null,
    dilutedNetIncomePerShare: entity.dilutedNetIncomePerShare !== undefined ? entity.dilutedNetIncomePerShare : null,
    equityRatio: entity.equityRatio !== undefined ? entity.equityRatio : null,
    returnOnEquity: entity.returnOnEquity !== undefined ? entity.returnOnEquity : null,
    priceEarningsRatio: entity.priceEarningsRatio !== undefined ? entity.priceEarningsRatio : null,
    cashFlowsFromOperatingActivities: entity.cashFlowsFromOperatingActivities !== undefined ? entity.cashFlowsFromOperatingActivities : null,
    cashFlowsFromInvestingActivities: entity.cashFlowsFromInvestingActivities !== undefined ? entity.cashFlowsFromInvestingActivities : null,
    cashFlowsFromFinancingActivities: entity.cashFlowsFromFinancingActivities !== undefined ? entity.cashFlowsFromFinancingActivities : null,
    cashAndCashEquivalentsEndOfPeriod: entity.cashAndCashEquivalentsEndOfPeriod !== undefined ? entity.cashAndCashEquivalentsEndOfPeriod : null,
    numberOfEmployees: entity.numberOfEmployees !== undefined ? entity.numberOfEmployees : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableKeyManagementIndicatorsNonConsolidatedToDomainModel = (
  entity: ProtoModel.UsecaseTableKeyManagementIndicatorsNonConsolidated,
): DomainModel.UsecaseTableKeyManagementIndicatorsNonConsolidated => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    fiscalYear: entity.fiscalYear !== undefined ? entity.fiscalYear : null,
    revenue: entity.revenue !== undefined ? entity.revenue : null,
    ordinaryIncomeLoss: entity.ordinaryIncomeLoss !== undefined ? entity.ordinaryIncomeLoss : null,
    netIncomeLossAttributableToOwnersOfParent:
      entity.netIncomeLossAttributableToOwnersOfParent !== undefined ? entity.netIncomeLossAttributableToOwnersOfParent : null,
    comprehensiveIncome: entity.comprehensiveIncome !== undefined ? entity.comprehensiveIncome : null,
    netAssets: entity.netAssets !== undefined ? entity.netAssets : null,
    totalAssets: entity.totalAssets !== undefined ? entity.totalAssets : null,
    netAssetsPerShare: entity.netAssetsPerShare !== undefined ? entity.netAssetsPerShare : null,
    netIncomeLossPerShare: entity.netIncomeLossPerShare !== undefined ? entity.netIncomeLossPerShare : null,
    dilutedNetIncomePerShare: entity.dilutedNetIncomePerShare !== undefined ? entity.dilutedNetIncomePerShare : null,
    equityRatio: entity.equityRatio !== undefined ? entity.equityRatio : null,
    returnOnEquity: entity.returnOnEquity !== undefined ? entity.returnOnEquity : null,
    priceEarningsRatio: entity.priceEarningsRatio !== undefined ? entity.priceEarningsRatio : null,
    cashFlowsFromOperatingActivities: entity.cashFlowsFromOperatingActivities !== undefined ? entity.cashFlowsFromOperatingActivities : null,
    cashFlowsFromInvestingActivities: entity.cashFlowsFromInvestingActivities !== undefined ? entity.cashFlowsFromInvestingActivities : null,
    cashFlowsFromFinancingActivities: entity.cashFlowsFromFinancingActivities !== undefined ? entity.cashFlowsFromFinancingActivities : null,
    cashAndCashEquivalentsEndOfPeriod: entity.cashAndCashEquivalentsEndOfPeriod !== undefined ? entity.cashAndCashEquivalentsEndOfPeriod : null,
    numberOfEmployees: entity.numberOfEmployees !== undefined ? entity.numberOfEmployees : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTablePlFullToDomainModel = (entity: ProtoModel.UsecaseTablePlFull): DomainModel.UsecaseTablePlFull => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    accountingStandard: entity.accountingStandard !== undefined ? entity.accountingStandard : null,
    unit: entity.unit !== undefined ? entity.unit : null,
    unitText: entity.unitText !== undefined ? entity.unitText : null,
    highlightRevenueJpy: entity.highlightRevenueJpy !== undefined ? entity.highlightRevenueJpy : null,
    highlightCostOfSalesJpy: entity.highlightCostOfSalesJpy !== undefined ? entity.highlightCostOfSalesJpy : null,
    highlightGrossProfitJpy: entity.highlightGrossProfitJpy !== undefined ? entity.highlightGrossProfitJpy : null,
    highlightSellingGeneralAdminExpensesJpy:
      entity.highlightSellingGeneralAdminExpensesJpy !== undefined ? entity.highlightSellingGeneralAdminExpensesJpy : null,
    highlightOperatingProfitJpy: entity.highlightOperatingProfitJpy !== undefined ? entity.highlightOperatingProfitJpy : null,
    ifrsGeneralRevenue: entity.ifrsGeneralRevenue !== undefined ? entity.ifrsGeneralRevenue : null,
    ifrsGeneralGainsAndLossesFromDerecOfFaAtAc:
      entity.ifrsGeneralGainsAndLossesFromDerecOfFaAtAc !== undefined ? entity.ifrsGeneralGainsAndLossesFromDerecOfFaAtAc : null,
    ifrsGeneralFinanceCosts: entity.ifrsGeneralFinanceCosts !== undefined ? entity.ifrsGeneralFinanceCosts : null,
    ifrsGeneralShareOfPolOfAjvUsingEquityMethod:
      entity.ifrsGeneralShareOfPolOfAjvUsingEquityMethod !== undefined ? entity.ifrsGeneralShareOfPolOfAjvUsingEquityMethod : null,
    ifrsGeneralGainsAndLossesFromDiffBetweenPrevAcAndFv:
      entity.ifrsGeneralGainsAndLossesFromDiffBetweenPrevAcAndFv !== undefined ? entity.ifrsGeneralGainsAndLossesFromDiffBetweenPrevAcAndFv : null,
    ifrsGeneralTaxExpense: entity.ifrsGeneralTaxExpense !== undefined ? entity.ifrsGeneralTaxExpense : null,
    ifrsGeneralDiscontinuedOperations: entity.ifrsGeneralDiscontinuedOperations !== undefined ? entity.ifrsGeneralDiscontinuedOperations : null,
    ifrsGeneralProfitOrLoss: entity.ifrsGeneralProfitOrLoss !== undefined ? entity.ifrsGeneralProfitOrLoss : null,
    ifrsGeneralPolAttrToOwnersOfParent: entity.ifrsGeneralPolAttrToOwnersOfParent !== undefined ? entity.ifrsGeneralPolAttrToOwnersOfParent : null,
    ifrsGeneralPolAttrToNci: entity.ifrsGeneralPolAttrToNci !== undefined ? entity.ifrsGeneralPolAttrToNci : null,
    ifrsGeneralItemsNotReclassifiedSubsequentlyToPol:
      entity.ifrsGeneralItemsNotReclassifiedSubsequentlyToPol !== undefined ? entity.ifrsGeneralItemsNotReclassifiedSubsequentlyToPol : null,
    ifrsGeneralItemsReclassifiedSubsequentlyToPol:
      entity.ifrsGeneralItemsReclassifiedSubsequentlyToPol !== undefined ? entity.ifrsGeneralItemsReclassifiedSubsequentlyToPol : null,
    ifrsGeneralShareOfOciOfAjv: entity.ifrsGeneralShareOfOciOfAjv !== undefined ? entity.ifrsGeneralShareOfOciOfAjv : null,
    ifrsGeneralTotalOtherComprehensiveIncome:
      entity.ifrsGeneralTotalOtherComprehensiveIncome !== undefined ? entity.ifrsGeneralTotalOtherComprehensiveIncome : null,
    ifrsGeneralTotalComprehensiveIncomeForThePeriod:
      entity.ifrsGeneralTotalComprehensiveIncomeForThePeriod !== undefined ? entity.ifrsGeneralTotalComprehensiveIncomeForThePeriod : null,
    ifrsFiInterestIncomeCalcUsingEim: entity.ifrsFiInterestIncomeCalcUsingEim !== undefined ? entity.ifrsFiInterestIncomeCalcUsingEim : null,
    ifrsFinancialInstitutionsOtherInterestIncome:
      entity.ifrsFinancialInstitutionsOtherInterestIncome !== undefined ? entity.ifrsFinancialInstitutionsOtherInterestIncome : null,
    ifrsFinancialInstitutionsInterestExpense:
      entity.ifrsFinancialInstitutionsInterestExpense !== undefined ? entity.ifrsFinancialInstitutionsInterestExpense : null,
    ifrsFinancialInstitutionsNetInterestIncome:
      entity.ifrsFinancialInstitutionsNetInterestIncome !== undefined ? entity.ifrsFinancialInstitutionsNetInterestIncome : null,
    ifrsFinancialInstitutionsFeeAndCommissionIncome:
      entity.ifrsFinancialInstitutionsFeeAndCommissionIncome !== undefined ? entity.ifrsFinancialInstitutionsFeeAndCommissionIncome : null,
    ifrsFinancialInstitutionsFeeAndCommissionExpense:
      entity.ifrsFinancialInstitutionsFeeAndCommissionExpense !== undefined ? entity.ifrsFinancialInstitutionsFeeAndCommissionExpense : null,
    ifrsFinancialInstitutionsNetFeeAndCommissionIncome:
      entity.ifrsFinancialInstitutionsNetFeeAndCommissionIncome !== undefined ? entity.ifrsFinancialInstitutionsNetFeeAndCommissionIncome : null,
    ifrsFinancialInstitutionsNetTradingIncome:
      entity.ifrsFinancialInstitutionsNetTradingIncome !== undefined ? entity.ifrsFinancialInstitutionsNetTradingIncome : null,
    ifrsFiNetIncomeFromOtherFiAtFvtpl: entity.ifrsFiNetIncomeFromOtherFiAtFvtpl !== undefined ? entity.ifrsFiNetIncomeFromOtherFiAtFvtpl : null,
    ifrsFinancialInstitutionsCreditImpairmentLosses:
      entity.ifrsFinancialInstitutionsCreditImpairmentLosses !== undefined ? entity.ifrsFinancialInstitutionsCreditImpairmentLosses : null,
    ifrsInsuranceIndustryInsuranceRevenue: entity.ifrsInsuranceIndustryInsuranceRevenue !== undefined ? entity.ifrsInsuranceIndustryInsuranceRevenue : null,
    ifrsInsuranceIndustryInsuranceServiceExpenses:
      entity.ifrsInsuranceIndustryInsuranceServiceExpenses !== undefined ? entity.ifrsInsuranceIndustryInsuranceServiceExpenses : null,
    ifrsInsuranceIndustryInsuranceServiceResult:
      entity.ifrsInsuranceIndustryInsuranceServiceResult !== undefined ? entity.ifrsInsuranceIndustryInsuranceServiceResult : null,
    ifrsInsuranceIndustryAllocationOfReinsurancePremiums:
      entity.ifrsInsuranceIndustryAllocationOfReinsurancePremiums !== undefined ? entity.ifrsInsuranceIndustryAllocationOfReinsurancePremiums : null,
    ifrsInsuranceAmountsRecoverableFromReinsurersForClaims:
      entity.ifrsInsuranceAmountsRecoverableFromReinsurersForClaims !== undefined ? entity.ifrsInsuranceAmountsRecoverableFromReinsurersForClaims : null,
    ifrsInsuranceNetIncomeExpensesFromReinsuranceHeld:
      entity.ifrsInsuranceNetIncomeExpensesFromReinsuranceHeld !== undefined ? entity.ifrsInsuranceNetIncomeExpensesFromReinsuranceHeld : null,
    ifrsInsuranceIndustryInsuranceFinanceIncomeOrExpenses:
      entity.ifrsInsuranceIndustryInsuranceFinanceIncomeOrExpenses !== undefined ? entity.ifrsInsuranceIndustryInsuranceFinanceIncomeOrExpenses : null,
    ifrsInsuranceIndustryReinsuranceFinanceIncomeOrExpenses:
      entity.ifrsInsuranceIndustryReinsuranceFinanceIncomeOrExpenses !== undefined ? entity.ifrsInsuranceIndustryReinsuranceFinanceIncomeOrExpenses : null,
    ifrsInsuranceIndustryNetInsuranceFinanceResult:
      entity.ifrsInsuranceIndustryNetInsuranceFinanceResult !== undefined ? entity.ifrsInsuranceIndustryNetInsuranceFinanceResult : null,
    ifrsAgricultureGainsAndLossesFromFvChangesOfBioAssets:
      entity.ifrsAgricultureGainsAndLossesFromFvChangesOfBioAssets !== undefined ? entity.ifrsAgricultureGainsAndLossesFromFvChangesOfBioAssets : null,
    ifrsEfaeomrExplorationAndEvaluationExpenses:
      entity.ifrsEfaeomrExplorationAndEvaluationExpenses !== undefined ? entity.ifrsEfaeomrExplorationAndEvaluationExpenses : null,
    ifrsEfaeomrImpairmentLossesOnEaeAssets: entity.ifrsEfaeomrImpairmentLossesOnEaeAssets !== undefined ? entity.ifrsEfaeomrImpairmentLossesOnEaeAssets : null,
    ifrsRraNetMovementInRdabRelatedToPol: entity.ifrsRraNetMovementInRdabRelatedToPol !== undefined ? entity.ifrsRraNetMovementInRdabRelatedToPol : null,
    ifrsRraNetMovementInRdabRelatedToOci: entity.ifrsRraNetMovementInRdabRelatedToOci !== undefined ? entity.ifrsRraNetMovementInRdabRelatedToOci : null,
    ifrsIeNetGainOrLossOnFaAtFvtpl: entity.ifrsIeNetGainOrLossOnFaAtFvtpl !== undefined ? entity.ifrsIeNetGainOrLossOnFaAtFvtpl : null,
    ifrsIeDividendIncomeFromInvestmentsAtFvtpl:
      entity.ifrsIeDividendIncomeFromInvestmentsAtFvtpl !== undefined ? entity.ifrsIeDividendIncomeFromInvestmentsAtFvtpl : null,
    jgaapGeneralNetSales: entity.jgaapGeneralNetSales !== undefined ? entity.jgaapGeneralNetSales : null,
    jgaapGeneralCostOfSales: entity.jgaapGeneralCostOfSales !== undefined ? entity.jgaapGeneralCostOfSales : null,
    jgaapGeneralGrossProfit: entity.jgaapGeneralGrossProfit !== undefined ? entity.jgaapGeneralGrossProfit : null,
    jgaapGeneralSellingGeneralAndAdministrativeExpenses:
      entity.jgaapGeneralSellingGeneralAndAdministrativeExpenses !== undefined ? entity.jgaapGeneralSellingGeneralAndAdministrativeExpenses : null,
    jgaapGeneralOperatingProfitOrOperatingLoss:
      entity.jgaapGeneralOperatingProfitOrOperatingLoss !== undefined ? entity.jgaapGeneralOperatingProfitOrOperatingLoss : null,
    jgaapGeneralNonOperatingIncome: entity.jgaapGeneralNonOperatingIncome !== undefined ? entity.jgaapGeneralNonOperatingIncome : null,
    jgaapGeneralNonOperatingExpenses: entity.jgaapGeneralNonOperatingExpenses !== undefined ? entity.jgaapGeneralNonOperatingExpenses : null,
    jgaapGeneralOrdinaryProfitOrOrdinaryLoss:
      entity.jgaapGeneralOrdinaryProfitOrOrdinaryLoss !== undefined ? entity.jgaapGeneralOrdinaryProfitOrOrdinaryLoss : null,
    jgaapGeneralExtraordinaryIncome: entity.jgaapGeneralExtraordinaryIncome !== undefined ? entity.jgaapGeneralExtraordinaryIncome : null,
    jgaapGeneralExtraordinaryLosses: entity.jgaapGeneralExtraordinaryLosses !== undefined ? entity.jgaapGeneralExtraordinaryLosses : null,
    jgaapGeneralProfitBeforeIncomeTaxes: entity.jgaapGeneralProfitBeforeIncomeTaxes !== undefined ? entity.jgaapGeneralProfitBeforeIncomeTaxes : null,
    jgaapGeneralIncomeTaxesCurrent: entity.jgaapGeneralIncomeTaxesCurrent !== undefined ? entity.jgaapGeneralIncomeTaxesCurrent : null,
    jgaapGeneralIncomeTaxesDeferred: entity.jgaapGeneralIncomeTaxesDeferred !== undefined ? entity.jgaapGeneralIncomeTaxesDeferred : null,
    jgaapGeneralProfit: entity.jgaapGeneralProfit !== undefined ? entity.jgaapGeneralProfit : null,
    jgaapGeneralProfitAttributableToNonControllingInterests:
      entity.jgaapGeneralProfitAttributableToNonControllingInterests !== undefined ? entity.jgaapGeneralProfitAttributableToNonControllingInterests : null,
    jgaapGeneralProfitAttributableToOwnersOfParent:
      entity.jgaapGeneralProfitAttributableToOwnersOfParent !== undefined ? entity.jgaapGeneralProfitAttributableToOwnersOfParent : null,
    jgaapGeneralOtherComprehensiveIncome: entity.jgaapGeneralOtherComprehensiveIncome !== undefined ? entity.jgaapGeneralOtherComprehensiveIncome : null,
    jgaapGeneralComprehensiveIncome: entity.jgaapGeneralComprehensiveIncome !== undefined ? entity.jgaapGeneralComprehensiveIncome : null,
    jgaapGeneralDepreciationAmortization: entity.jgaapGeneralDepreciationAmortization !== undefined ? entity.jgaapGeneralDepreciationAmortization : null,
    jgaapGeneralInterestIncome: entity.jgaapGeneralInterestIncome !== undefined ? entity.jgaapGeneralInterestIncome : null,
    jgaapGeneralInterestExpenses: entity.jgaapGeneralInterestExpenses !== undefined ? entity.jgaapGeneralInterestExpenses : null,
    jgaapGeneralPersonnelExpenses: entity.jgaapGeneralPersonnelExpenses !== undefined ? entity.jgaapGeneralPersonnelExpenses : null,
    jgaapGeneralLaborCost: entity.jgaapGeneralLaborCost !== undefined ? entity.jgaapGeneralLaborCost : null,
    jgaapGeneralAdvertisingExpenses: entity.jgaapGeneralAdvertisingExpenses !== undefined ? entity.jgaapGeneralAdvertisingExpenses : null,
    jgaapGeneralResearchDevelopmentExpenses:
      entity.jgaapGeneralResearchDevelopmentExpenses !== undefined ? entity.jgaapGeneralResearchDevelopmentExpenses : null,
    jgaapGeneralRentExpenses: entity.jgaapGeneralRentExpenses !== undefined ? entity.jgaapGeneralRentExpenses : null,
    jgaapGeneralEpsBasic: entity.jgaapGeneralEpsBasic !== undefined ? entity.jgaapGeneralEpsBasic : null,
    jgaapGeneralEpsDiluted: entity.jgaapGeneralEpsDiluted !== undefined ? entity.jgaapGeneralEpsDiluted : null,
    jgaapConstructionNetSalesOfCompletedCc: entity.jgaapConstructionNetSalesOfCompletedCc !== undefined ? entity.jgaapConstructionNetSalesOfCompletedCc : null,
    jgaapConstructionCosOfCompletedCc: entity.jgaapConstructionCosOfCompletedCc !== undefined ? entity.jgaapConstructionCosOfCompletedCc : null,
    jgaapConstructionGrossProfitOnCompletedCc:
      entity.jgaapConstructionGrossProfitOnCompletedCc !== undefined ? entity.jgaapConstructionGrossProfitOnCompletedCc : null,
    jgaapBankingOrdinaryIncome: entity.jgaapBankingOrdinaryIncome !== undefined ? entity.jgaapBankingOrdinaryIncome : null,
    jgaapBankingInterestIncome: entity.jgaapBankingInterestIncome !== undefined ? entity.jgaapBankingInterestIncome : null,
    jgaapBankingInterestOnLoansAndDiscounts:
      entity.jgaapBankingInterestOnLoansAndDiscounts !== undefined ? entity.jgaapBankingInterestOnLoansAndDiscounts : null,
    jgaapBankingInterestAndDividendsOnSecurities:
      entity.jgaapBankingInterestAndDividendsOnSecurities !== undefined ? entity.jgaapBankingInterestAndDividendsOnSecurities : null,
    jgaapBankingFeesAndCommissions: entity.jgaapBankingFeesAndCommissions !== undefined ? entity.jgaapBankingFeesAndCommissions : null,
    jgaapBankingTradingIncome: entity.jgaapBankingTradingIncome !== undefined ? entity.jgaapBankingTradingIncome : null,
    jgaapBankingOtherOperatingIncome: entity.jgaapBankingOtherOperatingIncome !== undefined ? entity.jgaapBankingOtherOperatingIncome : null,
    jgaapBankingOtherOrdinaryIncome: entity.jgaapBankingOtherOrdinaryIncome !== undefined ? entity.jgaapBankingOtherOrdinaryIncome : null,
    jgaapBankingOrdinaryExpenses: entity.jgaapBankingOrdinaryExpenses !== undefined ? entity.jgaapBankingOrdinaryExpenses : null,
    jgaapBankingInterestExpenses: entity.jgaapBankingInterestExpenses !== undefined ? entity.jgaapBankingInterestExpenses : null,
    jgaapBankingInterestOnDeposits: entity.jgaapBankingInterestOnDeposits !== undefined ? entity.jgaapBankingInterestOnDeposits : null,
    jgaapBankingFeesAndCommissionsPayments: entity.jgaapBankingFeesAndCommissionsPayments !== undefined ? entity.jgaapBankingFeesAndCommissionsPayments : null,
    jgaapBankingTradingExpenses: entity.jgaapBankingTradingExpenses !== undefined ? entity.jgaapBankingTradingExpenses : null,
    jgaapBankingOtherOperatingExpenses: entity.jgaapBankingOtherOperatingExpenses !== undefined ? entity.jgaapBankingOtherOperatingExpenses : null,
    jgaapBankingGeneralAndAdministrativeExpenses:
      entity.jgaapBankingGeneralAndAdministrativeExpenses !== undefined ? entity.jgaapBankingGeneralAndAdministrativeExpenses : null,
    jgaapBankingOtherOrdinaryExpenses: entity.jgaapBankingOtherOrdinaryExpenses !== undefined ? entity.jgaapBankingOtherOrdinaryExpenses : null,
    jgaapBankingOrdinaryProfit: entity.jgaapBankingOrdinaryProfit !== undefined ? entity.jgaapBankingOrdinaryProfit : null,
    jgaapSecuritiesOperatingRevenue: entity.jgaapSecuritiesOperatingRevenue !== undefined ? entity.jgaapSecuritiesOperatingRevenue : null,
    jgaapSecuritiesCommissionsReceived: entity.jgaapSecuritiesCommissionsReceived !== undefined ? entity.jgaapSecuritiesCommissionsReceived : null,
    jgaapSecuritiesBrokerageCommissions: entity.jgaapSecuritiesBrokerageCommissions !== undefined ? entity.jgaapSecuritiesBrokerageCommissions : null,
    jgaapSecuritiesUnderwritingAndSellingCommissions:
      entity.jgaapSecuritiesUnderwritingAndSellingCommissions !== undefined ? entity.jgaapSecuritiesUnderwritingAndSellingCommissions : null,
    jgaapSecuritiesSubscriptionAndDistributionCommissions:
      entity.jgaapSecuritiesSubscriptionAndDistributionCommissions !== undefined ? entity.jgaapSecuritiesSubscriptionAndDistributionCommissions : null,
    jgaapSecuritiesNetTradingIncome: entity.jgaapSecuritiesNetTradingIncome !== undefined ? entity.jgaapSecuritiesNetTradingIncome : null,
    jgaapSecuritiesFinancialRevenue: entity.jgaapSecuritiesFinancialRevenue !== undefined ? entity.jgaapSecuritiesFinancialRevenue : null,
    jgaapSecuritiesFinancialExpenses: entity.jgaapSecuritiesFinancialExpenses !== undefined ? entity.jgaapSecuritiesFinancialExpenses : null,
    jgaapSecuritiesSellingGeneralAndAdministrativeExpenses:
      entity.jgaapSecuritiesSellingGeneralAndAdministrativeExpenses !== undefined ? entity.jgaapSecuritiesSellingGeneralAndAdministrativeExpenses : null,
    jgaapSecuritiesTransactionExpenses: entity.jgaapSecuritiesTransactionExpenses !== undefined ? entity.jgaapSecuritiesTransactionExpenses : null,
    jgaapSecuritiesOperatingProfit: entity.jgaapSecuritiesOperatingProfit !== undefined ? entity.jgaapSecuritiesOperatingProfit : null,
    jgaapInsuranceOrdinaryIncome: entity.jgaapInsuranceOrdinaryIncome !== undefined ? entity.jgaapInsuranceOrdinaryIncome : null,
    jgaapInsuranceUnderwritingIncome: entity.jgaapInsuranceUnderwritingIncome !== undefined ? entity.jgaapInsuranceUnderwritingIncome : null,
    jgaapInsurancePremiumIncome: entity.jgaapInsurancePremiumIncome !== undefined ? entity.jgaapInsurancePremiumIncome : null,
    jgaapInsuranceNetPremiumsWritten: entity.jgaapInsuranceNetPremiumsWritten !== undefined ? entity.jgaapInsuranceNetPremiumsWritten : null,
    jgaapInsuranceInvestmentIncome: entity.jgaapInsuranceInvestmentIncome !== undefined ? entity.jgaapInsuranceInvestmentIncome : null,
    jgaapInsuranceInvestmentIncomeOnSeparateAccounts:
      entity.jgaapInsuranceInvestmentIncomeOnSeparateAccounts !== undefined ? entity.jgaapInsuranceInvestmentIncomeOnSeparateAccounts : null,
    jgaapInsuranceInterestAndDividendsIncome:
      entity.jgaapInsuranceInterestAndDividendsIncome !== undefined ? entity.jgaapInsuranceInterestAndDividendsIncome : null,
    jgaapInsuranceOtherOrdinaryIncome: entity.jgaapInsuranceOtherOrdinaryIncome !== undefined ? entity.jgaapInsuranceOtherOrdinaryIncome : null,
    jgaapInsuranceOrdinaryExpenses: entity.jgaapInsuranceOrdinaryExpenses !== undefined ? entity.jgaapInsuranceOrdinaryExpenses : null,
    jgaapInsuranceUnderwritingExpenses: entity.jgaapInsuranceUnderwritingExpenses !== undefined ? entity.jgaapInsuranceUnderwritingExpenses : null,
    jgaapInsuranceClaimsAndOtherPayments: entity.jgaapInsuranceClaimsAndOtherPayments !== undefined ? entity.jgaapInsuranceClaimsAndOtherPayments : null,
    jgaapInsuranceClaimsPaid: entity.jgaapInsuranceClaimsPaid !== undefined ? entity.jgaapInsuranceClaimsPaid : null,
    jgaapInsuranceInsuranceClaims: entity.jgaapInsuranceInsuranceClaims !== undefined ? entity.jgaapInsuranceInsuranceClaims : null,
    jgaapInsuranceAnnuityPayments: entity.jgaapInsuranceAnnuityPayments !== undefined ? entity.jgaapInsuranceAnnuityPayments : null,
    jgaapInsuranceBenefits: entity.jgaapInsuranceBenefits !== undefined ? entity.jgaapInsuranceBenefits : null,
    jgaapInsuranceSurrenderValues: entity.jgaapInsuranceSurrenderValues !== undefined ? entity.jgaapInsuranceSurrenderValues : null,
    jgaapInsuranceOtherRefunds: entity.jgaapInsuranceOtherRefunds !== undefined ? entity.jgaapInsuranceOtherRefunds : null,
    jgaapInsuranceReinsurancePremiums: entity.jgaapInsuranceReinsurancePremiums !== undefined ? entity.jgaapInsuranceReinsurancePremiums : null,
    jgaapInsuranceProvisionForPolicyReserves:
      entity.jgaapInsuranceProvisionForPolicyReserves !== undefined ? entity.jgaapInsuranceProvisionForPolicyReserves : null,
    jgaapInsuranceInvestmentExpenses: entity.jgaapInsuranceInvestmentExpenses !== undefined ? entity.jgaapInsuranceInvestmentExpenses : null,
    jgaapInsuranceInvestmentLossesOnSeparateAccounts:
      entity.jgaapInsuranceInvestmentLossesOnSeparateAccounts !== undefined ? entity.jgaapInsuranceInvestmentLossesOnSeparateAccounts : null,
    jgaapInsuranceOperatingExpenses: entity.jgaapInsuranceOperatingExpenses !== undefined ? entity.jgaapInsuranceOperatingExpenses : null,
    jgaapInsuranceLossAdjustmentExpenses: entity.jgaapInsuranceLossAdjustmentExpenses !== undefined ? entity.jgaapInsuranceLossAdjustmentExpenses : null,
    jgaapRealEstateRevenueFromRealEstateBusiness:
      entity.jgaapRealEstateRevenueFromRealEstateBusiness !== undefined ? entity.jgaapRealEstateRevenueFromRealEstateBusiness : null,
    jgaapRealEstateRevenueFromRealEstateLeasing:
      entity.jgaapRealEstateRevenueFromRealEstateLeasing !== undefined ? entity.jgaapRealEstateRevenueFromRealEstateLeasing : null,
    jgaapRealEstateCostOfRealEstateBusiness:
      entity.jgaapRealEstateCostOfRealEstateBusiness !== undefined ? entity.jgaapRealEstateCostOfRealEstateBusiness : null,
    jgaapRealEstateCostOfRealEstateSales: entity.jgaapRealEstateCostOfRealEstateSales !== undefined ? entity.jgaapRealEstateCostOfRealEstateSales : null,
    jgaapRealEstateCostOfRealEstateLeasing: entity.jgaapRealEstateCostOfRealEstateLeasing !== undefined ? entity.jgaapRealEstateCostOfRealEstateLeasing : null,
    jgaapRailwayOperatingRevenuesFromRailwayBusiness:
      entity.jgaapRailwayOperatingRevenuesFromRailwayBusiness !== undefined ? entity.jgaapRailwayOperatingRevenuesFromRailwayBusiness : null,
    jgaapRailwayOperatingExpensesFromRailwayBusiness:
      entity.jgaapRailwayOperatingExpensesFromRailwayBusiness !== undefined ? entity.jgaapRailwayOperatingExpensesFromRailwayBusiness : null,
    jgaapShippingShippingRevenues: entity.jgaapShippingShippingRevenues !== undefined ? entity.jgaapShippingShippingRevenues : null,
    jgaapShippingShippingExpenses: entity.jgaapShippingShippingExpenses !== undefined ? entity.jgaapShippingShippingExpenses : null,
    jgaapShippingOperatingExpenses: entity.jgaapShippingOperatingExpenses !== undefined ? entity.jgaapShippingOperatingExpenses : null,
    jgaapEpagOperatingRevenuesFromEub: entity.jgaapEpagOperatingRevenuesFromEub !== undefined ? entity.jgaapEpagOperatingRevenuesFromEub : null,
    jgaapEpagOperatingExpensesFromEub: entity.jgaapEpagOperatingExpensesFromEub !== undefined ? entity.jgaapEpagOperatingExpensesFromEub : null,
    jgaapElectricPowerAndGasNonOperatingIncome:
      entity.jgaapElectricPowerAndGasNonOperatingIncome !== undefined ? entity.jgaapElectricPowerAndGasNonOperatingIncome : null,
    jgaapElectricPowerAndGasNonOperatingExpenses:
      entity.jgaapElectricPowerAndGasNonOperatingExpenses !== undefined ? entity.jgaapElectricPowerAndGasNonOperatingExpenses : null,
    jgaapLeasingLeaseRevenue: entity.jgaapLeasingLeaseRevenue !== undefined ? entity.jgaapLeasingLeaseRevenue : null,
    jgaapLeasingLeaseCost: entity.jgaapLeasingLeaseCost !== undefined ? entity.jgaapLeasingLeaseCost : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableBsFullToDomainModel = (entity: ProtoModel.UsecaseTableBsFull): DomainModel.UsecaseTableBsFull => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    accountingStandard: entity.accountingStandard !== undefined ? entity.accountingStandard : null,
    unit: entity.unit !== undefined ? entity.unit : null,
    unitText: entity.unitText !== undefined ? entity.unitText : null,
    highlightCashAndDepositsJpy: entity.highlightCashAndDepositsJpy !== undefined ? entity.highlightCashAndDepositsJpy : null,
    highlightAccountsReceivableJpy: entity.highlightAccountsReceivableJpy !== undefined ? entity.highlightAccountsReceivableJpy : null,
    highlightInventoriesJpy: entity.highlightInventoriesJpy !== undefined ? entity.highlightInventoriesJpy : null,
    highlightPropertyPlantEquipmentJpy: entity.highlightPropertyPlantEquipmentJpy !== undefined ? entity.highlightPropertyPlantEquipmentJpy : null,
    highlightTotalAssetsJpy: entity.highlightTotalAssetsJpy !== undefined ? entity.highlightTotalAssetsJpy : null,
    ifrsGeneralPropertyPlantAndEquipment: entity.ifrsGeneralPropertyPlantAndEquipment !== undefined ? entity.ifrsGeneralPropertyPlantAndEquipment : null,
    ifrsGeneralInvestmentProperty: entity.ifrsGeneralInvestmentProperty !== undefined ? entity.ifrsGeneralInvestmentProperty : null,
    ifrsGeneralIntangibleAssets: entity.ifrsGeneralIntangibleAssets !== undefined ? entity.ifrsGeneralIntangibleAssets : null,
    ifrsGeneralFinancialAssetsExcludingCashEquivalents:
      entity.ifrsGeneralFinancialAssetsExcludingCashEquivalents !== undefined ? entity.ifrsGeneralFinancialAssetsExcludingCashEquivalents : null,
    ifrsGeneralInvestmentsAccountedForUsingTheEquityMethod:
      entity.ifrsGeneralInvestmentsAccountedForUsingTheEquityMethod !== undefined ? entity.ifrsGeneralInvestmentsAccountedForUsingTheEquityMethod : null,
    ifrsGeneralDeferredTaxAssets: entity.ifrsGeneralDeferredTaxAssets !== undefined ? entity.ifrsGeneralDeferredTaxAssets : null,
    ifrsGeneralTotalNonCurrentAssets: entity.ifrsGeneralTotalNonCurrentAssets !== undefined ? entity.ifrsGeneralTotalNonCurrentAssets : null,
    ifrsGeneralInventories: entity.ifrsGeneralInventories !== undefined ? entity.ifrsGeneralInventories : null,
    ifrsGeneralTradeAndOtherReceivables: entity.ifrsGeneralTradeAndOtherReceivables !== undefined ? entity.ifrsGeneralTradeAndOtherReceivables : null,
    ifrsGeneralCashAndCashEquivalents: entity.ifrsGeneralCashAndCashEquivalents !== undefined ? entity.ifrsGeneralCashAndCashEquivalents : null,
    ifrsGeneralAssetsHeldForSale: entity.ifrsGeneralAssetsHeldForSale !== undefined ? entity.ifrsGeneralAssetsHeldForSale : null,
    ifrsGeneralTotalCurrentAssets: entity.ifrsGeneralTotalCurrentAssets !== undefined ? entity.ifrsGeneralTotalCurrentAssets : null,
    ifrsGeneralTotalAssets: entity.ifrsGeneralTotalAssets !== undefined ? entity.ifrsGeneralTotalAssets : null,
    ifrsGeneralTotalFixedAssets: entity.ifrsGeneralTotalFixedAssets !== undefined ? entity.ifrsGeneralTotalFixedAssets : null,
    ifrsGeneralTotalCurrentLiabilities: entity.ifrsGeneralTotalCurrentLiabilities !== undefined ? entity.ifrsGeneralTotalCurrentLiabilities : null,
    ifrsGeneralTotalFixedLiabilities: entity.ifrsGeneralTotalFixedLiabilities !== undefined ? entity.ifrsGeneralTotalFixedLiabilities : null,
    ifrsGeneralTotalLiabilities: entity.ifrsGeneralTotalLiabilities !== undefined ? entity.ifrsGeneralTotalLiabilities : null,
    ifrsGeneralNonControllingInterests: entity.ifrsGeneralNonControllingInterests !== undefined ? entity.ifrsGeneralNonControllingInterests : null,
    ifrsGeneralIssuedCapitalAndReservesAttrToOotp:
      entity.ifrsGeneralIssuedCapitalAndReservesAttrToOotp !== undefined ? entity.ifrsGeneralIssuedCapitalAndReservesAttrToOotp : null,
    ifrsGeneralTotalEquity: entity.ifrsGeneralTotalEquity !== undefined ? entity.ifrsGeneralTotalEquity : null,
    ifrsGeneralTotalEquityAndLiabilities: entity.ifrsGeneralTotalEquityAndLiabilities !== undefined ? entity.ifrsGeneralTotalEquityAndLiabilities : null,
    ifrsFiCashAndBalancesWithCentralBanks: entity.ifrsFiCashAndBalancesWithCentralBanks !== undefined ? entity.ifrsFiCashAndBalancesWithCentralBanks : null,
    ifrsFinancialInstitutionsLoansAndAdvancesToBanks:
      entity.ifrsFinancialInstitutionsLoansAndAdvancesToBanks !== undefined ? entity.ifrsFinancialInstitutionsLoansAndAdvancesToBanks : null,
    ifrsFinancialInstitutionsLoansAndAdvancesToCustomers:
      entity.ifrsFinancialInstitutionsLoansAndAdvancesToCustomers !== undefined ? entity.ifrsFinancialInstitutionsLoansAndAdvancesToCustomers : null,
    ifrsFiDerivativeFiAssets: entity.ifrsFiDerivativeFiAssets !== undefined ? entity.ifrsFiDerivativeFiAssets : null,
    ifrsFinancialInstitutionsInvestmentSecurities:
      entity.ifrsFinancialInstitutionsInvestmentSecurities !== undefined ? entity.ifrsFinancialInstitutionsInvestmentSecurities : null,
    ifrsFinancialInstitutionsTradingAssets: entity.ifrsFinancialInstitutionsTradingAssets !== undefined ? entity.ifrsFinancialInstitutionsTradingAssets : null,
    ifrsFinancialInstitutionsPledgedAssets: entity.ifrsFinancialInstitutionsPledgedAssets !== undefined ? entity.ifrsFinancialInstitutionsPledgedAssets : null,
    ifrsFinancialInstitutionsDepositsFromBanks:
      entity.ifrsFinancialInstitutionsDepositsFromBanks !== undefined ? entity.ifrsFinancialInstitutionsDepositsFromBanks : null,
    ifrsFinancialInstitutionsDepositsFromCustomers:
      entity.ifrsFinancialInstitutionsDepositsFromCustomers !== undefined ? entity.ifrsFinancialInstitutionsDepositsFromCustomers : null,
    ifrsFiDerivativeFiLiabilities: entity.ifrsFiDerivativeFiLiabilities !== undefined ? entity.ifrsFiDerivativeFiLiabilities : null,
    ifrsFinancialInstitutionsDebtSecuritiesInIssue:
      entity.ifrsFinancialInstitutionsDebtSecuritiesInIssue !== undefined ? entity.ifrsFinancialInstitutionsDebtSecuritiesInIssue : null,
    ifrsFinancialInstitutionsSubordinatedLiabilities:
      entity.ifrsFinancialInstitutionsSubordinatedLiabilities !== undefined ? entity.ifrsFinancialInstitutionsSubordinatedLiabilities : null,
    ifrsFinancialInstitutionsTradingLiabilities:
      entity.ifrsFinancialInstitutionsTradingLiabilities !== undefined ? entity.ifrsFinancialInstitutionsTradingLiabilities : null,
    ifrsInsuranceIndustryInsuranceContractAssets:
      entity.ifrsInsuranceIndustryInsuranceContractAssets !== undefined ? entity.ifrsInsuranceIndustryInsuranceContractAssets : null,
    ifrsInsuranceIndustryReinsuranceContractAssets:
      entity.ifrsInsuranceIndustryReinsuranceContractAssets !== undefined ? entity.ifrsInsuranceIndustryReinsuranceContractAssets : null,
    ifrsInsuranceIndustryInsuranceContractLiabilities:
      entity.ifrsInsuranceIndustryInsuranceContractLiabilities !== undefined ? entity.ifrsInsuranceIndustryInsuranceContractLiabilities : null,
    ifrsInsuranceIndustryReinsuranceContractLiabilities:
      entity.ifrsInsuranceIndustryReinsuranceContractLiabilities !== undefined ? entity.ifrsInsuranceIndustryReinsuranceContractLiabilities : null,
    ifrsInsuranceIndustryInvestmentContractLiabilities:
      entity.ifrsInsuranceIndustryInvestmentContractLiabilities !== undefined ? entity.ifrsInsuranceIndustryInvestmentContractLiabilities : null,
    ifrsAgricultureBiologicalAssets: entity.ifrsAgricultureBiologicalAssets !== undefined ? entity.ifrsAgricultureBiologicalAssets : null,
    ifrsAgricultureBearerPlants: entity.ifrsAgricultureBearerPlants !== undefined ? entity.ifrsAgricultureBearerPlants : null,
    ifrsAgricultureAgriculturalProduceInventoryAtHarvest:
      entity.ifrsAgricultureAgriculturalProduceInventoryAtHarvest !== undefined ? entity.ifrsAgricultureAgriculturalProduceInventoryAtHarvest : null,
    ifrsEfaeomrExplorationAndEvaluationAssets:
      entity.ifrsEfaeomrExplorationAndEvaluationAssets !== undefined ? entity.ifrsEfaeomrExplorationAndEvaluationAssets : null,
    ifrsEfaeomrEaeAssetsTangible: entity.ifrsEfaeomrEaeAssetsTangible !== undefined ? entity.ifrsEfaeomrEaeAssetsTangible : null,
    ifrsEfaeomrEaeAssetsIntangible: entity.ifrsEfaeomrEaeAssetsIntangible !== undefined ? entity.ifrsEfaeomrEaeAssetsIntangible : null,
    ifrsEfaeomrLiabilitiesRelatedToEaeAssets:
      entity.ifrsEfaeomrLiabilitiesRelatedToEaeAssets !== undefined ? entity.ifrsEfaeomrLiabilitiesRelatedToEaeAssets : null,
    ifrsRraTotalAssetsSubjectToRateReg: entity.ifrsRraTotalAssetsSubjectToRateReg !== undefined ? entity.ifrsRraTotalAssetsSubjectToRateReg : null,
    ifrsRraRegulatoryDeferralAccountDebitBal:
      entity.ifrsRraRegulatoryDeferralAccountDebitBal !== undefined ? entity.ifrsRraRegulatoryDeferralAccountDebitBal : null,
    ifrsRraRegulatoryDeferralAccountCreditBal:
      entity.ifrsRraRegulatoryDeferralAccountCreditBal !== undefined ? entity.ifrsRraRegulatoryDeferralAccountCreditBal : null,
    ifrsIeFaAtFvtplInvestmentsInSubs: entity.ifrsIeFaAtFvtplInvestmentsInSubs !== undefined ? entity.ifrsIeFaAtFvtplInvestmentsInSubs : null,
    jgaapGeneralCashAndDeposits: entity.jgaapGeneralCashAndDeposits !== undefined ? entity.jgaapGeneralCashAndDeposits : null,
    jgaapGeneralNotesAndArTradeAndContractAssets:
      entity.jgaapGeneralNotesAndArTradeAndContractAssets !== undefined ? entity.jgaapGeneralNotesAndArTradeAndContractAssets : null,
    jgaapGeneralSecurities: entity.jgaapGeneralSecurities !== undefined ? entity.jgaapGeneralSecurities : null,
    jgaapGeneralInventories: entity.jgaapGeneralInventories !== undefined ? entity.jgaapGeneralInventories : null,
    jgaapGeneralPropertyPlantAndEquipment: entity.jgaapGeneralPropertyPlantAndEquipment !== undefined ? entity.jgaapGeneralPropertyPlantAndEquipment : null,
    jgaapGeneralIntangibleAssets: entity.jgaapGeneralIntangibleAssets !== undefined ? entity.jgaapGeneralIntangibleAssets : null,
    jgaapGeneralInvestmentSecurities: entity.jgaapGeneralInvestmentSecurities !== undefined ? entity.jgaapGeneralInvestmentSecurities : null,
    jgaapGeneralDeferredTaxAssets: entity.jgaapGeneralDeferredTaxAssets !== undefined ? entity.jgaapGeneralDeferredTaxAssets : null,
    jgaapGeneralNotesAndAccountsPayableTrade:
      entity.jgaapGeneralNotesAndAccountsPayableTrade !== undefined ? entity.jgaapGeneralNotesAndAccountsPayableTrade : null,
    jgaapGeneralShortTermBorrowings: entity.jgaapGeneralShortTermBorrowings !== undefined ? entity.jgaapGeneralShortTermBorrowings : null,
    jgaapGeneralProvisions: entity.jgaapGeneralProvisions !== undefined ? entity.jgaapGeneralProvisions : null,
    jgaapGeneralBondsPayable: entity.jgaapGeneralBondsPayable !== undefined ? entity.jgaapGeneralBondsPayable : null,
    jgaapGeneralLongTermBorrowings: entity.jgaapGeneralLongTermBorrowings !== undefined ? entity.jgaapGeneralLongTermBorrowings : null,
    jgaapGeneralRetirementBenefitLiability: entity.jgaapGeneralRetirementBenefitLiability !== undefined ? entity.jgaapGeneralRetirementBenefitLiability : null,
    jgaapGeneralShareCapital: entity.jgaapGeneralShareCapital !== undefined ? entity.jgaapGeneralShareCapital : null,
    jgaapGeneralCapitalSurplus: entity.jgaapGeneralCapitalSurplus !== undefined ? entity.jgaapGeneralCapitalSurplus : null,
    jgaapGeneralRetainedEarnings: entity.jgaapGeneralRetainedEarnings !== undefined ? entity.jgaapGeneralRetainedEarnings : null,
    jgaapGeneralTreasuryShares: entity.jgaapGeneralTreasuryShares !== undefined ? entity.jgaapGeneralTreasuryShares : null,
    jgaapGeneralAccumulatedOtherComprehensiveIncome:
      entity.jgaapGeneralAccumulatedOtherComprehensiveIncome !== undefined ? entity.jgaapGeneralAccumulatedOtherComprehensiveIncome : null,
    jgaapGeneralNonControllingInterests: entity.jgaapGeneralNonControllingInterests !== undefined ? entity.jgaapGeneralNonControllingInterests : null,
    jgaapGeneralTotalCurrentAssets: entity.jgaapGeneralTotalCurrentAssets !== undefined ? entity.jgaapGeneralTotalCurrentAssets : null,
    jgaapGeneralTotalFixedAssets: entity.jgaapGeneralTotalFixedAssets !== undefined ? entity.jgaapGeneralTotalFixedAssets : null,
    jgaapGeneralTotalCurrentLiabilities: entity.jgaapGeneralTotalCurrentLiabilities !== undefined ? entity.jgaapGeneralTotalCurrentLiabilities : null,
    jgaapGeneralTotalFixedLiabilities: entity.jgaapGeneralTotalFixedLiabilities !== undefined ? entity.jgaapGeneralTotalFixedLiabilities : null,
    jgaapGeneralTotalLiabilities: entity.jgaapGeneralTotalLiabilities !== undefined ? entity.jgaapGeneralTotalLiabilities : null,
    jgaapGeneralTotalNetAssets: entity.jgaapGeneralTotalNetAssets !== undefined ? entity.jgaapGeneralTotalNetAssets : null,
    jgaapGeneralTotalAssets: entity.jgaapGeneralTotalAssets !== undefined ? entity.jgaapGeneralTotalAssets : null,
    jgaapGeneralAccumulatedDepreciation: entity.jgaapGeneralAccumulatedDepreciation !== undefined ? entity.jgaapGeneralAccumulatedDepreciation : null,
    jgaapGeneralSubscriptionRightsShares: entity.jgaapGeneralSubscriptionRightsShares !== undefined ? entity.jgaapGeneralSubscriptionRightsShares : null,
    jgaapGeneralAdvancePayments: entity.jgaapGeneralAdvancePayments !== undefined ? entity.jgaapGeneralAdvancePayments : null,
    jgaapGeneralPrepaidExpenses: entity.jgaapGeneralPrepaidExpenses !== undefined ? entity.jgaapGeneralPrepaidExpenses : null,
    jgaapGeneralAdvancesReceived: entity.jgaapGeneralAdvancesReceived !== undefined ? entity.jgaapGeneralAdvancesReceived : null,
    jgaapGeneralDeferredRevenue: entity.jgaapGeneralDeferredRevenue !== undefined ? entity.jgaapGeneralDeferredRevenue : null,
    jgaapConstructionArFromCompletedCc: entity.jgaapConstructionArFromCompletedCc !== undefined ? entity.jgaapConstructionArFromCompletedCc : null,
    jgaapConstructionCostsOnUncompletedConstructionContracts:
      entity.jgaapConstructionCostsOnUncompletedConstructionContracts !== undefined ? entity.jgaapConstructionCostsOnUncompletedConstructionContracts : null,
    jgaapConstructionAdvancesReceivedOnUncompletedCc:
      entity.jgaapConstructionAdvancesReceivedOnUncompletedCc !== undefined ? entity.jgaapConstructionAdvancesReceivedOnUncompletedCc : null,
    jgaapConstructionMaterialsAndSupplies: entity.jgaapConstructionMaterialsAndSupplies !== undefined ? entity.jgaapConstructionMaterialsAndSupplies : null,
    jgaapConstructionAccountsPayableForConstructionContracts:
      entity.jgaapConstructionAccountsPayableForConstructionContracts !== undefined ? entity.jgaapConstructionAccountsPayableForConstructionContracts : null,
    jgaapConstructionProvisionForLossOnConstructionContracts:
      entity.jgaapConstructionProvisionForLossOnConstructionContracts !== undefined ? entity.jgaapConstructionProvisionForLossOnConstructionContracts : null,
    jgaapConstructionProvisionForWarrantiesForCompletedC:
      entity.jgaapConstructionProvisionForWarrantiesForCompletedC !== undefined ? entity.jgaapConstructionProvisionForWarrantiesForCompletedC : null,
    jgaapBankingCashAndDueFromBanks: entity.jgaapBankingCashAndDueFromBanks !== undefined ? entity.jgaapBankingCashAndDueFromBanks : null,
    jgaapBankingCallLoansAndBillsBought: entity.jgaapBankingCallLoansAndBillsBought !== undefined ? entity.jgaapBankingCallLoansAndBillsBought : null,
    jgaapBankingMonetaryClaimsBought: entity.jgaapBankingMonetaryClaimsBought !== undefined ? entity.jgaapBankingMonetaryClaimsBought : null,
    jgaapBankingTradingAssets: entity.jgaapBankingTradingAssets !== undefined ? entity.jgaapBankingTradingAssets : null,
    jgaapBankingMoneyHeldInTrust: entity.jgaapBankingMoneyHeldInTrust !== undefined ? entity.jgaapBankingMoneyHeldInTrust : null,
    jgaapBankingSecurities: entity.jgaapBankingSecurities !== undefined ? entity.jgaapBankingSecurities : null,
    jgaapBankingLoansAndBillsDiscounted: entity.jgaapBankingLoansAndBillsDiscounted !== undefined ? entity.jgaapBankingLoansAndBillsDiscounted : null,
    jgaapBankingForeignExchangesAssets: entity.jgaapBankingForeignExchangesAssets !== undefined ? entity.jgaapBankingForeignExchangesAssets : null,
    jgaapBankingDerivativesAssets: entity.jgaapBankingDerivativesAssets !== undefined ? entity.jgaapBankingDerivativesAssets : null,
    jgaapBankingDeposits: entity.jgaapBankingDeposits !== undefined ? entity.jgaapBankingDeposits : null,
    jgaapBankingNegotiableCertificatesOfDeposit:
      entity.jgaapBankingNegotiableCertificatesOfDeposit !== undefined ? entity.jgaapBankingNegotiableCertificatesOfDeposit : null,
    jgaapBankingCallMoneyAndBillsSold: entity.jgaapBankingCallMoneyAndBillsSold !== undefined ? entity.jgaapBankingCallMoneyAndBillsSold : null,
    jgaapBankingPayablesUnderSecuritiesLendingTransactions:
      entity.jgaapBankingPayablesUnderSecuritiesLendingTransactions !== undefined ? entity.jgaapBankingPayablesUnderSecuritiesLendingTransactions : null,
    jgaapBankingTradingLiabilities: entity.jgaapBankingTradingLiabilities !== undefined ? entity.jgaapBankingTradingLiabilities : null,
    jgaapBankingBorrowedMoney: entity.jgaapBankingBorrowedMoney !== undefined ? entity.jgaapBankingBorrowedMoney : null,
    jgaapBankingForeignExchangesLiabilities:
      entity.jgaapBankingForeignExchangesLiabilities !== undefined ? entity.jgaapBankingForeignExchangesLiabilities : null,
    jgaapBankingBondsPayable: entity.jgaapBankingBondsPayable !== undefined ? entity.jgaapBankingBondsPayable : null,
    jgaapBankingDerivativesLiabilities: entity.jgaapBankingDerivativesLiabilities !== undefined ? entity.jgaapBankingDerivativesLiabilities : null,
    jgaapBankingDeferredTaxLiabilitiesForLandRevaluation:
      entity.jgaapBankingDeferredTaxLiabilitiesForLandRevaluation !== undefined ? entity.jgaapBankingDeferredTaxLiabilitiesForLandRevaluation : null,
    jgaapBankingCustomersLiabForAcceptancesAndGuarantees:
      entity.jgaapBankingCustomersLiabForAcceptancesAndGuarantees !== undefined ? entity.jgaapBankingCustomersLiabForAcceptancesAndGuarantees : null,
    jgaapBankingAcceptancesAndGuarantees: entity.jgaapBankingAcceptancesAndGuarantees !== undefined ? entity.jgaapBankingAcceptancesAndGuarantees : null,
    jgaapSecuritiesDepositsPaid: entity.jgaapSecuritiesDepositsPaid !== undefined ? entity.jgaapSecuritiesDepositsPaid : null,
    jgaapSecuritiesSegregatedDepositsForCustomers:
      entity.jgaapSecuritiesSegregatedDepositsForCustomers !== undefined ? entity.jgaapSecuritiesSegregatedDepositsForCustomers : null,
    jgaapSecuritiesTradingProducts: entity.jgaapSecuritiesTradingProducts !== undefined ? entity.jgaapSecuritiesTradingProducts : null,
    jgaapSecuritiesMarginTransactionAssets: entity.jgaapSecuritiesMarginTransactionAssets !== undefined ? entity.jgaapSecuritiesMarginTransactionAssets : null,
    jgaapSecuritiesLoansOnMarginTransactions:
      entity.jgaapSecuritiesLoansOnMarginTransactions !== undefined ? entity.jgaapSecuritiesLoansOnMarginTransactions : null,
    jgaapSecuritiesCashCollateralForSecBorrowedOnMt:
      entity.jgaapSecuritiesCashCollateralForSecBorrowedOnMt !== undefined ? entity.jgaapSecuritiesCashCollateralForSecBorrowedOnMt : null,
    jgaapSecuritiesAdvancesPaid: entity.jgaapSecuritiesAdvancesPaid !== undefined ? entity.jgaapSecuritiesAdvancesPaid : null,
    jgaapSecuritiesSubscriptionDeposits: entity.jgaapSecuritiesSubscriptionDeposits !== undefined ? entity.jgaapSecuritiesSubscriptionDeposits : null,
    jgaapSecuritiesShortTermGuaranteeDeposits:
      entity.jgaapSecuritiesShortTermGuaranteeDeposits !== undefined ? entity.jgaapSecuritiesShortTermGuaranteeDeposits : null,
    jgaapSecuritiesLoansSecuredBySecurities:
      entity.jgaapSecuritiesLoansSecuredBySecurities !== undefined ? entity.jgaapSecuritiesLoansSecuredBySecurities : null,
    jgaapSecuritiesTradingProductsLiabilities:
      entity.jgaapSecuritiesTradingProductsLiabilities !== undefined ? entity.jgaapSecuritiesTradingProductsLiabilities : null,
    jgaapSecuritiesMarginTransactionLiabilities:
      entity.jgaapSecuritiesMarginTransactionLiabilities !== undefined ? entity.jgaapSecuritiesMarginTransactionLiabilities : null,
    jgaapSecuritiesBorrowingsOnMarginTransactions:
      entity.jgaapSecuritiesBorrowingsOnMarginTransactions !== undefined ? entity.jgaapSecuritiesBorrowingsOnMarginTransactions : null,
    jgaapSecuritiesCashReceivedForSecLentOnMt:
      entity.jgaapSecuritiesCashReceivedForSecLentOnMt !== undefined ? entity.jgaapSecuritiesCashReceivedForSecLentOnMt : null,
    jgaapSecuritiesGuaranteeDepositsReceived:
      entity.jgaapSecuritiesGuaranteeDepositsReceived !== undefined ? entity.jgaapSecuritiesGuaranteeDepositsReceived : null,
    jgaapSecuritiesDepositsReceived: entity.jgaapSecuritiesDepositsReceived !== undefined ? entity.jgaapSecuritiesDepositsReceived : null,
    jgaapSecuritiesDepositsFromCustomers: entity.jgaapSecuritiesDepositsFromCustomers !== undefined ? entity.jgaapSecuritiesDepositsFromCustomers : null,
    jgaapSecuritiesShortTermGuaranteeDepositsReceived:
      entity.jgaapSecuritiesShortTermGuaranteeDepositsReceived !== undefined ? entity.jgaapSecuritiesShortTermGuaranteeDepositsReceived : null,
    jgaapSecuritiesShortTermBorrowings: entity.jgaapSecuritiesShortTermBorrowings !== undefined ? entity.jgaapSecuritiesShortTermBorrowings : null,
    jgaapSecuritiesBorrowingsSecuredBySecurities:
      entity.jgaapSecuritiesBorrowingsSecuredBySecurities !== undefined ? entity.jgaapSecuritiesBorrowingsSecuredBySecurities : null,
    jgaapInsuranceCashAndDeposits: entity.jgaapInsuranceCashAndDeposits !== undefined ? entity.jgaapInsuranceCashAndDeposits : null,
    jgaapInsuranceCallLoans: entity.jgaapInsuranceCallLoans !== undefined ? entity.jgaapInsuranceCallLoans : null,
    jgaapInsuranceMonetaryClaimsBought: entity.jgaapInsuranceMonetaryClaimsBought !== undefined ? entity.jgaapInsuranceMonetaryClaimsBought : null,
    jgaapInsuranceMoneyHeldInTrust: entity.jgaapInsuranceMoneyHeldInTrust !== undefined ? entity.jgaapInsuranceMoneyHeldInTrust : null,
    jgaapInsuranceSecurities: entity.jgaapInsuranceSecurities !== undefined ? entity.jgaapInsuranceSecurities : null,
    jgaapInsuranceLoans: entity.jgaapInsuranceLoans !== undefined ? entity.jgaapInsuranceLoans : null,
    jgaapInsuranceAgencyLoans: entity.jgaapInsuranceAgencyLoans !== undefined ? entity.jgaapInsuranceAgencyLoans : null,
    jgaapInsuranceReinsuranceReceivables: entity.jgaapInsuranceReinsuranceReceivables !== undefined ? entity.jgaapInsuranceReinsuranceReceivables : null,
    jgaapInsuranceDeferredAssetsUnderArticle113:
      entity.jgaapInsuranceDeferredAssetsUnderArticle113 !== undefined ? entity.jgaapInsuranceDeferredAssetsUnderArticle113 : null,
    jgaapInsuranceReserveForOutstandingClaims:
      entity.jgaapInsuranceReserveForOutstandingClaims !== undefined ? entity.jgaapInsuranceReserveForOutstandingClaims : null,
    jgaapInsurancePolicyReserves: entity.jgaapInsurancePolicyReserves !== undefined ? entity.jgaapInsurancePolicyReserves : null,
    jgaapInsuranceReserveForPolicyholderDividends:
      entity.jgaapInsuranceReserveForPolicyholderDividends !== undefined ? entity.jgaapInsuranceReserveForPolicyholderDividends : null,
    jgaapInsuranceReinsurancePayables: entity.jgaapInsuranceReinsurancePayables !== undefined ? entity.jgaapInsuranceReinsurancePayables : null,
    jgaapInsuranceReserveForPriceFluctuation:
      entity.jgaapInsuranceReserveForPriceFluctuation !== undefined ? entity.jgaapInsuranceReserveForPriceFluctuation : null,
    jgaapRealEstateRealEstateForSale: entity.jgaapRealEstateRealEstateForSale !== undefined ? entity.jgaapRealEstateRealEstateForSale : null,
    jgaapRealEstateRealEstateForSaleInProcess:
      entity.jgaapRealEstateRealEstateForSaleInProcess !== undefined ? entity.jgaapRealEstateRealEstateForSaleInProcess : null,
    jgaapShippingVessels: entity.jgaapShippingVessels !== undefined ? entity.jgaapShippingVessels : null,
    jgaapShippingDeferredShippingExpenses: entity.jgaapShippingDeferredShippingExpenses !== undefined ? entity.jgaapShippingDeferredShippingExpenses : null,
    jgaapShippingDeferredShippingRevenue: entity.jgaapShippingDeferredShippingRevenue !== undefined ? entity.jgaapShippingDeferredShippingRevenue : null,
    jgaapEpagFixedAssetsForEub: entity.jgaapEpagFixedAssetsForEub !== undefined ? entity.jgaapEpagFixedAssetsForEub : null,
    jgaapElectricPowerAndGasConstructionInProgress:
      entity.jgaapElectricPowerAndGasConstructionInProgress !== undefined ? entity.jgaapElectricPowerAndGasConstructionInProgress : null,
    jgaapElectricPowerAndGasNuclearFuel: entity.jgaapElectricPowerAndGasNuclearFuel !== undefined ? entity.jgaapElectricPowerAndGasNuclearFuel : null,
    jgaapEpagNfInReactorOfSpecificNpf: entity.jgaapEpagNfInReactorOfSpecificNpf !== undefined ? entity.jgaapEpagNfInReactorOfSpecificNpf : null,
    jgaapEpagReserveForSpecialDeprOfSpecificEquip:
      entity.jgaapEpagReserveForSpecialDeprOfSpecificEquip !== undefined ? entity.jgaapEpagReserveForSpecialDeprOfSpecificEquip : null,
    jgaapEpagReserveForFluctuationInWaterLevels:
      entity.jgaapEpagReserveForFluctuationInWaterLevels !== undefined ? entity.jgaapEpagReserveForFluctuationInWaterLevels : null,
    jgaapEpagReserveForDecommissioningOfNpu:
      entity.jgaapEpagReserveForDecommissioningOfNpu !== undefined ? entity.jgaapEpagReserveForDecommissioningOfNpu : null,
    jgaapEpagReserveForReprocessingOfIrradiatedNf:
      entity.jgaapEpagReserveForReprocessingOfIrradiatedNf !== undefined ? entity.jgaapEpagReserveForReprocessingOfIrradiatedNf : null,
    jgaapEpagReserveForDecommissioningOfSpecificNpf:
      entity.jgaapEpagReserveForDecommissioningOfSpecificNpf !== undefined ? entity.jgaapEpagReserveForDecommissioningOfSpecificNpf : null,
    jgaapLeasingLeaseInvestmentAssets: entity.jgaapLeasingLeaseInvestmentAssets !== undefined ? entity.jgaapLeasingLeaseInvestmentAssets : null,
    jgaapLeasingLeaseReceivables: entity.jgaapLeasingLeaseReceivables !== undefined ? entity.jgaapLeasingLeaseReceivables : null,
    jgaapLeasingAssetsForLease: entity.jgaapLeasingAssetsForLease !== undefined ? entity.jgaapLeasingAssetsForLease : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUsecaseTableCfFullToDomainModel = (entity: ProtoModel.UsecaseTableCfFull): DomainModel.UsecaseTableCfFull => {
  return {
    ...entity,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    accountingStandard: entity.accountingStandard !== undefined ? entity.accountingStandard : null,
    unit: entity.unit !== undefined ? entity.unit : null,
    unitText: entity.unitText !== undefined ? entity.unitText : null,
    highlightOperatingCfJpy: entity.highlightOperatingCfJpy !== undefined ? entity.highlightOperatingCfJpy : null,
    highlightInvestingCfJpy: entity.highlightInvestingCfJpy !== undefined ? entity.highlightInvestingCfJpy : null,
    highlightFinancingCfJpy: entity.highlightFinancingCfJpy !== undefined ? entity.highlightFinancingCfJpy : null,
    highlightCashEoyJpy: entity.highlightCashEoyJpy !== undefined ? entity.highlightCashEoyJpy : null,
    ifrsGeneralCashFlowsFromOperatingActivities:
      entity.ifrsGeneralCashFlowsFromOperatingActivities !== undefined ? entity.ifrsGeneralCashFlowsFromOperatingActivities : null,
    ifrsGeneralInterestPaid: entity.ifrsGeneralInterestPaid !== undefined ? entity.ifrsGeneralInterestPaid : null,
    ifrsGeneralInterestReceived: entity.ifrsGeneralInterestReceived !== undefined ? entity.ifrsGeneralInterestReceived : null,
    ifrsGeneralDividendsReceived: entity.ifrsGeneralDividendsReceived !== undefined ? entity.ifrsGeneralDividendsReceived : null,
    ifrsGeneralIncomeTaxesPaid: entity.ifrsGeneralIncomeTaxesPaid !== undefined ? entity.ifrsGeneralIncomeTaxesPaid : null,
    ifrsGeneralCashFlowsFromInvestingActivities:
      entity.ifrsGeneralCashFlowsFromInvestingActivities !== undefined ? entity.ifrsGeneralCashFlowsFromInvestingActivities : null,
    ifrsGeneralCashFlowsFromFinancingActivities:
      entity.ifrsGeneralCashFlowsFromFinancingActivities !== undefined ? entity.ifrsGeneralCashFlowsFromFinancingActivities : null,
    ifrsGeneralDividendsPaid: entity.ifrsGeneralDividendsPaid !== undefined ? entity.ifrsGeneralDividendsPaid : null,
    ifrsGeneralCceAtBeginningOfPeriod: entity.ifrsGeneralCceAtBeginningOfPeriod !== undefined ? entity.ifrsGeneralCceAtBeginningOfPeriod : null,
    ifrsGeneralCashAndCashEquivalentsAtTheEndOfThePeriod:
      entity.ifrsGeneralCashAndCashEquivalentsAtTheEndOfThePeriod !== undefined ? entity.ifrsGeneralCashAndCashEquivalentsAtTheEndOfThePeriod : null,
    jgaapGeneralCashFlowsFromOperatingActivities:
      entity.jgaapGeneralCashFlowsFromOperatingActivities !== undefined ? entity.jgaapGeneralCashFlowsFromOperatingActivities : null,
    jgaapGeneralCashFlowsFromInvestingActivities:
      entity.jgaapGeneralCashFlowsFromInvestingActivities !== undefined ? entity.jgaapGeneralCashFlowsFromInvestingActivities : null,
    jgaapGeneralCashFlowsFromFinancingActivities:
      entity.jgaapGeneralCashFlowsFromFinancingActivities !== undefined ? entity.jgaapGeneralCashFlowsFromFinancingActivities : null,
    jgaapGeneralEffectOfExchRateChangeOnCce:
      entity.jgaapGeneralEffectOfExchRateChangeOnCce !== undefined ? entity.jgaapGeneralEffectOfExchRateChangeOnCce : null,
    jgaapGeneralNetIncreaseDecreaseInCce: entity.jgaapGeneralNetIncreaseDecreaseInCce !== undefined ? entity.jgaapGeneralNetIncreaseDecreaseInCce : null,
    jgaapGeneralCashAndCashEquivalentsAtBeginningOfPeriod:
      entity.jgaapGeneralCashAndCashEquivalentsAtBeginningOfPeriod !== undefined ? entity.jgaapGeneralCashAndCashEquivalentsAtBeginningOfPeriod : null,
    jgaapGeneralCashAndCashEquivalentsAtEndOfPeriod:
      entity.jgaapGeneralCashAndCashEquivalentsAtEndOfPeriod !== undefined ? entity.jgaapGeneralCashAndCashEquivalentsAtEndOfPeriod : null,
    jgaapGeneralPurchasePpe: entity.jgaapGeneralPurchasePpe !== undefined ? entity.jgaapGeneralPurchasePpe : null,
    jgaapGeneralPurchaseIntangible: entity.jgaapGeneralPurchaseIntangible !== undefined ? entity.jgaapGeneralPurchaseIntangible : null,
    jgaapGeneralDividendsPaid: entity.jgaapGeneralDividendsPaid !== undefined ? entity.jgaapGeneralDividendsPaid : null,

    columnMissingReason:
      entity.columnMissingReason !== undefined
        ? (() => {
            if (!entity.columnMissingReason) throw new Error('Struct is null')
            const result = entity.columnMissingReason.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertUserToDomainModel = (entity: ProtoModel.User): DomainModel.User => {
  return {
    ...entity,

    createdAt: new Date(entity.createdAt),
  }
}

export const convertUserAnalysisThreadToDomainModel = (entity: ProtoModel.UserAnalysisThread): DomainModel.UserAnalysisThread => {
  return {
    ...entity,
    description: entity.description !== undefined ? entity.description : null,

    createdAt: new Date(entity.createdAt),
    updatedAt: new Date(entity.updatedAt),
  }
}

export const convertUserAnalysisThreadMessageStatusEnumToDomainModel = (
  enumValue: ProtoModel.UserAnalysisThreadMessage_Status,
): DomainModel.UserAnalysisThreadMessage['status'] => {
  switch (enumValue) {
    case ProtoModel.UserAnalysisThreadMessage_Status.PENDING:
      return 'pending'
    case ProtoModel.UserAnalysisThreadMessage_Status.PROCESSING:
      return 'processing'
    case ProtoModel.UserAnalysisThreadMessage_Status.COMPLETED:
      return 'completed'
    case ProtoModel.UserAnalysisThreadMessage_Status.FAILED:
      return 'failed'
    case ProtoModel.UserAnalysisThreadMessage_Status._UNSPECIFIED_STATUS:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertUserAnalysisThreadMessageContentTypeEnumToDomainModel = (
  enumValue: ProtoModel.UserAnalysisThreadMessage_ContentType,
): DomainModel.UserAnalysisThreadMessage['contentType'] => {
  switch (enumValue) {
    case ProtoModel.UserAnalysisThreadMessage_ContentType.COMPANY_OVERVIEW:
      return 'companyOverview'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.PL_HIGHLIGHT:
      return 'plHighlight'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.BS_HIGHLIGHT:
      return 'bsHighlight'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.CF_HIGHLIGHT:
      return 'cfHighlight'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.EXECUTIVES:
      return 'executives'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.EXECUTIVE_COMPENSATION:
      return 'executiveCompensation'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.BUSINESS_DESCRIPTION:
      return 'businessDescription'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.BUSINESS_RISKS:
      return 'businessRisks'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.HISTORY:
      return 'history'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.MAJOR_SUBSIDIARIES:
      return 'majorSubsidiaries'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.OFFICES:
      return 'offices'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.MAJOR_SHAREHOLDERS:
      return 'majorShareholders'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.USER_PROMPT:
      return 'userPrompt'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.ASSISTANT:
      return 'assistant'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.SUMMARY:
      return 'summary'
    case ProtoModel.UserAnalysisThreadMessage_ContentType.SECURITIES_REPORT_ANALYSIS:
      return 'securitiesReportAnalysis'
    case ProtoModel.UserAnalysisThreadMessage_ContentType._UNSPECIFIED_CONTENT_TYPE:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertUserAnalysisThreadMessageToDomainModel = (entity: ProtoModel.UserAnalysisThreadMessage): DomainModel.UserAnalysisThreadMessage => {
  return {
    ...entity,
    errorMessage: entity.errorMessage !== undefined ? entity.errorMessage : null,

    status: convertUserAnalysisThreadMessageStatusEnumToDomainModel(entity.status),
    contentType: convertUserAnalysisThreadMessageContentTypeEnumToDomainModel(entity.contentType),
    createdAt: new Date(entity.createdAt),
    updatedAt: new Date(entity.updatedAt),
    content: (() => {
      if (!entity.content) throw new Error('Struct is null')
      return changeKeysToCamelCaseRecursively(entity.content.toJson() as any)
    })(),
  }
}

export const convertCompanyAvailabilityToDomainModel = (entity: ProtoModel.CompanyAvailability): DomainModel.CompanyAvailability => {
  return {
    ...entity,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
  }
}

export const convertSecuritiesReportChunkToDomainModel = (entity: ProtoModel.SecuritiesReportChunk): DomainModel.SecuritiesReportChunk => {
  return {
    ...entity,
    secCode: entity.secCode !== undefined ? entity.secCode : null,
    docDescription: entity.docDescription !== undefined ? entity.docDescription : null,
    periodStart: entity.periodStart !== undefined ? entity.periodStart : null,
    periodEnd: entity.periodEnd !== undefined ? entity.periodEnd : null,
    fiscalPeriodEndYear: entity.fiscalPeriodEndYear !== undefined ? entity.fiscalPeriodEndYear : null,
    fiscalPeriodEndMonth: entity.fiscalPeriodEndMonth !== undefined ? entity.fiscalPeriodEndMonth : null,
    docTypeCode: entity.docTypeCode !== undefined ? entity.docTypeCode : null,
    filerName: entity.filerName !== undefined ? entity.filerName : null,
    ordinanceCode: entity.ordinanceCode !== undefined ? entity.ordinanceCode : null,
    formCode: entity.formCode !== undefined ? entity.formCode : null,
    errorMessage: entity.errorMessage !== undefined ? entity.errorMessage : null,
    chunkIndex: entity.chunkIndex !== undefined ? entity.chunkIndex : null,
    layer: entity.layer !== undefined ? entity.layer : null,
    parentChunkId: entity.parentChunkId !== undefined ? entity.parentChunkId : null,

    creationTime: new Date(entity.creationTime),
  }
}

export const convertAiChatSessionToDomainModel = (entity: ProtoModel.AiChatSession): DomainModel.AiChatSession => {
  return {
    ...entity,
    description: entity.description !== undefined ? entity.description : null,

    createdAt: new Date(entity.createdAt),
    updatedAt: new Date(entity.updatedAt),
  }
}

export const convertAiChatEventEventTypeEnumToDomainModel = (enumValue: ProtoModel.AiChatEvent_EventType): DomainModel.AiChatEvent['eventType'] => {
  switch (enumValue) {
    case ProtoModel.AiChatEvent_EventType.USER_MESSAGE:
      return 'userMessage'
    case ProtoModel.AiChatEvent_EventType.ASSISTANT_MESSAGE:
      return 'assistantMessage'
    case ProtoModel.AiChatEvent_EventType.SERVER_SIDE_TOOL_CALL:
      return 'serverSideToolCall'
    case ProtoModel.AiChatEvent_EventType.CLIENT_INFO:
      return 'clientInfo'
    case ProtoModel.AiChatEvent_EventType.CLIENT_ACTION:
      return 'clientAction'
    case ProtoModel.AiChatEvent_EventType.ERROR:
      return 'error'
    case ProtoModel.AiChatEvent_EventType._UNSPECIFIED_EVENT_TYPE:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertAiChatEventPayloadJsonStatusEnumToDomainModel = (
  enumValue: ProtoModel.AiChatEvent_PayloadJsonStatus,
): DomainModel.AiChatEvent['payloadJsonStatus'] => {
  switch (enumValue) {
    case ProtoModel.AiChatEvent_PayloadJsonStatus.GENERATING:
      return 'generating'
    case ProtoModel.AiChatEvent_PayloadJsonStatus.COMPLETED:
      return 'completed'
    case ProtoModel.AiChatEvent_PayloadJsonStatus._UNSPECIFIED_PAYLOAD_JSON_STATUS:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertAiChatEventToDomainModel = (entity: ProtoModel.AiChatEvent): DomainModel.AiChatEvent => {
  return {
    ...entity,

    eventType: convertAiChatEventEventTypeEnumToDomainModel(entity.eventType),
    payloadJsonStatus: convertAiChatEventPayloadJsonStatusEnumToDomainModel(entity.payloadJsonStatus),
    createdAt: new Date(entity.createdAt),
    payload: (() => {
      if (!entity.payload) throw new Error('Struct is null')
      return changeKeysToCamelCaseRecursively(entity.payload.toJson() as any)
    })(),
  }
}

export const convertNikkeiNeedsIndustryLargeToDomainModel = (entity: ProtoModel.NikkeiNeedsIndustryLarge): DomainModel.NikkeiNeedsIndustryLarge => {
  return {
    ...entity,
  }
}

export const convertNikkeiNeedsIndustryMediumToDomainModel = (entity: ProtoModel.NikkeiNeedsIndustryMedium): DomainModel.NikkeiNeedsIndustryMedium => {
  return {
    ...entity,
  }
}

export const convertNikkeiNeedsIndustrySmallToDomainModel = (entity: ProtoModel.NikkeiNeedsIndustrySmall): DomainModel.NikkeiNeedsIndustrySmall => {
  return {
    ...entity,
  }
}

export const convertCompanyToDomainModel = (entity: ProtoModel.Company): DomainModel.Company => {
  return {
    ...entity,
    edinetCode: entity.edinetCode !== undefined ? entity.edinetCode : null,
    englishName: entity.englishName !== undefined ? entity.englishName : null,
    cooperateSiteNewsPageUrl: entity.cooperateSiteNewsPageUrl !== undefined ? entity.cooperateSiteNewsPageUrl : null,
    industry33Name: entity.industry33Name !== undefined ? entity.industry33Name : null,
    industry17Name: entity.industry17Name !== undefined ? entity.industry17Name : null,
    description: entity.description !== undefined ? entity.description : null,
  }
}

export const convertCompanyNikkeiNeedsIndustrySmallAssignmentToDomainModel = (
  entity: ProtoModel.CompanyNikkeiNeedsIndustrySmallAssignment,
): DomainModel.CompanyNikkeiNeedsIndustrySmallAssignment => {
  return {
    ...entity,
  }
}

export const convertCompanyFiscalPeriodToDomainModel = (entity: ProtoModel.CompanyFiscalPeriod): DomainModel.CompanyFiscalPeriod => {
  return {
    ...entity,

    startAt: new Date(entity.startAt),
    endAt: new Date(entity.endAt),
  }
}

export const convertIrDataSourceDocumentTypeEnumToDomainModel = (enumValue: ProtoModel.IrDataSource_DocumentType): DomainModel.IrDataSource['documentType'] => {
  switch (enumValue) {
    case ProtoModel.IrDataSource_DocumentType.SECURITIES_REPORT:
      return 'securitiesReport'
    case ProtoModel.IrDataSource_DocumentType.FINANCIAL_RESULTS_PRESENTATION:
      return 'financialResultsPresentation'
    case ProtoModel.IrDataSource_DocumentType._UNSPECIFIED_DOCUMENT_TYPE:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertIrDataSourceToDomainModel = (entity: ProtoModel.IrDataSource): DomainModel.IrDataSource => {
  return {
    ...entity,
    edinetDocumentId: entity.edinetDocumentId !== undefined ? entity.edinetDocumentId : null,

    documentType: convertIrDataSourceDocumentTypeEnumToDomainModel(entity.documentType),
    issuedAt: entity.issuedAt ? new Date(entity.issuedAt) : null,
  }
}

export const convertIrDataSourceFragmentToDomainModel = (entity: ProtoModel.IrDataSourceFragment): DomainModel.IrDataSourceFragment => {
  return {
    ...entity,
    extractedContent: entity.extractedContent !== undefined ? entity.extractedContent : null,
  }
}

export const convertReportableSegmentToDomainModel = (entity: ProtoModel.ReportableSegment): DomainModel.ReportableSegment => {
  return {
    ...entity,
    companyFiscalPeriodId: entity.companyFiscalPeriodId !== undefined ? entity.companyFiscalPeriodId : null,
    extractedIrDataSourceId: entity.extractedIrDataSourceId !== undefined ? entity.extractedIrDataSourceId : null,
    irDataSourceFragmentExtractionId: entity.irDataSourceFragmentExtractionId !== undefined ? entity.irDataSourceFragmentExtractionId : null,
  }
}

export const convertFinancialIndicatorTargetTypeEnumToDomainModel = (
  enumValue: ProtoModel.FinancialIndicator_TargetType,
): DomainModel.FinancialIndicator['targetType'] => {
  switch (enumValue) {
    case ProtoModel.FinancialIndicator_TargetType.COMPANY:
      return 'company'
    case ProtoModel.FinancialIndicator_TargetType.REPORTABLE_SEGMENT:
      return 'reportableSegment'
    case ProtoModel.FinancialIndicator_TargetType._UNSPECIFIED_TARGET_TYPE:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertFinancialIndicatorIndicatorTypeEnumToDomainModel = (
  enumValue: ProtoModel.FinancialIndicator_IndicatorType,
): DomainModel.FinancialIndicator['indicatorType'] => {
  switch (enumValue) {
    case ProtoModel.FinancialIndicator_IndicatorType.GROSS_SALES:
      return 'grossSales'
    case ProtoModel.FinancialIndicator_IndicatorType.GROSS_PROFIT:
      return 'grossProfit'
    case ProtoModel.FinancialIndicator_IndicatorType.OPERATING_PROFIT:
      return 'operatingProfit'
    case ProtoModel.FinancialIndicator_IndicatorType.MANAGEMENT_PROFIT:
      return 'managementProfit'
    case ProtoModel.FinancialIndicator_IndicatorType.PRE_TAX_PROFIT:
      return 'preTaxProfit'
    case ProtoModel.FinancialIndicator_IndicatorType.NET_INCOME:
      return 'netIncome'
    case ProtoModel.FinancialIndicator_IndicatorType._UNSPECIFIED_INDICATOR_TYPE:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertFinancialIndicatorCurrencyEnumToDomainModel = (
  enumValue: ProtoModel.FinancialIndicator_Currency,
): DomainModel.FinancialIndicator['currency'] => {
  switch (enumValue) {
    case ProtoModel.FinancialIndicator_Currency.JPY:
      return 'jpy'
    case ProtoModel.FinancialIndicator_Currency.USD:
      return 'usd'
    case ProtoModel.FinancialIndicator_Currency._UNSPECIFIED_CURRENCY:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertFinancialIndicatorUnitEnumToDomainModel = (enumValue: ProtoModel.FinancialIndicator_Unit): DomainModel.FinancialIndicator['unit'] => {
  switch (enumValue) {
    case ProtoModel.FinancialIndicator_Unit.ONE:
      return 'one'
    case ProtoModel.FinancialIndicator_Unit.THOUSAND:
      return 'thousand'
    case ProtoModel.FinancialIndicator_Unit.MILLION:
      return 'million'
    case ProtoModel.FinancialIndicator_Unit.BILLION:
      return 'billion'
    case ProtoModel.FinancialIndicator_Unit._UNSPECIFIED_UNIT:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertFinancialIndicatorToDomainModel = (entity: ProtoModel.FinancialIndicator): DomainModel.FinancialIndicator => {
  return {
    ...entity,
    reportableSegmentId: entity.reportableSegmentId !== undefined ? entity.reportableSegmentId : null,
    extractedIrDataSourceId: entity.extractedIrDataSourceId !== undefined ? entity.extractedIrDataSourceId : null,
    irDataSourceFragmentExtractionId: entity.irDataSourceFragmentExtractionId !== undefined ? entity.irDataSourceFragmentExtractionId : null,
    yoyChangePercentage: entity.yoyChangePercentage !== undefined ? entity.yoyChangePercentage : null,

    targetType: convertFinancialIndicatorTargetTypeEnumToDomainModel(entity.targetType),
    indicatorType: convertFinancialIndicatorIndicatorTypeEnumToDomainModel(entity.indicatorType),
    currency: convertFinancialIndicatorCurrencyEnumToDomainModel(entity.currency),
    unit: convertFinancialIndicatorUnitEnumToDomainModel(entity.unit),
  }
}

export const convertUserAnalysisQueryToDomainModel = (entity: ProtoModel.UserAnalysisQuery): DomainModel.UserAnalysisQuery => {
  return {
    ...entity,

    requestedAt: new Date(entity.requestedAt),

    summaryAnalysisResultCache:
      entity.summaryAnalysisResultCache !== undefined
        ? (() => {
            if (!entity.summaryAnalysisResultCache) throw new Error('Struct is null')
            const result = entity.summaryAnalysisResultCache.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
    analysisResultWidetsCache:
      entity.analysisResultWidetsCache !== undefined
        ? (() => {
            if (!entity.analysisResultWidetsCache) throw new Error('Struct is null')
            const result = entity.analysisResultWidetsCache.toJson()
            if (result == null) throw new Error('toJson() returned null')
            return changeKeysToCamelCaseRecursively(result) as object
          })()
        : null,
  }
}

export const convertFinancialIndicatorFactorToDomainModel = (entity: ProtoModel.FinancialIndicatorFactor): DomainModel.FinancialIndicatorFactor => {
  return {
    ...entity,
    irDataSourceFragmentExtractionId: entity.irDataSourceFragmentExtractionId !== undefined ? entity.irDataSourceFragmentExtractionId : null,
  }
}

export const convertReportableSegmentCompanyFiscalPeriodAppearanceToDomainModel = (
  entity: ProtoModel.ReportableSegmentCompanyFiscalPeriodAppearance,
): DomainModel.ReportableSegmentCompanyFiscalPeriodAppearance => {
  return {
    ...entity,
  }
}

export const convertMediumTermManagementPlanToDomainModel = (entity: ProtoModel.MediumTermManagementPlan): DomainModel.MediumTermManagementPlan => {
  return {
    ...entity,
    startFiscalYear: entity.startFiscalYear !== undefined ? entity.startFiscalYear : null,
    endFiscalYear: entity.endFiscalYear !== undefined ? entity.endFiscalYear : null,
  }
}

export const convertMediumTermManagementPlanObjectiveToDomainModel = (
  entity: ProtoModel.MediumTermManagementPlanObjective,
): DomainModel.MediumTermManagementPlanObjective => {
  return {
    ...entity,
  }
}

export const convertMediumTermManagementPlanFocusPointToDomainModel = (
  entity: ProtoModel.MediumTermManagementPlanFocusPoint,
): DomainModel.MediumTermManagementPlanFocusPoint => {
  return {
    ...entity,
  }
}

export const convertMediumTermManagementPlanFocusPointCaseToDomainModel = (
  entity: ProtoModel.MediumTermManagementPlanFocusPointCase,
): DomainModel.MediumTermManagementPlanFocusPointCase => {
  return {
    ...entity,
  }
}

export const convertIrDataSourceFragmentExtractionExtractedFactTypeEnumToDomainModel = (
  enumValue: ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType,
): DomainModel.IrDataSourceFragmentExtraction['extractedFactType'] => {
  switch (enumValue) {
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.REPORTABLE_SEGMENT:
      return 'reportableSegment'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.REPORTABLE_SEGMENT_COMPANY_FISCAL_PERIOD_APPEARANCE:
      return 'reportableSegmentCompanyFiscalPeriodAppearance'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.FINANCIAL_INDICATOR:
      return 'financialIndicator'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.FINANCIAL_INDICATOR_FACTOR:
      return 'financialIndicatorFactor'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.MEDIUM_TERM_MANAGEMENT_PLAN:
      return 'mediumTermManagementPlan'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.MEDIUM_TERM_MANAGEMENT_PLAN_OBJECTIVE:
      return 'mediumTermManagementPlanObjective'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT:
      return 'mediumTermManagementPlanFocusPoint'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType.MEDIUM_TERM_MANAGEMENT_PLAN_FOCUS_POINT_CASE:
      return 'mediumTermManagementPlanFocusPointCase'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractedFactType._UNSPECIFIED_EXTRACTED_FACT_TYPE:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertIrDataSourceFragmentExtractionExtractionMethodEnumToDomainModel = (
  enumValue: ProtoModel.IrDataSourceFragmentExtraction_ExtractionMethod,
): DomainModel.IrDataSourceFragmentExtraction['extractionMethod'] => {
  switch (enumValue) {
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractionMethod.VISION_LLM:
      return 'visionLlm'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractionMethod.PARSE_XBRL:
      return 'parseXbrl'
    case ProtoModel.IrDataSourceFragmentExtraction_ExtractionMethod._UNSPECIFIED_EXTRACTION_METHOD:
      throw new Error(`unspecified enum value ${enumValue}`)
    default:
      assertNever(enumValue)
      throw new Error(`unsupported enum value ${enumValue}`)
  }
}
export const convertIrDataSourceFragmentExtractionToDomainModel = (
  entity: ProtoModel.IrDataSourceFragmentExtraction,
): DomainModel.IrDataSourceFragmentExtraction => {
  return {
    ...entity,
    model: entity.model !== undefined ? entity.model : null,

    extractedFactType: convertIrDataSourceFragmentExtractionExtractedFactTypeEnumToDomainModel(entity.extractedFactType),
    extractionMethod: convertIrDataSourceFragmentExtractionExtractionMethodEnumToDomainModel(entity.extractionMethod),
    extractedAt: new Date(entity.extractedAt),
  }
}

export const convertPressReleaseToDomainModel = (entity: ProtoModel.PressRelease): DomainModel.PressRelease => {
  return {
    ...entity,

    releasedAt: new Date(entity.releasedAt),
  }
}
